var Oa = Object.defineProperty;
var Aa = (e, t, s) => t in e ? Oa(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var Ms = (e, t, s) => Aa(e, typeof t != "symbol" ? t + "" : t, s);
function mt() {
}
function nn(e, t) {
  for (const s in t) e[s] = t[s];
  return (
    /** @type {T & S} */
    e
  );
}
function Ei(e) {
  return e();
}
function on() {
  return /* @__PURE__ */ Object.create(null);
}
function $e(e) {
  e.forEach(Ei);
}
function ki(e) {
  return typeof e == "function";
}
function Tr(e, t) {
  return e != e ? t == t : e !== t || e && typeof e == "object" || typeof e == "function";
}
function Ia(e) {
  return Object.keys(e).length === 0;
}
function an(e) {
  const t = {};
  for (const s in e) s[0] !== "$" && (t[s] = e[s]);
  return t;
}
function L(e, t) {
  e.appendChild(t);
}
function Me(e, t, s) {
  e.insertBefore(t, s || null);
}
function xe(e) {
  e.parentNode && e.parentNode.removeChild(e);
}
function Ns(e, t) {
  for (let s = 0; s < e.length; s += 1)
    e[s] && e[s].d(t);
}
function te(e) {
  return document.createElement(e);
}
function es(e) {
  return document.createElementNS("http://www.w3.org/2000/svg", e);
}
function Ie(e) {
  return document.createTextNode(e);
}
function ue() {
  return Ie(" ");
}
function Pa() {
  return Ie("");
}
function We(e, t, s, r) {
  return e.addEventListener(t, s, r), () => e.removeEventListener(t, s, r);
}
function N(e, t, s) {
  s == null ? e.removeAttribute(t) : e.getAttribute(t) !== s && e.setAttribute(t, s);
}
function _a(e) {
  return Array.from(e.childNodes);
}
function ts(e, t) {
  t = "" + t, e.data !== t && (e.data = /** @type {string} */
  t);
}
function K(e, t, s, r) {
  s == null ? e.style.removeProperty(t) : e.style.setProperty(t, s, "");
}
function Ge(e, t, s) {
  e.classList.toggle(t, !!s);
}
function Fa(e, t, { bubbles: s = !1, cancelable: r = !1 } = {}) {
  return new CustomEvent(e, { detail: t, bubbles: s, cancelable: r });
}
let gt;
function pt(e) {
  gt = e;
}
function fs() {
  if (!gt) throw new Error("Function called outside component initialization");
  return gt;
}
function Mi(e) {
  fs().$$.on_mount.push(e);
}
function La(e) {
  fs().$$.after_update.push(e);
}
function Ni(e) {
  fs().$$.on_destroy.push(e);
}
function Ua() {
  const e = fs();
  return (t, s, { cancelable: r = !1 } = {}) => {
    const n = e.$$.callbacks[t];
    if (n) {
      const o = Fa(
        /** @type {string} */
        t,
        s,
        { cancelable: r }
      );
      return n.slice().forEach((a) => {
        a.call(e, o);
      }), !o.defaultPrevented;
    }
    return !0;
  };
}
const Ue = [], Ae = [];
let Ye = [];
const Ws = [], Ba = /* @__PURE__ */ Promise.resolve();
let Vs = !1;
function za() {
  Vs || (Vs = !0, Ba.then(Ti));
}
function Ys(e) {
  Ye.push(e);
}
function ja(e) {
  Ws.push(e);
}
const Ts = /* @__PURE__ */ new Set();
let Fe = 0;
function Ti() {
  if (Fe !== 0)
    return;
  const e = gt;
  do {
    try {
      for (; Fe < Ue.length; ) {
        const t = Ue[Fe];
        Fe++, pt(t), Wa(t.$$);
      }
    } catch (t) {
      throw Ue.length = 0, Fe = 0, t;
    }
    for (pt(null), Ue.length = 0, Fe = 0; Ae.length; ) Ae.pop()();
    for (let t = 0; t < Ye.length; t += 1) {
      const s = Ye[t];
      Ts.has(s) || (Ts.add(s), s());
    }
    Ye.length = 0;
  } while (Ue.length);
  for (; Ws.length; )
    Ws.pop()();
  Vs = !1, Ts.clear(), pt(e);
}
function Wa(e) {
  if (e.fragment !== null) {
    e.update(), $e(e.before_update);
    const t = e.dirty;
    e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(Ys);
  }
}
function Va(e) {
  const t = [], s = [];
  Ye.forEach((r) => e.indexOf(r) === -1 ? t.push(r) : s.push(r)), s.forEach((r) => r()), Ye = t;
}
const Jt = /* @__PURE__ */ new Set();
let Oe;
function Di() {
  Oe = {
    r: 0,
    c: [],
    p: Oe
    // parent group
  };
}
function Ri() {
  Oe.r || $e(Oe.c), Oe = Oe.p;
}
function Ce(e, t) {
  e && e.i && (Jt.delete(e), e.i(t));
}
function Ze(e, t, s, r) {
  if (e && e.o) {
    if (Jt.has(e)) return;
    Jt.add(e), Oe.c.push(() => {
      Jt.delete(e), r && (s && e.d(1), r());
    }), e.o(t);
  } else r && r();
}
function Le(e) {
  return (e == null ? void 0 : e.length) !== void 0 ? e : Array.from(e);
}
function Ya(e, t, s) {
  const r = e.$$.props[t];
  r !== void 0 && (e.$$.bound[r] = s, s(e.$$.ctx[r]));
}
function Oi(e) {
  e && e.c();
}
function Dr(e, t, s) {
  const { fragment: r, after_update: n } = e.$$;
  r && r.m(t, s), Ys(() => {
    const o = e.$$.on_mount.map(Ei).filter(ki);
    e.$$.on_destroy ? e.$$.on_destroy.push(...o) : $e(o), e.$$.on_mount = [];
  }), n.forEach(Ys);
}
function Rr(e, t) {
  const s = e.$$;
  s.fragment !== null && (Va(s.after_update), $e(s.on_destroy), s.fragment && s.fragment.d(t), s.on_destroy = s.fragment = null, s.ctx = []);
}
function Ga(e, t) {
  e.$$.dirty[0] === -1 && (Ue.push(e), za(), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function Or(e, t, s, r, n, o, a = null, i = [-1]) {
  const l = gt;
  pt(e);
  const c = e.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: o,
    update: mt,
    not_equal: n,
    bound: on(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(t.context || (l ? l.$$.context : [])),
    // everything else
    callbacks: on(),
    dirty: i,
    skip_bound: !1,
    root: t.target || l.$$.root
  };
  a && a(c.root);
  let u = !1;
  if (c.ctx = s ? s(e, t.props || {}, (h, p, ...y) => {
    const g = y.length ? y[0] : p;
    return c.ctx && n(c.ctx[h], c.ctx[h] = g) && (!c.skip_bound && c.bound[h] && c.bound[h](g), u && Ga(e, h)), p;
  }) : [], c.update(), u = !0, $e(c.before_update), c.fragment = r ? r(c.ctx) : !1, t.target) {
    if (t.hydrate) {
      const h = _a(t.target);
      c.fragment && c.fragment.l(h), h.forEach(xe);
    } else
      c.fragment && c.fragment.c();
    t.intro && Ce(e.$$.fragment), Dr(e, t.target, t.anchor), Ti();
  }
  pt(l);
}
class Ar {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    Ms(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    Ms(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    Rr(this, 1), this.$destroy = mt;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(t, s) {
    if (!ki(s))
      return mt;
    const r = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return r.push(s), () => {
      const n = r.indexOf(s);
      n !== -1 && r.splice(n, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(t) {
    this.$$set && !Ia(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  }
}
const Za = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Za);
var he = Uint8Array, Te = Uint16Array, Gs = Uint32Array, Ai = new he([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), Ii = new he([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), Xa = new he([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Pi = function(e, t) {
  for (var s = new Te(31), r = 0; r < 31; ++r)
    s[r] = t += 1 << e[r - 1];
  for (var n = new Gs(s[30]), r = 1; r < 30; ++r)
    for (var o = s[r]; o < s[r + 1]; ++o)
      n[o] = o - s[r] << 5 | r;
  return [s, n];
}, _i = Pi(Ai, 2), Fi = _i[0], Ha = _i[1];
Fi[28] = 258, Ha[258] = 28;
var Ja = Pi(Ii, 0), Qa = Ja[0], Zs = new Te(32768);
for (var Z = 0; Z < 32768; ++Z) {
  var Ne = (Z & 43690) >>> 1 | (Z & 21845) << 1;
  Ne = (Ne & 52428) >>> 2 | (Ne & 13107) << 2, Ne = (Ne & 61680) >>> 4 | (Ne & 3855) << 4, Zs[Z] = ((Ne & 65280) >>> 8 | (Ne & 255) << 8) >>> 1;
}
var dt = function(e, t, s) {
  for (var r = e.length, n = 0, o = new Te(t); n < r; ++n)
    ++o[e[n] - 1];
  var a = new Te(t);
  for (n = 0; n < t; ++n)
    a[n] = a[n - 1] + o[n - 1] << 1;
  var i;
  if (s) {
    i = new Te(1 << t);
    var l = 15 - t;
    for (n = 0; n < r; ++n)
      if (e[n])
        for (var c = n << 4 | e[n], u = t - e[n], h = a[e[n] - 1]++ << u, p = h | (1 << u) - 1; h <= p; ++h)
          i[Zs[h] >>> l] = c;
  } else
    for (i = new Te(r), n = 0; n < r; ++n)
      i[n] = Zs[a[e[n] - 1]++] >>> 15 - e[n];
  return i;
}, kt = new he(288);
for (var Z = 0; Z < 144; ++Z)
  kt[Z] = 8;
for (var Z = 144; Z < 256; ++Z)
  kt[Z] = 9;
for (var Z = 256; Z < 280; ++Z)
  kt[Z] = 7;
for (var Z = 280; Z < 288; ++Z)
  kt[Z] = 8;
var Li = new he(32);
for (var Z = 0; Z < 32; ++Z)
  Li[Z] = 5;
var Ka = /* @__PURE__ */ dt(kt, 9, 1), qa = /* @__PURE__ */ dt(Li, 5, 1), Ds = function(e) {
  for (var t = e[0], s = 1; s < e.length; ++s)
    e[s] > t && (t = e[s]);
  return t;
}, de = function(e, t, s) {
  var r = t / 8 >> 0;
  return (e[r] | e[r + 1] << 8) >>> (t & 7) & s;
}, Rs = function(e, t) {
  var s = t / 8 >> 0;
  return (e[s] | e[s + 1] << 8 | e[s + 2] << 16) >>> (t & 7);
}, $a = function(e) {
  return (e / 8 >> 0) + (e & 7 && 1);
}, Ui = function(e, t, s) {
  (s == null || s > e.length) && (s = e.length);
  var r = new (e instanceof Te ? Te : e instanceof Gs ? Gs : he)(s - t);
  return r.set(e.subarray(t, s)), r;
}, el = function(e, t, s) {
  var r = e.length, n = !t || s, o = !s || s.i;
  s || (s = {}), t || (t = new he(r * 3));
  var a = function(T) {
    var m = t.length;
    if (T > m) {
      var I = new he(Math.max(m * 2, T));
      I.set(t), t = I;
    }
  }, i = s.f || 0, l = s.p || 0, c = s.b || 0, u = s.l, h = s.d, p = s.m, y = s.n, g = r * 8;
  do {
    if (!u) {
      s.f = i = de(e, l, 1);
      var d = de(e, l + 1, 3);
      if (l += 3, d)
        if (d == 1)
          u = Ka, h = qa, p = 9, y = 5;
        else if (d == 2) {
          var S = de(e, l, 31) + 257, f = de(e, l + 10, 15) + 4, v = S + de(e, l + 5, 31) + 1;
          l += 14;
          for (var w = new he(v), k = new he(19), E = 0; E < f; ++E)
            k[Xa[E]] = de(e, l + E * 3, 7);
          l += f * 3;
          var A = Ds(k), _ = (1 << A) - 1;
          if (!o && l + v * (A + 7) > g)
            break;
          for (var Y = dt(k, A, 1), E = 0; E < v; ) {
            var q = Y[de(e, l, _)];
            l += q & 15;
            var j = q >>> 4;
            if (j < 16)
              w[E++] = j;
            else {
              var se = 0, oe = 0;
              for (j == 16 ? (oe = 3 + de(e, l, 3), l += 2, se = w[E - 1]) : j == 17 ? (oe = 3 + de(e, l, 7), l += 3) : j == 18 && (oe = 11 + de(e, l, 127), l += 7); oe--; )
                w[E++] = se;
            }
          }
          var re = w.subarray(0, S), P = w.subarray(S);
          p = Ds(re), y = Ds(P), u = dt(re, p, 1), h = dt(P, y, 1);
        } else
          throw "invalid block type";
      else {
        var j = $a(l) + 4, ne = e[j - 4] | e[j - 3] << 8, V = j + ne;
        if (V > r) {
          if (o)
            throw "unexpected EOF";
          break;
        }
        n && a(c + ne), t.set(e.subarray(j, V), c), s.b = c += ne, s.p = l = V * 8;
        continue;
      }
      if (l > g)
        throw "unexpected EOF";
    }
    n && a(c + 131072);
    for (var G = (1 << p) - 1, ae = (1 << y) - 1, ie = p + y + 18; o || l + ie < g; ) {
      var se = u[Rs(e, l) & G], $ = se >>> 4;
      if (l += se & 15, l > g)
        throw "unexpected EOF";
      if (!se)
        throw "invalid length/literal";
      if ($ < 256)
        t[c++] = $;
      else if ($ == 256) {
        u = null;
        break;
      } else {
        var J = $ - 254;
        if ($ > 264) {
          var E = $ - 257, pe = Ai[E];
          J = de(e, l, (1 << pe) - 1) + Fi[E], l += pe;
        }
        var ge = h[Rs(e, l) & ae], x = ge >>> 4;
        if (!ge)
          throw "invalid distance";
        l += ge & 15;
        var P = Qa[x];
        if (x > 3) {
          var pe = Ii[x];
          P += Rs(e, l) & (1 << pe) - 1, l += pe;
        }
        if (l > g)
          throw "unexpected EOF";
        n && a(c + 131072);
        for (var b = c + J; c < b; c += 4)
          t[c] = t[c - P], t[c + 1] = t[c + 1 - P], t[c + 2] = t[c + 2 - P], t[c + 3] = t[c + 3 - P];
        c = b;
      }
    }
    s.l = u, s.p = l, s.b = c, u && (i = 1, s.m = p, s.d = h, s.n = y);
  } while (!i);
  return c == t.length ? t : Ui(t, 0, c);
}, tl = function(e) {
  if ((e[0] & 15) != 8 || e[0] >>> 4 > 7 || (e[0] << 8 | e[1]) % 31)
    throw "invalid zlib data";
  if (e[1] & 32)
    throw "invalid zlib data: preset dictionaries not supported";
};
function sl(e, t) {
  return el((tl(e), e.subarray(2, -4)), t);
}
function rl(e, t) {
  for (var s = e.length, r = new he(e.length + (e.length >>> 1)), n = 0, o = function(c) {
    r[n++] = c;
  }, a = 0; a < s; ++a) {
    if (n + 5 > r.length) {
      var i = new he(n + 8 + (s - a << 1));
      i.set(r), r = i;
    }
    var l = e.charCodeAt(a);
    o(l);
  }
  return Ui(r, 0, n);
}
function nl(e, t) {
  var s = "";
  if (typeof TextDecoder < "u")
    return new TextDecoder().decode(e);
  for (var r = 0; r < e.length; ) {
    var n = e[r++];
    n < 128 || t ? s += String.fromCharCode(n) : n < 224 ? s += String.fromCharCode((n & 31) << 6 | e[r++] & 63) : n < 240 ? s += String.fromCharCode((n & 15) << 12 | (e[r++] & 63) << 6 | e[r++] & 63) : (n = ((n & 15) << 18 | (e[r++] & 63) << 12 | (e[r++] & 63) << 6 | e[r++] & 63) - 65536, s += String.fromCharCode(55296 | n >> 10, 56320 | n & 1023));
  }
  return s;
}
const ln = "v1", il = (e) => {
  if (typeof e != "string")
    return e;
  try {
    const t = JSON.parse(e);
    if (t.timestamp)
      return t;
  } catch {
  }
  try {
    const t = JSON.parse(
      nl(sl(rl(e, !0)))
    );
    if (t.v === ln)
      return t;
    throw new Error(
      `These events were packed with packer ${t.v} which is incompatible with current packer ${ln}.`
    );
  } catch (t) {
    throw console.error(t), new Error("Unknown data format.");
  }
};
var ol = Object.defineProperty, al = (e, t, s) => t in e ? ol(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, M = (e, t, s) => al(e, typeof t != "symbol" ? t + "" : t, s), ll = Object.defineProperty, cl = (e, t, s) => t in e ? ll(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, cn = (e, t, s) => cl(e, typeof t != "symbol" ? t + "" : t, s), W = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(W || {});
function ul(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
let Bi = class {
  constructor() {
    cn(this, "idNodeMap", /* @__PURE__ */ new Map()), cn(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(e) {
    var t;
    return e ? ((t = this.getMeta(e)) == null ? void 0 : t.id) ?? -1 : -1;
  }
  getNode(e) {
    return this.idNodeMap.get(e) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(e) {
    return this.nodeMetaMap.get(e) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(e) {
    const t = this.getId(e);
    this.idNodeMap.delete(t), e.childNodes && e.childNodes.forEach(
      (s) => this.removeNodeFromMap(s)
    );
  }
  has(e) {
    return this.idNodeMap.has(e);
  }
  hasNode(e) {
    return this.nodeMetaMap.has(e);
  }
  add(e, t) {
    const s = t.id;
    this.idNodeMap.set(s, e), this.nodeMetaMap.set(e, t);
  }
  replace(e, t) {
    const s = this.getNode(e);
    if (s) {
      const r = this.nodeMetaMap.get(s);
      r && this.nodeMetaMap.set(t, r);
    }
    this.idNodeMap.set(e, t);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
};
function zi() {
  return new Bi();
}
function hl(e) {
  return e.toLowerCase();
}
function pl(e, t) {
  return !e || !t || e.type !== t.type ? !1 : e.type === W.Document ? e.compatMode === t.compatMode : e.type === W.DocumentType ? e.name === t.name && e.publicId === t.publicId && e.systemId === t.systemId : e.type === W.Comment || e.type === W.Text || e.type === W.CDATA ? e.textContent === t.textContent : e.type === W.Element ? e.tagName === t.tagName && JSON.stringify(e.attributes) === JSON.stringify(t.attributes) && e.isSVG === t.isSVG && e.needBlock === t.needBlock : !1;
}
function dl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function fl(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var s = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    s.prototype = t.prototype;
  } else s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(s, r, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), s;
}
var Ir = { exports: {} }, D = String, ji = function() {
  return { isColorSupported: !1, reset: D, bold: D, dim: D, italic: D, underline: D, inverse: D, hidden: D, strikethrough: D, black: D, red: D, green: D, yellow: D, blue: D, magenta: D, cyan: D, white: D, gray: D, bgBlack: D, bgRed: D, bgGreen: D, bgYellow: D, bgBlue: D, bgMagenta: D, bgCyan: D, bgWhite: D, blackBright: D, redBright: D, greenBright: D, yellowBright: D, blueBright: D, magentaBright: D, cyanBright: D, whiteBright: D, bgBlackBright: D, bgRedBright: D, bgGreenBright: D, bgYellowBright: D, bgBlueBright: D, bgMagentaBright: D, bgCyanBright: D, bgWhiteBright: D };
};
Ir.exports = ji();
Ir.exports.createColors = ji;
var ml = Ir.exports;
const gl = {}, yl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gl
}, Symbol.toStringTag, { value: "Module" })), fe = /* @__PURE__ */ fl(yl);
let un = ml, hn = fe, Xs = class Wi extends Error {
  constructor(t, s, r, n, o, a) {
    super(t), this.name = "CssSyntaxError", this.reason = t, o && (this.file = o), n && (this.source = n), a && (this.plugin = a), typeof s < "u" && typeof r < "u" && (typeof s == "number" ? (this.line = s, this.column = r) : (this.line = s.line, this.column = s.column, this.endLine = r.line, this.endColumn = r.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, Wi);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(t) {
    if (!this.source) return "";
    let s = this.source;
    t == null && (t = un.isColorSupported);
    let r = (u) => u, n = (u) => u, o = (u) => u;
    if (t) {
      let { bold: u, gray: h, red: p } = un.createColors(!0);
      n = (y) => u(p(y)), r = (y) => h(y), hn && (o = (y) => hn(y));
    }
    let a = s.split(/\r?\n/), i = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, a.length), c = String(l).length;
    return a.slice(i, l).map((u, h) => {
      let p = i + 1 + h, y = " " + (" " + p).slice(-c) + " | ";
      if (p === this.line) {
        if (u.length > 160) {
          let d = 20, S = Math.max(0, this.column - d), f = Math.max(
            this.column + d,
            this.endColumn + d
          ), v = u.slice(S, f), w = r(y.replace(/\d/g, " ")) + u.slice(0, Math.min(this.column - 1, d - 1)).replace(/[^\t]/g, " ");
          return n(">") + r(y) + o(v) + `
 ` + w + n("^");
        }
        let g = r(y.replace(/\d/g, " ")) + u.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return n(">") + r(y) + o(u) + `
 ` + g + n("^");
      }
      return " " + r(y) + o(u);
    }).join(`
`);
  }
  toString() {
    let t = this.showSourceCode();
    return t && (t = `

` + t + `
`), this.name + ": " + this.message + t;
  }
};
var Pr = Xs;
Xs.default = Xs;
const pn = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function wl(e) {
  return e[0].toUpperCase() + e.slice(1);
}
let Hs = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let s = "@" + e.name, r = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName < "u" ? s += e.raws.afterName : r && (s += " "), e.nodes)
      this.block(e, s + r);
    else {
      let n = (e.raws.between || "") + (t ? ";" : "");
      this.builder(s + r + n, e);
    }
  }
  beforeAfter(e, t) {
    let s;
    e.type === "decl" ? s = this.raw(e, null, "beforeDecl") : e.type === "comment" ? s = this.raw(e, null, "beforeComment") : t === "before" ? s = this.raw(e, null, "beforeRule") : s = this.raw(e, null, "beforeClose");
    let r = e.parent, n = 0;
    for (; r && r.type !== "root"; )
      n += 1, r = r.parent;
    if (s.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let a = 0; a < n; a++) s += o;
    }
    return s;
  }
  block(e, t) {
    let s = this.raw(e, "between", "beforeOpen");
    this.builder(t + s + "{", e, "start");
    let r;
    e.nodes && e.nodes.length ? (this.body(e), r = this.raw(e, "after")) : r = this.raw(e, "after", "emptyBody"), r && this.builder(r), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let s = this.raw(e, "semicolon");
    for (let r = 0; r < e.nodes.length; r++) {
      let n = e.nodes[r], o = this.raw(n, "before");
      o && this.builder(o), this.stringify(n, t !== r || s);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), s = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + s + "*/", e);
  }
  decl(e, t) {
    let s = this.raw(e, "between", "colon"), r = e.prop + s + this.rawValue(e, "value");
    e.important && (r += e.raws.important || " !important"), t && (r += ";"), this.builder(r, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, s) {
    let r;
    if (s || (s = t), t && (r = e.raws[t], typeof r < "u"))
      return r;
    let n = e.parent;
    if (s === "before" && (!n || n.type === "root" && n.first === e || n && n.type === "document"))
      return "";
    if (!n) return pn[s];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[s] < "u")
      return o.rawCache[s];
    if (s === "before" || s === "after")
      return this.beforeAfter(e, s);
    {
      let a = "raw" + wl(s);
      this[a] ? r = this[a](o, e) : o.walk((i) => {
        if (r = i.raws[t], typeof r < "u") return !1;
      });
    }
    return typeof r > "u" && (r = pn[s]), o.rawCache[s] = r, r;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && s.nodes.length > 0 && typeof s.raws.after < "u")
        return t = s.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let s;
    return e.walkComments((r) => {
      if (typeof r.raws.before < "u")
        return s = r.raws.before, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
    }), typeof s > "u" ? s = this.raw(t, null, "beforeDecl") : s && (s = s.replace(/\S/g, "")), s;
  }
  rawBeforeDecl(e, t) {
    let s;
    return e.walkDecls((r) => {
      if (typeof r.raws.before < "u")
        return s = r.raws.before, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
    }), typeof s > "u" ? s = this.raw(t, null, "beforeRule") : s && (s = s.replace(/\S/g, "")), s;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((s) => {
      if (s.type !== "decl" && (t = s.raws.between, typeof t < "u"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && (s.parent !== e || e.first !== s) && typeof s.raws.before < "u")
        return t = s.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((s) => {
      if (typeof s.raws.between < "u")
        return t = s.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && s.nodes.length === 0 && (t = s.raws.after, typeof t < "u"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((s) => {
      let r = s.parent;
      if (r && r !== e && r.parent && r.parent === e && typeof s.raws.before < "u") {
        let n = s.raws.before.split(`
`);
        return t = n[n.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && s.nodes.length && s.last.type === "decl" && (t = s.raws.semicolon, typeof t < "u"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let s = e[t], r = e.raws[t];
    return r && r.value === s ? r.raw : s;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var Vi = Hs;
Hs.default = Hs;
let vl = Vi;
function Js(e, t) {
  new vl(t).stringify(e);
}
var ms = Js;
Js.default = Js;
var Mt = {};
Mt.isClean = Symbol("isClean");
Mt.my = Symbol("my");
let bl = Pr, Sl = Vi, xl = ms, { isClean: tt, my: Cl } = Mt;
function Qs(e, t) {
  let s = new e.constructor();
  for (let r in e) {
    if (!Object.prototype.hasOwnProperty.call(e, r) || r === "proxyCache") continue;
    let n = e[r], o = typeof n;
    r === "parent" && o === "object" ? t && (s[r] = t) : r === "source" ? s[r] = n : Array.isArray(n) ? s[r] = n.map((a) => Qs(a, s)) : (o === "object" && n !== null && (n = Qs(n)), s[r] = n);
  }
  return s;
}
function st(e, t) {
  if (t && typeof t.offset < "u")
    return t.offset;
  let s = 1, r = 1, n = 0;
  for (let o = 0; o < e.length; o++) {
    if (r === t.line && s === t.column) {
      n = o;
      break;
    }
    e[o] === `
` ? (s = 1, r += 1) : s += 1;
  }
  return n;
}
let Ks = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[tt] = !1, this[Cl] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let s of e[t])
          typeof s.clone == "function" ? this.append(s.clone()) : this.append(s);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = Qs(this);
    for (let s in e)
      t[s] = e[s];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: s, start: r } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: r.column, line: r.line },
        { column: s.column, line: s.line },
        t
      );
    }
    return new bl(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, s) {
        return e[t] === s || (e[t] = s, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[tt] = !0;
  }
  markDirty() {
    if (this[tt]) {
      this[tt] = !1;
      let e = this;
      for (; e = e.parent; )
        e[tt] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let s = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = s.slice(
        st(s, this.source.start),
        st(s, this.source.end)
      ).indexOf(e.word);
      r !== -1 && (t = this.positionInside(r));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, s = this.source.start.line, r = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = st(r, this.source.start), o = n + e;
    for (let a = n; a < o; a++)
      r[a] === `
` ? (t = 1, s += 1) : t += 1;
    return { column: t, line: s };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, s = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let r = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = r.slice(
        st(r, this.source.start),
        st(r, this.source.end)
      ).indexOf(e.word);
      n !== -1 && (t = this.positionInside(n), s = this.positionInside(
        n + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? s = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? s = this.positionInside(e.endIndex) : e.index && (s = this.positionInside(e.index + 1));
    return (s.line < t.line || s.line === t.line && s.column <= t.column) && (s = { column: t.column + 1, line: t.line }), { end: s, start: t };
  }
  raw(e, t) {
    return new Sl().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, s = !1;
      for (let r of e)
        r === this ? s = !0 : s ? (this.parent.insertAfter(t, r), t = r) : this.parent.insertBefore(t, r);
      s || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let s = {}, r = t == null;
    t = t || /* @__PURE__ */ new Map();
    let n = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let a = this[o];
      if (Array.isArray(a))
        s[o] = a.map((i) => typeof i == "object" && i.toJSON ? i.toJSON(null, t) : i);
      else if (typeof a == "object" && a.toJSON)
        s[o] = a.toJSON(null, t);
      else if (o === "source") {
        let i = t.get(a.input);
        i == null && (i = n, t.set(a.input, n), n++), s[o] = {
          end: a.end,
          inputId: i,
          start: a.start
        };
      } else
        s[o] = a;
    }
    return r && (s.inputs = [...t.keys()].map((o) => o.toJSON())), s;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = xl) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (s) => {
      t += s;
    }), t;
  }
  warn(e, t, s) {
    let r = { node: this };
    for (let n in s) r[n] = s[n];
    return e.warn(t, r);
  }
};
var gs = Ks;
Ks.default = Ks;
let El = gs, qs = class extends El {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var ys = qs;
qs.default = qs;
let kl = gs, $s = class extends kl {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value < "u" && typeof e.value != "string" && (e = { ...e, value: String(e.value) }), super(e), this.type = "decl";
  }
};
var ws = $s;
$s.default = $s;
let Yi = ys, Gi = ws, Ml = gs, { isClean: Zi, my: Xi } = Mt, _r, Hi, Ji, Fr;
function Qi(e) {
  return e.map((t) => (t.nodes && (t.nodes = Qi(t.nodes)), delete t.source, t));
}
function Ki(e) {
  if (e[Zi] = !1, e.proxyOf.nodes)
    for (let t of e.proxyOf.nodes)
      Ki(t);
}
let Ee = class qi extends Ml {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...t) {
    for (let s of t) {
      let r = this.normalize(s, this.last);
      for (let n of r) this.proxyOf.nodes.push(n);
    }
    return this.markDirty(), this;
  }
  cleanRaws(t) {
    if (super.cleanRaws(t), this.nodes)
      for (let s of this.nodes) s.cleanRaws(t);
  }
  each(t) {
    if (!this.proxyOf.nodes) return;
    let s = this.getIterator(), r, n;
    for (; this.indexes[s] < this.proxyOf.nodes.length && (r = this.indexes[s], n = t(this.proxyOf.nodes[r], r), n !== !1); )
      this.indexes[s] += 1;
    return delete this.indexes[s], n;
  }
  every(t) {
    return this.nodes.every(t);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let t = this.lastEach;
    return this.indexes[t] = 0, t;
  }
  getProxyProcessor() {
    return {
      get(t, s) {
        return s === "proxyOf" ? t : t[s] ? s === "each" || typeof s == "string" && s.startsWith("walk") ? (...r) => t[s](
          ...r.map((n) => typeof n == "function" ? (o, a) => n(o.toProxy(), a) : n)
        ) : s === "every" || s === "some" ? (r) => t[s](
          (n, ...o) => r(n.toProxy(), ...o)
        ) : s === "root" ? () => t.root().toProxy() : s === "nodes" ? t.nodes.map((r) => r.toProxy()) : s === "first" || s === "last" ? t[s].toProxy() : t[s] : t[s];
      },
      set(t, s, r) {
        return t[s] === r || (t[s] = r, (s === "name" || s === "params" || s === "selector") && t.markDirty()), !0;
      }
    };
  }
  index(t) {
    return typeof t == "number" ? t : (t.proxyOf && (t = t.proxyOf), this.proxyOf.nodes.indexOf(t));
  }
  insertAfter(t, s) {
    let r = this.index(t), n = this.normalize(s, this.proxyOf.nodes[r]).reverse();
    r = this.index(t);
    for (let a of n) this.proxyOf.nodes.splice(r + 1, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], r < o && (this.indexes[a] = o + n.length);
    return this.markDirty(), this;
  }
  insertBefore(t, s) {
    let r = this.index(t), n = r === 0 ? "prepend" : !1, o = this.normalize(
      s,
      this.proxyOf.nodes[r],
      n
    ).reverse();
    r = this.index(t);
    for (let i of o) this.proxyOf.nodes.splice(r, 0, i);
    let a;
    for (let i in this.indexes)
      a = this.indexes[i], r <= a && (this.indexes[i] = a + o.length);
    return this.markDirty(), this;
  }
  normalize(t, s) {
    if (typeof t == "string")
      t = Qi(Hi(t).nodes);
    else if (typeof t > "u")
      t = [];
    else if (Array.isArray(t)) {
      t = t.slice(0);
      for (let r of t)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (t.type === "root" && this.type !== "document") {
      t = t.nodes.slice(0);
      for (let r of t)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (t.type)
      t = [t];
    else if (t.prop) {
      if (typeof t.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof t.value != "string" && (t.value = String(t.value)), t = [new Gi(t)];
    } else if (t.selector || t.selectors)
      t = [new Fr(t)];
    else if (t.name)
      t = [new _r(t)];
    else if (t.text)
      t = [new Yi(t)];
    else
      throw new Error("Unknown node type in node creation");
    return t.map((r) => (r[Xi] || qi.rebuild(r), r = r.proxyOf, r.parent && r.parent.removeChild(r), r[Zi] && Ki(r), r.raws || (r.raws = {}), typeof r.raws.before > "u" && s && typeof s.raws.before < "u" && (r.raws.before = s.raws.before.replace(/\S/g, "")), r.parent = this.proxyOf, r));
  }
  prepend(...t) {
    t = t.reverse();
    for (let s of t) {
      let r = this.normalize(s, this.first, "prepend").reverse();
      for (let n of r) this.proxyOf.nodes.unshift(n);
      for (let n in this.indexes)
        this.indexes[n] = this.indexes[n] + r.length;
    }
    return this.markDirty(), this;
  }
  push(t) {
    return t.parent = this, this.proxyOf.nodes.push(t), this;
  }
  removeAll() {
    for (let t of this.proxyOf.nodes) t.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(t) {
    t = this.index(t), this.proxyOf.nodes[t].parent = void 0, this.proxyOf.nodes.splice(t, 1);
    let s;
    for (let r in this.indexes)
      s = this.indexes[r], s >= t && (this.indexes[r] = s - 1);
    return this.markDirty(), this;
  }
  replaceValues(t, s, r) {
    return r || (r = s, s = {}), this.walkDecls((n) => {
      s.props && !s.props.includes(n.prop) || s.fast && !n.value.includes(s.fast) || (n.value = n.value.replace(t, r));
    }), this.markDirty(), this;
  }
  some(t) {
    return this.nodes.some(t);
  }
  walk(t) {
    return this.each((s, r) => {
      let n;
      try {
        n = t(s, r);
      } catch (o) {
        throw s.addToError(o);
      }
      return n !== !1 && s.walk && (n = s.walk(t)), n;
    });
  }
  walkAtRules(t, s) {
    return s ? t instanceof RegExp ? this.walk((r, n) => {
      if (r.type === "atrule" && t.test(r.name))
        return s(r, n);
    }) : this.walk((r, n) => {
      if (r.type === "atrule" && r.name === t)
        return s(r, n);
    }) : (s = t, this.walk((r, n) => {
      if (r.type === "atrule")
        return s(r, n);
    }));
  }
  walkComments(t) {
    return this.walk((s, r) => {
      if (s.type === "comment")
        return t(s, r);
    });
  }
  walkDecls(t, s) {
    return s ? t instanceof RegExp ? this.walk((r, n) => {
      if (r.type === "decl" && t.test(r.prop))
        return s(r, n);
    }) : this.walk((r, n) => {
      if (r.type === "decl" && r.prop === t)
        return s(r, n);
    }) : (s = t, this.walk((r, n) => {
      if (r.type === "decl")
        return s(r, n);
    }));
  }
  walkRules(t, s) {
    return s ? t instanceof RegExp ? this.walk((r, n) => {
      if (r.type === "rule" && t.test(r.selector))
        return s(r, n);
    }) : this.walk((r, n) => {
      if (r.type === "rule" && r.selector === t)
        return s(r, n);
    }) : (s = t, this.walk((r, n) => {
      if (r.type === "rule")
        return s(r, n);
    }));
  }
};
Ee.registerParse = (e) => {
  Hi = e;
};
Ee.registerRule = (e) => {
  Fr = e;
};
Ee.registerAtRule = (e) => {
  _r = e;
};
Ee.registerRoot = (e) => {
  Ji = e;
};
var Pe = Ee;
Ee.default = Ee;
Ee.rebuild = (e) => {
  e.type === "atrule" ? Object.setPrototypeOf(e, _r.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, Fr.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, Gi.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, Yi.prototype) : e.type === "root" && Object.setPrototypeOf(e, Ji.prototype), e[Xi] = !0, e.nodes && e.nodes.forEach((t) => {
    Ee.rebuild(t);
  });
};
let $i = Pe, ss = class extends $i {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var Lr = ss;
ss.default = ss;
$i.registerAtRule(ss);
let Nl = Pe, eo, to, yt = class extends Nl {
  constructor(e) {
    super({ type: "document", ...e }), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new eo(new to(), this, e).stringify();
  }
};
yt.registerLazyResult = (e) => {
  eo = e;
};
yt.registerProcessor = (e) => {
  to = e;
};
var Ur = yt;
yt.default = yt;
let Tl = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", Dl = (e = 21) => {
  let t = "", s = e | 0;
  for (; s--; )
    t += Tl[Math.random() * 64 | 0];
  return t;
};
var Rl = { nanoid: Dl };
let { existsSync: Ol, readFileSync: Al } = fe, { dirname: Os, join: Il } = fe, { SourceMapConsumer: dn, SourceMapGenerator: fn } = fe;
function Pl(e) {
  return Buffer ? Buffer.from(e, "base64").toString() : window.atob(e);
}
let er = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let s = t.map ? t.map.prev : void 0, r = this.loadMap(t.from, s);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = Os(this.mapFile)), r && (this.text = r);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new dn(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, s = /^data:application\/json;base64,/, r = /^data:application\/json;charset=utf-?8,/, n = /^data:application\/json,/, o = e.match(r) || e.match(n);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let a = e.match(t) || e.match(s);
    if (a)
      return Pl(e.substr(a[0].length));
    let i = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + i);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let s = e.lastIndexOf(t.pop()), r = e.indexOf("*/", s);
    s > -1 && r > -1 && (this.annotation = this.getAnnotationURL(e.substring(s, r)));
  }
  loadFile(e) {
    if (this.root = Os(e), Ol(e))
      return this.mapFile = e, Al(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let s = t(e);
        if (s) {
          let r = this.loadFile(s);
          if (!r)
            throw new Error(
              "Unable to load previous source map: " + s.toString()
            );
          return r;
        }
      } else {
        if (t instanceof dn)
          return fn.fromSourceMap(t).toString();
        if (t instanceof fn)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let s = this.annotation;
        return e && (s = Il(Os(e), s)), this.loadFile(s);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var so = er;
er.default = er;
let { nanoid: _l } = Rl, { isAbsolute: tr, resolve: sr } = fe, { SourceMapConsumer: Fl, SourceMapGenerator: Ll } = fe, { fileURLToPath: mn, pathToFileURL: Rt } = fe, gn = Pr, Ul = so, As = fe, Is = Symbol("fromOffsetCache"), Bl = !!(Fl && Ll), yn = !!(sr && tr), rs = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e > "u" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!yn || /^\w+:\/\//.test(t.from) || tr(t.from) ? this.file = t.from : this.file = sr(t.from)), yn && Bl) {
      let s = new Ul(this.css, t);
      if (s.text) {
        this.map = s;
        let r = s.consumer().file;
        !this.file && r && (this.file = this.mapResolve(r));
      }
    }
    this.file || (this.id = "<input css " + _l(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, s, r = {}) {
    let n, o, a;
    if (t && typeof t == "object") {
      let l = t, c = s;
      if (typeof l.offset == "number") {
        let u = this.fromOffset(l.offset);
        t = u.line, s = u.col;
      } else
        t = l.line, s = l.column;
      if (typeof c.offset == "number") {
        let u = this.fromOffset(c.offset);
        o = u.line, n = u.col;
      } else
        o = c.line, n = c.column;
    } else if (!s) {
      let l = this.fromOffset(t);
      t = l.line, s = l.col;
    }
    let i = this.origin(t, s, o, n);
    return i ? a = new gn(
      e,
      i.endLine === void 0 ? i.line : { column: i.column, line: i.line },
      i.endLine === void 0 ? i.column : { column: i.endColumn, line: i.endLine },
      i.source,
      i.file,
      r.plugin
    ) : a = new gn(
      e,
      o === void 0 ? t : { column: s, line: t },
      o === void 0 ? s : { column: n, line: o },
      this.css,
      this.file,
      r.plugin
    ), a.input = { column: s, endColumn: n, endLine: o, line: t, source: this.css }, this.file && (Rt && (a.input.url = Rt(this.file).toString()), a.input.file = this.file), a;
  }
  fromOffset(e) {
    let t, s;
    if (this[Is])
      s = this[Is];
    else {
      let n = this.css.split(`
`);
      s = new Array(n.length);
      let o = 0;
      for (let a = 0, i = n.length; a < i; a++)
        s[a] = o, o += n[a].length + 1;
      this[Is] = s;
    }
    t = s[s.length - 1];
    let r = 0;
    if (e >= t)
      r = s.length - 1;
    else {
      let n = s.length - 2, o;
      for (; r < n; )
        if (o = r + (n - r >> 1), e < s[o])
          n = o - 1;
        else if (e >= s[o + 1])
          r = o + 1;
        else {
          r = o;
          break;
        }
    }
    return {
      col: e - s[r] + 1,
      line: r + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : sr(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, s, r) {
    if (!this.map) return !1;
    let n = this.map.consumer(), o = n.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let a;
    typeof s == "number" && (a = n.originalPositionFor({ column: r, line: s }));
    let i;
    tr(o.source) ? i = Rt(o.source) : i = new URL(
      o.source,
      this.map.consumer().sourceRoot || Rt(this.map.mapFile)
    );
    let l = {
      column: o.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: o.line,
      url: i.toString()
    };
    if (i.protocol === "file:")
      if (mn)
        l.file = mn(i);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let c = n.sourceContentFor(o.source);
    return c && (l.source = c), l;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = { ...this.map }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var vs = rs;
rs.default = rs;
As && As.registerInput && As.registerInput(rs);
let ro = Pe, no, io, Xe = class extends ro {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, s) {
    let r = super.normalize(e);
    if (t) {
      if (s === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let n of r)
          n.raws.before = t.raws.before;
    }
    return r;
  }
  removeChild(e, t) {
    let s = this.index(e);
    return !t && s === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[s].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new no(new io(), this, e).stringify();
  }
};
Xe.registerLazyResult = (e) => {
  no = e;
};
Xe.registerProcessor = (e) => {
  io = e;
};
var Nt = Xe;
Xe.default = Xe;
ro.registerRoot(Xe);
let wt = {
  comma(e) {
    return wt.split(e, [","], !0);
  },
  space(e) {
    let t = [" ", `
`, "	"];
    return wt.split(e, t);
  },
  split(e, t, s) {
    let r = [], n = "", o = !1, a = 0, i = !1, l = "", c = !1;
    for (let u of e)
      c ? c = !1 : u === "\\" ? c = !0 : i ? u === l && (i = !1) : u === '"' || u === "'" ? (i = !0, l = u) : u === "(" ? a += 1 : u === ")" ? a > 0 && (a -= 1) : a === 0 && t.includes(u) && (o = !0), o ? (n !== "" && r.push(n.trim()), n = "", o = !1) : n += u;
    return (s || n !== "") && r.push(n.trim()), r;
  }
};
var oo = wt;
wt.default = wt;
let ao = Pe, zl = oo, ns = class extends ao {
  get selectors() {
    return zl.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, s = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(s);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var Br = ns;
ns.default = ns;
ao.registerRule(ns);
let jl = Lr, Wl = ys, Vl = ws, Yl = vs, Gl = so, Zl = Nt, Xl = Br;
function vt(e, t) {
  if (Array.isArray(e)) return e.map((n) => vt(n));
  let { inputs: s, ...r } = e;
  if (s) {
    t = [];
    for (let n of s) {
      let o = { ...n, __proto__: Yl.prototype };
      o.map && (o.map = {
        ...o.map,
        __proto__: Gl.prototype
      }), t.push(o);
    }
  }
  if (r.nodes && (r.nodes = e.nodes.map((n) => vt(n, t))), r.source) {
    let { inputId: n, ...o } = r.source;
    r.source = o, n != null && (r.source.input = t[n]);
  }
  if (r.type === "root")
    return new Zl(r);
  if (r.type === "decl")
    return new Vl(r);
  if (r.type === "rule")
    return new Xl(r);
  if (r.type === "comment")
    return new Wl(r);
  if (r.type === "atrule")
    return new jl(r);
  throw new Error("Unknown node type: " + e.type);
}
var Hl = vt;
vt.default = vt;
let { dirname: Qt, relative: lo, resolve: co, sep: uo } = fe, { SourceMapConsumer: ho, SourceMapGenerator: Kt } = fe, { pathToFileURL: wn } = fe, Jl = vs, Ql = !!(ho && Kt), Kl = !!(Qt && co && lo && uo), ql = class {
  constructor(e, t, s, r) {
    this.stringify = e, this.mapOpts = s.map || {}, this.root = t, this.opts = s, this.css = r, this.originalCSS = r, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), s = e.root || Qt(e.file), r;
      this.mapOpts.sourcesContent === !1 ? (r = new ho(e.text), r.sourcesContent && (r.sourcesContent = null)) : r = e.consumer(), this.map.applySourceMap(r, t, this.toUrl(this.path(s)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), Kl && Ql && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = Kt.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new Kt({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new Kt({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, s = "<no source>", r = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, n, o;
    this.stringify(this.root, (a, i, l) => {
      if (this.css += a, i && l !== "end" && (r.generated.line = e, r.generated.column = t - 1, i.source && i.source.start ? (r.source = this.sourcePath(i), r.original.line = i.source.start.line, r.original.column = i.source.start.column - 1, this.map.addMapping(r)) : (r.source = s, r.original.line = 1, r.original.column = 0, this.map.addMapping(r))), o = a.match(/\n/g), o ? (e += o.length, n = a.lastIndexOf(`
`), t = a.length - n) : t += a.length, i && l !== "start") {
        let c = i.parent || { raws: {} };
        (!(i.type === "decl" || i.type === "atrule" && !i.nodes) || i !== c.last || c.raws.semicolon) && (i.source && i.source.end ? (r.source = this.sourcePath(i), r.original.line = i.source.end.line, r.original.column = i.source.end.column - 1, r.generated.line = e, r.generated.column = t - 2, this.map.addMapping(r)) : (r.source = s, r.original.line = 1, r.original.column = 0, r.generated.line = e, r.generated.column = t - 1, this.map.addMapping(r)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let s = this.opts.to ? Qt(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (s = Qt(co(s, this.mapOpts.annotation)));
    let r = lo(s, e);
    return this.memoizedPaths.set(e, r), r;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new Jl(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let s = t.source.input.from;
          if (s && !e[s]) {
            e[s] = !0;
            let r = this.usesFileUrls ? this.toFileUrl(s) : this.toUrl(this.path(s));
            this.map.setSourceContent(r, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (wn) {
      let s = wn(e).toString();
      return this.memoizedFileURLs.set(e, s), s;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    uo === "\\" && (e = e.replace(/\\/g, "/"));
    let s = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, s), s;
  }
};
var po = ql;
const Ps = 39, vn = 34, Ot = 92, bn = 47, At = 10, rt = 32, It = 12, Pt = 9, _t = 13, $l = 91, ec = 93, tc = 40, sc = 41, rc = 123, nc = 125, ic = 59, oc = 42, ac = 58, lc = 64, Ft = /[\t\n\f\r "#'()/;[\\\]{}]/g, Lt = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, cc = /.[\r\n"'(/\\]/, Sn = /[\da-f]/i;
var uc = function(e, t = {}) {
  let s = e.css.valueOf(), r = t.ignoreErrors, n, o, a, i, l, c, u, h, p, y, g = s.length, d = 0, S = [], f = [];
  function v() {
    return d;
  }
  function w(_) {
    throw e.error("Unclosed " + _, d);
  }
  function k() {
    return f.length === 0 && d >= g;
  }
  function E(_) {
    if (f.length) return f.pop();
    if (d >= g) return;
    let Y = _ ? _.ignoreUnclosed : !1;
    switch (n = s.charCodeAt(d), n) {
      case At:
      case rt:
      case Pt:
      case _t:
      case It: {
        i = d;
        do
          i += 1, n = s.charCodeAt(i);
        while (n === rt || n === At || n === Pt || n === _t || n === It);
        c = ["space", s.slice(d, i)], d = i - 1;
        break;
      }
      case $l:
      case ec:
      case rc:
      case nc:
      case ac:
      case ic:
      case sc: {
        let q = String.fromCharCode(n);
        c = [q, q, d];
        break;
      }
      case tc: {
        if (y = S.length ? S.pop()[1] : "", p = s.charCodeAt(d + 1), y === "url" && p !== Ps && p !== vn && p !== rt && p !== At && p !== Pt && p !== It && p !== _t) {
          i = d;
          do {
            if (u = !1, i = s.indexOf(")", i + 1), i === -1)
              if (r || Y) {
                i = d;
                break;
              } else
                w("bracket");
            for (h = i; s.charCodeAt(h - 1) === Ot; )
              h -= 1, u = !u;
          } while (u);
          c = ["brackets", s.slice(d, i + 1), d, i], d = i;
        } else
          i = s.indexOf(")", d + 1), o = s.slice(d, i + 1), i === -1 || cc.test(o) ? c = ["(", "(", d] : (c = ["brackets", o, d, i], d = i);
        break;
      }
      case Ps:
      case vn: {
        l = n === Ps ? "'" : '"', i = d;
        do {
          if (u = !1, i = s.indexOf(l, i + 1), i === -1)
            if (r || Y) {
              i = d + 1;
              break;
            } else
              w("string");
          for (h = i; s.charCodeAt(h - 1) === Ot; )
            h -= 1, u = !u;
        } while (u);
        c = ["string", s.slice(d, i + 1), d, i], d = i;
        break;
      }
      case lc: {
        Ft.lastIndex = d + 1, Ft.test(s), Ft.lastIndex === 0 ? i = s.length - 1 : i = Ft.lastIndex - 2, c = ["at-word", s.slice(d, i + 1), d, i], d = i;
        break;
      }
      case Ot: {
        for (i = d, a = !0; s.charCodeAt(i + 1) === Ot; )
          i += 1, a = !a;
        if (n = s.charCodeAt(i + 1), a && n !== bn && n !== rt && n !== At && n !== Pt && n !== _t && n !== It && (i += 1, Sn.test(s.charAt(i)))) {
          for (; Sn.test(s.charAt(i + 1)); )
            i += 1;
          s.charCodeAt(i + 1) === rt && (i += 1);
        }
        c = ["word", s.slice(d, i + 1), d, i], d = i;
        break;
      }
      default: {
        n === bn && s.charCodeAt(d + 1) === oc ? (i = s.indexOf("*/", d + 2) + 1, i === 0 && (r || Y ? i = s.length : w("comment")), c = ["comment", s.slice(d, i + 1), d, i], d = i) : (Lt.lastIndex = d + 1, Lt.test(s), Lt.lastIndex === 0 ? i = s.length - 1 : i = Lt.lastIndex - 2, c = ["word", s.slice(d, i + 1), d, i], S.push(c), d = i);
        break;
      }
    }
    return d++, c;
  }
  function A(_) {
    f.push(_);
  }
  return {
    back: A,
    endOfFile: k,
    nextToken: E,
    position: v
  };
};
let hc = Lr, pc = ys, dc = ws, fc = Nt, xn = Br, mc = uc;
const Cn = {
  empty: !0,
  space: !0
};
function gc(e) {
  for (let t = e.length - 1; t >= 0; t--) {
    let s = e[t], r = s[3] || s[2];
    if (r) return r;
  }
}
let yc = class {
  constructor(e) {
    this.input = e, this.root = new fc(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new hc();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let s, r, n, o = !1, a = !1, i = [], l = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), s = e[0], s === "(" || s === "[" ? l.push(s === "(" ? ")" : "]") : s === "{" && l.length > 0 ? l.push("}") : s === l[l.length - 1] && l.pop(), l.length === 0)
        if (s === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (s === "{") {
          a = !0;
          break;
        } else if (s === "}") {
          if (i.length > 0) {
            for (n = i.length - 1, r = i[n]; r && r[0] === "space"; )
              r = i[--n];
            r && (t.source.end = this.getPosition(r[3] || r[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          i.push(e);
      else
        i.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(i), i.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(i), this.raw(t, "params", i), o && (e = i[i.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let s = 0, r;
    for (let n = t - 1; n >= 0 && (r = e[n], !(r[0] !== "space" && (s += 1, s === 2))); n--)
      ;
    throw this.input.error(
      "Missed semicolon",
      r[0] === "word" ? r[3] + 1 : r[2]
    );
  }
  colon(e) {
    let t = 0, s, r, n;
    for (let [o, a] of e.entries()) {
      if (r = a, n = r[0], n === "(" && (t += 1), n === ")" && (t -= 1), t === 0 && n === ":")
        if (!s)
          this.doubleColon(r);
        else {
          if (s[0] === "word" && s[1] === "progid")
            continue;
          return o;
        }
      s = r;
    }
    return !1;
  }
  comment(e) {
    let t = new pc();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let s = e[1].slice(2, -2);
    if (/^\s*$/.test(s))
      t.text = "", t.raws.left = s, t.raws.right = "";
    else {
      let r = s.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = r[2], t.raws.left = r[1], t.raws.right = r[3];
    }
  }
  createTokenizer() {
    this.tokenizer = mc(this.input);
  }
  decl(e, t) {
    let s = new dc();
    this.init(s, e[0][2]);
    let r = e[e.length - 1];
    for (r[0] === ";" && (this.semicolon = !0, e.pop()), s.source.end = this.getPosition(
      r[3] || r[2] || gc(e)
    ), s.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), s.raws.before += e.shift()[1];
    for (s.source.start = this.getPosition(e[0][2]), s.prop = ""; e.length; ) {
      let i = e[0][0];
      if (i === ":" || i === "space" || i === "comment")
        break;
      s.prop += e.shift()[1];
    }
    s.raws.between = "";
    let n;
    for (; e.length; )
      if (n = e.shift(), n[0] === ":") {
        s.raws.between += n[1];
        break;
      } else
        n[0] === "word" && /\w/.test(n[1]) && this.unknownWord([n]), s.raws.between += n[1];
    (s.prop[0] === "_" || s.prop[0] === "*") && (s.raws.before += s.prop[0], s.prop = s.prop.slice(1));
    let o = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let i = e.length - 1; i >= 0; i--) {
      if (n = e[i], n[1].toLowerCase() === "!important") {
        s.important = !0;
        let l = this.stringFrom(e, i);
        l = this.spacesFromEnd(e) + l, l !== " !important" && (s.raws.important = l);
        break;
      } else if (n[1].toLowerCase() === "important") {
        let l = e.slice(0), c = "";
        for (let u = i; u > 0; u--) {
          let h = l[u][0];
          if (c.trim().startsWith("!") && h !== "space")
            break;
          c = l.pop()[1] + c;
        }
        c.trim().startsWith("!") && (s.important = !0, s.raws.important = c, e = l);
      }
      if (n[0] !== "space" && n[0] !== "comment")
        break;
    }
    e.some((i) => i[0] !== "space" && i[0] !== "comment") && (s.raws.between += o.map((i) => i[1]).join(""), o = []), this.raw(s, "value", o.concat(e), t), s.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new xn();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, s = null, r = !1, n = null, o = [], a = e[1].startsWith("--"), i = [], l = e;
    for (; l; ) {
      if (s = l[0], i.push(l), s === "(" || s === "[")
        n || (n = l), o.push(s === "(" ? ")" : "]");
      else if (a && r && s === "{")
        n || (n = l), o.push("}");
      else if (o.length === 0)
        if (s === ";")
          if (r) {
            this.decl(i, a);
            return;
          } else
            break;
        else if (s === "{") {
          this.rule(i);
          return;
        } else if (s === "}") {
          this.tokenizer.back(i.pop()), t = !0;
          break;
        } else s === ":" && (r = !0);
      else s === o[o.length - 1] && (o.pop(), o.length === 0 && (n = null));
      l = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(n), t && r) {
      if (!a)
        for (; i.length && (l = i[i.length - 1][0], !(l !== "space" && l !== "comment")); )
          this.tokenizer.back(i.pop());
      this.decl(i, a);
    } else
      this.unknownWord(i);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, s, r) {
    let n, o, a = s.length, i = "", l = !0, c, u;
    for (let h = 0; h < a; h += 1)
      n = s[h], o = n[0], o === "space" && h === a - 1 && !r ? l = !1 : o === "comment" ? (u = s[h - 1] ? s[h - 1][0] : "empty", c = s[h + 1] ? s[h + 1][0] : "empty", !Cn[u] && !Cn[c] ? i.slice(-1) === "," ? l = !1 : i += n[1] : l = !1) : i += n[1];
    if (!l) {
      let h = s.reduce((p, y) => p + y[1], "");
      e.raws[t] = { raw: h, value: i };
    }
    e[t] = i;
  }
  rule(e) {
    e.pop();
    let t = new xn();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, s = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      s = e.pop()[1] + s;
    return s;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, s = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      s += e.shift()[1];
    return s;
  }
  spacesFromEnd(e) {
    let t, s = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      s = e.pop()[1] + s;
    return s;
  }
  stringFrom(e, t) {
    let s = "";
    for (let r = t; r < e.length; r++)
      s += e[r][1];
    return e.splice(t, e.length - t), s;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var wc = yc;
let vc = Pe, bc = vs, Sc = wc;
function is(e, t) {
  let s = new bc(e, t), r = new Sc(s);
  try {
    r.parse();
  } catch (n) {
    throw process.env.NODE_ENV !== "production" && n.name === "CssSyntaxError" && t && t.from && (/\.scss$/i.test(t.from) ? n.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(t.from) ? n.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(t.from) && (n.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), n;
  }
  return r.root;
}
var zr = is;
is.default = is;
vc.registerParse(is);
let rr = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let s = t.node.rangeBy(t);
      this.line = s.start.line, this.column = s.start.column, this.endLine = s.end.line, this.endColumn = s.end.column;
    }
    for (let s in t) this[s] = t[s];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var fo = rr;
rr.default = rr;
let xc = fo, nr = class {
  get content() {
    return this.css;
  }
  constructor(e, t, s) {
    this.processor = e, this.messages = [], this.root = t, this.opts = s, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let s = new xc(e, t);
    return this.messages.push(s), s;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var jr = nr;
nr.default = nr;
let En = {};
var mo = function(e) {
  En[e] || (En[e] = !0, typeof console < "u" && console.warn && console.warn(e));
};
let Cc = Pe, Ec = Ur, kc = po, Mc = zr, kn = jr, Nc = Nt, Tc = ms, { isClean: ve, my: Dc } = Mt, Rc = mo;
const Oc = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, Ac = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, Ic = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, He = 0;
function nt(e) {
  return typeof e == "object" && typeof e.then == "function";
}
function go(e) {
  let t = !1, s = Oc[e.type];
  return e.type === "decl" ? t = e.prop.toLowerCase() : e.type === "atrule" && (t = e.name.toLowerCase()), t && e.append ? [
    s,
    s + "-" + t,
    He,
    s + "Exit",
    s + "Exit-" + t
  ] : t ? [s, s + "-" + t, s + "Exit", s + "Exit-" + t] : e.append ? [s, He, s + "Exit"] : [s, s + "Exit"];
}
function Mn(e) {
  let t;
  return e.type === "document" ? t = ["Document", He, "DocumentExit"] : e.type === "root" ? t = ["Root", He, "RootExit"] : t = go(e), {
    eventIndex: 0,
    events: t,
    iterator: 0,
    node: e,
    visitorIndex: 0,
    visitors: []
  };
}
function ir(e) {
  return e[ve] = !1, e.nodes && e.nodes.forEach((t) => ir(t)), e;
}
let or = {}, Je = class yo {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(t, s, r) {
    this.stringified = !1, this.processed = !1;
    let n;
    if (typeof s == "object" && s !== null && (s.type === "root" || s.type === "document"))
      n = ir(s);
    else if (s instanceof yo || s instanceof kn)
      n = ir(s.root), s.map && (typeof r.map > "u" && (r.map = {}), r.map.inline || (r.map.inline = !1), r.map.prev = s.map);
    else {
      let o = Mc;
      r.syntax && (o = r.syntax.parse), r.parser && (o = r.parser), o.parse && (o = o.parse);
      try {
        n = o(s, r);
      } catch (a) {
        this.processed = !0, this.error = a;
      }
      n && !n[Dc] && Cc.rebuild(n);
    }
    this.result = new kn(t, n, r), this.helpers = { ...or, postcss: or, result: this.result }, this.plugins = this.processor.plugins.map((o) => typeof o == "object" && o.prepare ? { ...o, ...o.prepare(this.result) } : o);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(t) {
    return this.async().catch(t);
  }
  finally(t) {
    return this.async().then(t, t);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(t, s) {
    let r = this.result.lastPlugin;
    try {
      if (s && s.addToError(t), this.error = t, t.name === "CssSyntaxError" && !t.plugin)
        t.plugin = r.postcssPlugin, t.setMessage();
      else if (r.postcssVersion && process.env.NODE_ENV !== "production") {
        let n = r.postcssPlugin, o = r.postcssVersion, a = this.result.processor.version, i = o.split("."), l = a.split(".");
        (i[0] !== l[0] || parseInt(i[1]) > parseInt(l[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + a + ", but " + n + " uses " + o + ". Perhaps this is the source of the error below."
        );
      }
    } catch (n) {
      console && console.error && console.error(n);
    }
    return t;
  }
  prepareVisitors() {
    this.listeners = {};
    let t = (s, r, n) => {
      this.listeners[r] || (this.listeners[r] = []), this.listeners[r].push([s, n]);
    };
    for (let s of this.plugins)
      if (typeof s == "object")
        for (let r in s) {
          if (!Ac[r] && /^[A-Z]/.test(r))
            throw new Error(
              `Unknown event ${r} in ${s.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!Ic[r])
            if (typeof s[r] == "object")
              for (let n in s[r])
                n === "*" ? t(s, r, s[r][n]) : t(
                  s,
                  r + "-" + n.toLowerCase(),
                  s[r][n]
                );
            else typeof s[r] == "function" && t(s, r, s[r]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let t = 0; t < this.plugins.length; t++) {
      let s = this.plugins[t], r = this.runOnRoot(s);
      if (nt(r))
        try {
          await r;
        } catch (n) {
          throw this.handleError(n);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[ve]; ) {
        t[ve] = !0;
        let s = [Mn(t)];
        for (; s.length > 0; ) {
          let r = this.visitTick(s);
          if (nt(r))
            try {
              await r;
            } catch (n) {
              let o = s[s.length - 1].node;
              throw this.handleError(n, o);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [s, r] of this.listeners.OnceExit) {
          this.result.lastPlugin = s;
          try {
            if (t.type === "document") {
              let n = t.nodes.map(
                (o) => r(o, this.helpers)
              );
              await Promise.all(n);
            } else
              await r(t, this.helpers);
          } catch (n) {
            throw this.handleError(n);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(t) {
    this.result.lastPlugin = t;
    try {
      if (typeof t == "object" && t.Once) {
        if (this.result.root.type === "document") {
          let s = this.result.root.nodes.map(
            (r) => t.Once(r, this.helpers)
          );
          return nt(s[0]) ? Promise.all(s) : s;
        }
        return t.Once(this.result.root, this.helpers);
      } else if (typeof t == "function")
        return t(this.result.root, this.result);
    } catch (s) {
      throw this.handleError(s);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let t = this.result.opts, s = Tc;
    t.syntax && (s = t.syntax.stringify), t.stringifier && (s = t.stringifier), s.stringify && (s = s.stringify);
    let r = new kc(s, this.result.root, this.result.opts).generate();
    return this.result.css = r[0], this.result.map = r[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let t of this.plugins) {
      let s = this.runOnRoot(t);
      if (nt(s))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[ve]; )
        t[ve] = !0, this.walkSync(t);
      if (this.listeners.OnceExit)
        if (t.type === "document")
          for (let s of t.nodes)
            this.visitSync(this.listeners.OnceExit, s);
        else
          this.visitSync(this.listeners.OnceExit, t);
    }
    return this.result;
  }
  then(t, s) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || Rc(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(t, s);
  }
  toString() {
    return this.css;
  }
  visitSync(t, s) {
    for (let [r, n] of t) {
      this.result.lastPlugin = r;
      let o;
      try {
        o = n(s, this.helpers);
      } catch (a) {
        throw this.handleError(a, s.proxyOf);
      }
      if (s.type !== "root" && s.type !== "document" && !s.parent)
        return !0;
      if (nt(o))
        throw this.getAsyncError();
    }
  }
  visitTick(t) {
    let s = t[t.length - 1], { node: r, visitors: n } = s;
    if (r.type !== "root" && r.type !== "document" && !r.parent) {
      t.pop();
      return;
    }
    if (n.length > 0 && s.visitorIndex < n.length) {
      let [a, i] = n[s.visitorIndex];
      s.visitorIndex += 1, s.visitorIndex === n.length && (s.visitors = [], s.visitorIndex = 0), this.result.lastPlugin = a;
      try {
        return i(r.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, r);
      }
    }
    if (s.iterator !== 0) {
      let a = s.iterator, i;
      for (; i = r.nodes[r.indexes[a]]; )
        if (r.indexes[a] += 1, !i[ve]) {
          i[ve] = !0, t.push(Mn(i));
          return;
        }
      s.iterator = 0, delete r.indexes[a];
    }
    let o = s.events;
    for (; s.eventIndex < o.length; ) {
      let a = o[s.eventIndex];
      if (s.eventIndex += 1, a === He) {
        r.nodes && r.nodes.length && (r[ve] = !0, s.iterator = r.getIterator());
        return;
      } else if (this.listeners[a]) {
        s.visitors = this.listeners[a];
        return;
      }
    }
    t.pop();
  }
  walkSync(t) {
    t[ve] = !0;
    let s = go(t);
    for (let r of s)
      if (r === He)
        t.nodes && t.each((n) => {
          n[ve] || this.walkSync(n);
        });
      else {
        let n = this.listeners[r];
        if (n && this.visitSync(n, t.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
Je.registerPostcss = (e) => {
  or = e;
};
var wo = Je;
Je.default = Je;
Nc.registerLazyResult(Je);
Ec.registerLazyResult(Je);
let Pc = po, _c = zr;
const Fc = jr;
let Lc = ms, Uc = mo, ar = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = _c;
    try {
      e = t(this._css, this._opts);
    } catch (s) {
      this.error = s;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, s) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = s, this._map = void 0;
    let r, n = Lc;
    this.result = new Fc(this._processor, r, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let a = new Pc(n, r, this._opts, t);
    if (a.isMap()) {
      let [i, l] = a.generate();
      i && (this.result.css = i), l && (this.result.map = l);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || Uc(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var Bc = ar;
ar.default = ar;
let zc = Ur, jc = wo, Wc = Bc, Vc = Nt, bt = class {
  constructor(e = []) {
    this.version = "8.5.3", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let s of e)
      if (s.postcss === !0 ? s = s() : s.postcss && (s = s.postcss), typeof s == "object" && Array.isArray(s.plugins))
        t = t.concat(s.plugins);
      else if (typeof s == "object" && s.postcssPlugin)
        t.push(s);
      else if (typeof s == "function")
        t.push(s);
      else if (typeof s == "object" && (s.parse || s.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(s + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new Wc(this, e, t) : new jc(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var Yc = bt;
bt.default = bt;
Vc.registerProcessor(bt);
zc.registerProcessor(bt);
let vo = Lr, bo = ys, Gc = Pe, Zc = Pr, So = ws, xo = Ur, Xc = Hl, Hc = vs, Jc = wo, Qc = oo, Kc = gs, qc = zr, Wr = Yc, $c = jr, Co = Nt, Eo = Br, eu = ms, tu = fo;
function B(...e) {
  return e.length === 1 && Array.isArray(e[0]) && (e = e[0]), new Wr(e);
}
B.plugin = function(e, t) {
  let s = !1;
  function r(...o) {
    console && console.warn && !s && (s = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...o);
    return a.postcssPlugin = e, a.postcssVersion = new Wr().version, a;
  }
  let n;
  return Object.defineProperty(r, "postcss", {
    get() {
      return n || (n = r()), n;
    }
  }), r.process = function(o, a, i) {
    return B([r(i)]).process(o, a);
  }, r;
};
B.stringify = eu;
B.parse = qc;
B.fromJSON = Xc;
B.list = Qc;
B.comment = (e) => new bo(e);
B.atRule = (e) => new vo(e);
B.decl = (e) => new So(e);
B.rule = (e) => new Eo(e);
B.root = (e) => new Co(e);
B.document = (e) => new xo(e);
B.CssSyntaxError = Zc;
B.Declaration = So;
B.Container = Gc;
B.Processor = Wr;
B.Document = xo;
B.Comment = bo;
B.Warning = tu;
B.AtRule = vo;
B.Result = $c;
B.Input = Hc;
B.Rule = Eo;
B.Root = Co;
B.Node = Kc;
Jc.registerPostcss(B);
var su = B;
B.default = B;
const X = /* @__PURE__ */ dl(su);
X.stringify;
X.fromJSON;
X.plugin;
X.parse;
X.list;
X.document;
X.comment;
X.atRule;
X.rule;
X.decl;
X.root;
X.CssSyntaxError;
X.Declaration;
X.Container;
X.Processor;
X.Document;
X.Comment;
X.Warning;
X.AtRule;
X.Result;
X.Input;
X.Rule;
X.Root;
X.Node;
const ru = /(max|min)-device-(width|height)/, Nn = new RegExp(ru.source, "g"), nu = {
  postcssPlugin: "postcss-custom-selectors",
  prepare() {
    return {
      postcssPlugin: "postcss-custom-selectors",
      AtRule: function(e) {
        e.params.match(Nn) && (e.params = e.params.replace(Nn, "$1-$2"));
      }
    };
  }
}, iu = {
  postcssPlugin: "postcss-hover-classes",
  prepare: function() {
    const e = [];
    return {
      Rule: function(t) {
        e.indexOf(t) === -1 && (e.push(t), t.selectors.forEach(function(s) {
          if (!s.includes(":"))
            return;
          const r = s.replace(/\n/g, " ").split(" "), n = [];
          r.forEach(function(a) {
            const i = a.match(/::?([^:]+)/g);
            if (!i) {
              n.push(a);
              return;
            }
            const l = a.substr(
              0,
              a.length - i.join("").length
            ), c = i.map(function(u) {
              return u.replace(/\(.*/g, "") !== ":hover" || u.match(/^::/) ? u : (u = u.substr(1), u = u.replace(/\(/g, "\\("), u = u.replace(/\)/g, "\\)"), ".\\:" + u);
            });
            n.push(l + c.join(""));
          }), o(n.join(" "));
          function o(a) {
            a && a !== s && (t.selector += `,
` + a);
          }
        }));
      }
    };
  }
}, Tn = {
  script: "noscript",
  // camel case svg element tag names
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  fedropshadow: "feDropShadow",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient"
};
function ou(e) {
  let t = Tn[e.tagName] ? Tn[e.tagName] : e.tagName;
  return t === "link" && e.attributes._cssText && (t = "style"), t;
}
function Dn(e, t) {
  const s = t == null ? void 0 : t.stylesWithHoverClass.get(e);
  if (s) return s;
  const r = X([
    nu,
    iu
  ]).process(e).css;
  return t == null || t.stylesWithHoverClass.set(e, r), r;
}
function Rn() {
  return {
    stylesWithHoverClass: /* @__PURE__ */ new Map()
  };
}
function au(e, t) {
  var s;
  const { doc: r, hackCss: n, cache: o } = t;
  switch (e.type) {
    case W.Document:
      return r.implementation.createDocument(null, "", null);
    case W.DocumentType:
      return r.implementation.createDocumentType(
        e.name || "html",
        e.publicId,
        e.systemId
      );
    case W.Element: {
      const a = ou(e);
      let i;
      e.isSVG ? i = r.createElementNS("http://www.w3.org/2000/svg", a) : (
        // If the tag name is a custom element name
        (e.isCustom && // If the browser supports custom elements
        (s = r.defaultView) != null && s.customElements && // If the custom element hasn't been defined yet
        !r.defaultView.customElements.get(e.tagName) && r.defaultView.customElements.define(
          e.tagName,
          class extends r.defaultView.HTMLElement {
          }
        ), i = r.createElement(a))
      );
      const l = {};
      for (const c in e.attributes) {
        if (!Object.prototype.hasOwnProperty.call(e.attributes, c))
          continue;
        let u = e.attributes[c];
        if (a === "option" && c === "selected" && u === !1 || u === null)
          continue;
        if (u === !0 && (u = ""), c.startsWith("rr_")) {
          l[c] = u;
          continue;
        }
        const h = a === "textarea" && c === "value", p = a === "style" && c === "_cssText";
        if (p && n && typeof u == "string" && (u = Dn(u, o)), (h || p) && typeof u == "string") {
          i.appendChild(r.createTextNode(u)), e.childNodes = [];
          continue;
        }
        try {
          if (e.isSVG && c === "xlink:href")
            i.setAttributeNS(
              "http://www.w3.org/1999/xlink",
              c,
              u.toString()
            );
          else if (c === "onload" || c === "onclick" || c.substring(0, 7) === "onmouse")
            i.setAttribute("_" + c, u.toString());
          else if (a === "meta" && e.attributes["http-equiv"] === "Content-Security-Policy" && c === "content") {
            i.setAttribute("csp-content", u.toString());
            continue;
          } else a === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") && e.attributes.as === "script" || a === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && e.attributes.href.endsWith(".js") || (a === "img" && e.attributes.srcset && e.attributes.rr_dataURL ? i.setAttribute("original-srcset", e.attributes.srcset) : i.setAttribute(c, u.toString()));
        } catch {
        }
      }
      for (const c in l) {
        const u = l[c];
        if (a === "canvas" && c === "rr_dataURL") {
          const h = r.createElement("img");
          h.onload = () => {
            const p = i.getContext("2d");
            p && p.drawImage(h, 0, 0, h.width, h.height);
          }, h.src = u.toString(), i.RRNodeType && (i.rr_dataURL = u.toString());
        } else if (a === "img" && c === "rr_dataURL") {
          const h = i;
          h.currentSrc.startsWith("data:") || (h.setAttribute("original-src", e.attributes.src), h.src = u.toString());
        }
        if (c === "rr_width")
          i.style.width = u.toString();
        else if (c === "rr_height")
          i.style.height = u.toString();
        else if (c === "rr_mediaCurrentTime" && typeof u == "number")
          i.currentTime = u;
        else if (c === "rr_mediaState")
          switch (u) {
            case "played":
              i.play().catch((h) => console.warn("media playback error", h));
              break;
            case "paused":
              i.pause();
              break;
          }
        else c === "rr_mediaPlaybackRate" && typeof u == "number" ? i.playbackRate = u : c === "rr_mediaMuted" && typeof u == "boolean" ? i.muted = u : c === "rr_mediaLoop" && typeof u == "boolean" ? i.loop = u : c === "rr_mediaVolume" && typeof u == "number" && (i.volume = u);
      }
      if (e.isShadowHost)
        if (!i.shadowRoot)
          i.attachShadow({ mode: "open" });
        else
          for (; i.shadowRoot.firstChild; )
            i.shadowRoot.removeChild(i.shadowRoot.firstChild);
      return i;
    }
    case W.Text:
      return r.createTextNode(
        e.isStyle && n ? Dn(e.textContent, o) : e.textContent
      );
    case W.CDATA:
      return r.createCDATASection(e.textContent);
    case W.Comment:
      return r.createComment(e.textContent);
    default:
      return null;
  }
}
function ft(e, t) {
  const {
    doc: s,
    mirror: r,
    skipChild: n = !1,
    hackCss: o = !0,
    afterAppend: a,
    cache: i
  } = t;
  if (r.has(e.id)) {
    const c = r.getNode(e.id), u = r.getMeta(c);
    if (pl(u, e)) return r.getNode(e.id);
  }
  let l = au(e, { doc: s, hackCss: o, cache: i });
  if (!l)
    return null;
  if (e.rootId && r.getNode(e.rootId) !== s && r.replace(e.rootId, s), e.type === W.Document && (s.close(), s.open(), e.compatMode === "BackCompat" && e.childNodes && e.childNodes[0].type !== W.DocumentType && (e.childNodes[0].type === W.Element && "xmlns" in e.childNodes[0].attributes && e.childNodes[0].attributes.xmlns === "http://www.w3.org/1999/xhtml" ? s.write(
    '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">'
  ) : s.write(
    '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">'
  )), l = s), r.add(l, e), (e.type === W.Document || e.type === W.Element) && !n)
    for (const c of e.childNodes) {
      const u = ft(c, {
        doc: s,
        mirror: r,
        skipChild: !1,
        hackCss: o,
        afterAppend: a,
        cache: i
      });
      if (!u) {
        console.warn("Failed to rebuild", c);
        continue;
      }
      if (c.isShadow && ul(l) && l.shadowRoot)
        l.shadowRoot.appendChild(u);
      else if (e.type === W.Document && c.type == W.Element) {
        const h = u;
        let p = null;
        h.childNodes.forEach((y) => {
          y.nodeName === "BODY" && (p = y);
        }), p ? (h.removeChild(p), l.appendChild(u), h.appendChild(p)) : l.appendChild(u);
      } else
        l.appendChild(u);
      a && a(u, c.id);
    }
  return l;
}
function lu(e, t) {
  function s(r) {
    t(r);
  }
  for (const r of e.getIds())
    e.has(r) && s(e.getNode(r));
}
function cu(e, t) {
  const s = t.getMeta(e);
  if ((s == null ? void 0 : s.type) !== W.Element)
    return;
  const r = e;
  for (const n in s.attributes) {
    if (!(Object.prototype.hasOwnProperty.call(s.attributes, n) && n.startsWith("rr_")))
      continue;
    const o = s.attributes[n];
    n === "rr_scrollLeft" && (r.scrollLeft = o), n === "rr_scrollTop" && (r.scrollTop = o);
  }
}
function uu(e, t) {
  const {
    doc: s,
    onVisit: r,
    hackCss: n = !0,
    afterAppend: o,
    cache: a,
    mirror: i = new Bi()
  } = t, l = ft(e, {
    doc: s,
    mirror: i,
    skipChild: !1,
    hackCss: n,
    afterAppend: o,
    cache: a
  });
  return lu(i, (c) => {
    r && r(c), cu(c, i);
  }), l;
}
var Q = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e[e.Device = 24] = "Device", e[e.SailfishCustom = 25] = "SailfishCustom", e))(Q || {}), U = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e[e.Typing = 17] = "Typing", e))(U || {}), ee = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(ee || {}), os = /* @__PURE__ */ ((e) => (e[e["2D"] = 0] = "2D", e[e.WebGL = 1] = "WebGL", e[e.WebGL2 = 2] = "WebGL2", e))(os || {}), lr = /* @__PURE__ */ ((e) => (e[e.Play = 0] = "Play", e[e.Pause = 1] = "Pause", e[e.Seeked = 2] = "Seeked", e[e.VolumeChange = 3] = "VolumeChange", e[e.RateChange = 4] = "RateChange", e))(lr || {}), F = /* @__PURE__ */ ((e) => (e.Start = "start", e.Pause = "pause", e.Resume = "resume", e.Resize = "resize", e.Finish = "finish", e.FullsnapshotRebuilded = "fullsnapshot-rebuilded", e.LoadStylesheetStart = "load-stylesheet-start", e.LoadStylesheetEnd = "load-stylesheet-end", e.SkipStart = "skip-start", e.SkipEnd = "skip-end", e.MouseInteraction = "mouse-interaction", e.EventCast = "event-cast", e.CustomEvent = "custom-event", e.Flush = "flush", e.StateChange = "state-change", e.PlayBack = "play-back", e.Destroy = "destroy", e))(F || {});
const Be = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let On = {
  map: {},
  getId() {
    return console.error(Be), -1;
  },
  getNode() {
    return console.error(Be), null;
  },
  removeNodeFromMap() {
    console.error(Be);
  },
  has() {
    return console.error(Be), !1;
  },
  reset() {
    console.error(Be);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (On = new Proxy(On, {
  get(e, t, s) {
    return t === "map" && console.error(Be), Reflect.get(e, t, s);
  }
}));
Date.now().toString();
function hu(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...t) => {
    let s = t[0];
    if (!(0 in t))
      throw new TypeError("1 argument is required");
    do
      if (this === s)
        return !0;
    while (s = s && s.parentNode);
    return !1;
  });
}
function pu(e) {
  const t = {}, s = (n, o) => {
    const a = {
      value: n,
      parent: o,
      children: []
    };
    return t[n.node.id] = a, a;
  }, r = [];
  for (const n of e) {
    const { nextId: o, parentId: a } = n;
    if (o && o in t) {
      const i = t[o];
      if (i.parent) {
        const l = i.parent.children.indexOf(i);
        i.parent.children.splice(
          l,
          0,
          s(n, i.parent)
        );
      } else {
        const l = r.indexOf(i);
        r.splice(l, 0, s(n, null));
      }
      continue;
    }
    if (a in t) {
      const i = t[a];
      i.children.push(s(n, i));
      continue;
    }
    r.push(s(n, null));
  }
  return r;
}
function ko(e, t) {
  t(e.value);
  for (let s = e.children.length - 1; s >= 0; s--)
    ko(e.children[s], t);
}
function _s(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function Mo(e, t) {
  var s, r;
  const n = (r = (s = e.ownerDocument) == null ? void 0 : s.defaultView) == null ? void 0 : r.frameElement;
  if (!n || n === t)
    return {
      x: 0,
      y: 0,
      relativeScale: 1,
      absoluteScale: 1
    };
  const o = n.getBoundingClientRect(), a = Mo(n, t), i = o.height / n.clientHeight;
  return {
    x: o.x * a.relativeScale + a.x,
    y: o.y * a.relativeScale + a.y,
    relativeScale: i,
    absoluteScale: a.absoluteScale * i
  };
}
function Ut(e) {
  return !!(e != null && e.shadowRoot);
}
function ut(e, t) {
  const s = e[t[0]];
  return t.length === 1 ? s : ut(
    s.cssRules[t[1]].cssRules,
    t.slice(2)
  );
}
function An(e) {
  const t = [...e], s = t.pop();
  return { positions: t, index: s };
}
function du(e) {
  const t = /* @__PURE__ */ new Set(), s = [];
  for (let r = e.length; r--; ) {
    const n = e[r];
    t.has(n.id) || (s.push(n), t.add(n.id));
  }
  return s;
}
class fu {
  constructor() {
    M(this, "id", 1), M(this, "styleIDMap", /* @__PURE__ */ new WeakMap()), M(this, "idStyleMap", /* @__PURE__ */ new Map());
  }
  getId(t) {
    return this.styleIDMap.get(t) ?? -1;
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(t, s) {
    if (this.has(t)) return this.getId(t);
    let r;
    return s === void 0 ? r = this.id++ : r = s, this.styleIDMap.set(t, r), this.idStyleMap.set(r, t), r;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
const mu = "KGZ1bmN0aW9uKCl7InVzZSBzdHJpY3QiO2Zvcih2YXIgcj0iQUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5ejAxMjM0NTY3ODkrLyIsdz10eXBlb2YgVWludDhBcnJheT4idSI/W106bmV3IFVpbnQ4QXJyYXkoMjU2KSxpPTA7aTxyLmxlbmd0aDtpKyspd1tyLmNoYXJDb2RlQXQoaSldPWk7dmFyIHA9ZnVuY3Rpb24ocyl7dmFyIGU9bmV3IFVpbnQ4QXJyYXkocyksbixhPWUubGVuZ3RoLHQ9IiI7Zm9yKG49MDtuPGE7bis9Myl0Kz1yW2Vbbl0+PjJdLHQrPXJbKGVbbl0mMyk8PDR8ZVtuKzFdPj40XSx0Kz1yWyhlW24rMV0mMTUpPDwyfGVbbisyXT4+Nl0sdCs9cltlW24rMl0mNjNdO3JldHVybiBhJTM9PT0yP3Q9dC5zdWJzdHJpbmcoMCx0Lmxlbmd0aC0xKSsiPSI6YSUzPT09MSYmKHQ9dC5zdWJzdHJpbmcoMCx0Lmxlbmd0aC0yKSsiPT0iKSx0fTtjb25zdCBsPW5ldyBNYXAsYj1uZXcgTWFwO2FzeW5jIGZ1bmN0aW9uIHkocyxlLG4pe2NvbnN0IGE9YCR7c30tJHtlfWA7aWYoIk9mZnNjcmVlbkNhbnZhcyJpbiBnbG9iYWxUaGlzKXtpZihiLmhhcyhhKSlyZXR1cm4gYi5nZXQoYSk7Y29uc3QgdD1uZXcgT2Zmc2NyZWVuQ2FudmFzKHMsZSk7dC5nZXRDb250ZXh0KCIyZCIpO2NvbnN0IGc9YXdhaXQoYXdhaXQgdC5jb252ZXJ0VG9CbG9iKG4pKS5hcnJheUJ1ZmZlcigpLGM9cChnKTtyZXR1cm4gYi5zZXQoYSxjKSxjfWVsc2UgcmV0dXJuIiJ9Y29uc3Qgbz1zZWxmO28ub25tZXNzYWdlPWFzeW5jIGZ1bmN0aW9uKHMpe2lmKCJPZmZzY3JlZW5DYW52YXMiaW4gZ2xvYmFsVGhpcyl7Y29uc3R7aWQ6ZSxiaXRtYXA6bix3aWR0aDphLGhlaWdodDp0LGRhdGFVUkxPcHRpb25zOnV9PXMuZGF0YSxnPXkoYSx0LHUpLGM9bmV3IE9mZnNjcmVlbkNhbnZhcyhhLHQpO2MuZ2V0Q29udGV4dCgiMmQiKS5kcmF3SW1hZ2UobiwwLDApLG4uY2xvc2UoKTtjb25zdCBkPWF3YWl0IGMuY29udmVydFRvQmxvYih1KSx2PWQudHlwZSxoPWF3YWl0IGQuYXJyYXlCdWZmZXIoKSxmPXAoaCk7aWYoIWwuaGFzKGUpJiZhd2FpdCBnPT09ZilyZXR1cm4gbC5zZXQoZSxmKSxvLnBvc3RNZXNzYWdlKHtpZDplfSk7aWYobC5nZXQoZSk9PT1mKXJldHVybiBvLnBvc3RNZXNzYWdlKHtpZDplfSk7by5wb3N0TWVzc2FnZSh7aWQ6ZSx0eXBlOnYsYmFzZTY0OmYsd2lkdGg6YSxoZWlnaHQ6dH0pLGwuc2V0KGUsZil9ZWxzZSByZXR1cm4gby5wb3N0TWVzc2FnZSh7aWQ6cy5kYXRhLmlkfSl9fSkoKTsKLy8jIHNvdXJjZU1hcHBpbmdVUkw9aW1hZ2UtYml0bWFwLWRhdGEtdXJsLXdvcmtlci1Cb1hHVm1Zby5qcy5tYXAK", gu = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0));
typeof self < "u" && self.Blob && new Blob([gu(mu)], { type: "text/javascript;charset=utf-8" });
var In = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ht = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Bt = 0; Bt < In.length; Bt++)
  ht[In.charCodeAt(Bt)] = Bt;
var yu = function(e) {
  var t = e.length * 0.75, s = e.length, r, n = 0, o, a, i, l;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  var c = new ArrayBuffer(t), u = new Uint8Array(c);
  for (r = 0; r < s; r += 4)
    o = ht[e.charCodeAt(r)], a = ht[e.charCodeAt(r + 1)], i = ht[e.charCodeAt(r + 2)], l = ht[e.charCodeAt(r + 3)], u[n++] = o << 2 | a >> 4, u[n++] = (a & 15) << 4 | i >> 2, u[n++] = (i & 3) << 6 | l & 63;
  return c;
}, Pn;
try {
  if (Array.from([1], (e) => e * 2)[0] !== 2) {
    const e = document.createElement("iframe");
    document.body.appendChild(e), Array.from = ((Pn = e.contentWindow) == null ? void 0 : Pn.Array.from) || Array.from, document.body.removeChild(e);
  }
} catch (e) {
  console.debug("Unable to override Array.from", e);
}
zi();
var wu = Object.defineProperty, vu = (e, t, s) => t in e ? wu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, C = (e, t, s) => vu(e, typeof t != "symbol" ? t + "" : t, s), bu = Object.defineProperty, Su = (e, t, s) => t in e ? bu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, _n = (e, t, s) => Su(e, typeof t != "symbol" ? t + "" : t, s), O = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(O || {});
class xu {
  constructor() {
    _n(this, "idNodeMap", /* @__PURE__ */ new Map()), _n(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    var s;
    return t ? ((s = this.getMeta(t)) == null ? void 0 : s.id) ?? -1 : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const s = this.getId(t);
    this.idNodeMap.delete(s), t.childNodes && t.childNodes.forEach(
      (r) => this.removeNodeFromMap(r)
    );
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, s) {
    const r = s.id;
    this.idNodeMap.set(r, t), this.nodeMetaMap.set(t, s);
  }
  replace(t, s) {
    const r = this.getNode(t);
    if (r) {
      const n = this.nodeMetaMap.get(r);
      n && this.nodeMetaMap.set(s, n);
    }
    this.idNodeMap.set(t, s);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function Cu() {
  return new xu();
}
function Eu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ku(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var s = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    s.prototype = t.prototype;
  } else s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(s, r, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), s;
}
var Vr = { exports: {} }, R = String, No = function() {
  return { isColorSupported: !1, reset: R, bold: R, dim: R, italic: R, underline: R, inverse: R, hidden: R, strikethrough: R, black: R, red: R, green: R, yellow: R, blue: R, magenta: R, cyan: R, white: R, gray: R, bgBlack: R, bgRed: R, bgGreen: R, bgYellow: R, bgBlue: R, bgMagenta: R, bgCyan: R, bgWhite: R, blackBright: R, redBright: R, greenBright: R, yellowBright: R, blueBright: R, magentaBright: R, cyanBright: R, whiteBright: R, bgBlackBright: R, bgRedBright: R, bgGreenBright: R, bgYellowBright: R, bgBlueBright: R, bgMagentaBright: R, bgCyanBright: R, bgWhiteBright: R };
};
Vr.exports = No();
Vr.exports.createColors = No;
var Mu = Vr.exports;
const Nu = {}, Tu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nu
}, Symbol.toStringTag, { value: "Module" })), me = /* @__PURE__ */ ku(Tu);
let Fn = Mu, Ln = me, cr = class To extends Error {
  constructor(t, s, r, n, o, a) {
    super(t), this.name = "CssSyntaxError", this.reason = t, o && (this.file = o), n && (this.source = n), a && (this.plugin = a), typeof s < "u" && typeof r < "u" && (typeof s == "number" ? (this.line = s, this.column = r) : (this.line = s.line, this.column = s.column, this.endLine = r.line, this.endColumn = r.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, To);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(t) {
    if (!this.source) return "";
    let s = this.source;
    t == null && (t = Fn.isColorSupported);
    let r = (u) => u, n = (u) => u, o = (u) => u;
    if (t) {
      let { bold: u, gray: h, red: p } = Fn.createColors(!0);
      n = (y) => u(p(y)), r = (y) => h(y), Ln && (o = (y) => Ln(y));
    }
    let a = s.split(/\r?\n/), i = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, a.length), c = String(l).length;
    return a.slice(i, l).map((u, h) => {
      let p = i + 1 + h, y = " " + (" " + p).slice(-c) + " | ";
      if (p === this.line) {
        if (u.length > 160) {
          let d = 20, S = Math.max(0, this.column - d), f = Math.max(
            this.column + d,
            this.endColumn + d
          ), v = u.slice(S, f), w = r(y.replace(/\d/g, " ")) + u.slice(0, Math.min(this.column - 1, d - 1)).replace(/[^\t]/g, " ");
          return n(">") + r(y) + o(v) + `
 ` + w + n("^");
        }
        let g = r(y.replace(/\d/g, " ")) + u.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return n(">") + r(y) + o(u) + `
 ` + g + n("^");
      }
      return " " + r(y) + o(u);
    }).join(`
`);
  }
  toString() {
    let t = this.showSourceCode();
    return t && (t = `

` + t + `
`), this.name + ": " + this.message + t;
  }
};
var Yr = cr;
cr.default = cr;
const Un = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function Du(e) {
  return e[0].toUpperCase() + e.slice(1);
}
let ur = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let s = "@" + e.name, r = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName < "u" ? s += e.raws.afterName : r && (s += " "), e.nodes)
      this.block(e, s + r);
    else {
      let n = (e.raws.between || "") + (t ? ";" : "");
      this.builder(s + r + n, e);
    }
  }
  beforeAfter(e, t) {
    let s;
    e.type === "decl" ? s = this.raw(e, null, "beforeDecl") : e.type === "comment" ? s = this.raw(e, null, "beforeComment") : t === "before" ? s = this.raw(e, null, "beforeRule") : s = this.raw(e, null, "beforeClose");
    let r = e.parent, n = 0;
    for (; r && r.type !== "root"; )
      n += 1, r = r.parent;
    if (s.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let a = 0; a < n; a++) s += o;
    }
    return s;
  }
  block(e, t) {
    let s = this.raw(e, "between", "beforeOpen");
    this.builder(t + s + "{", e, "start");
    let r;
    e.nodes && e.nodes.length ? (this.body(e), r = this.raw(e, "after")) : r = this.raw(e, "after", "emptyBody"), r && this.builder(r), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let s = this.raw(e, "semicolon");
    for (let r = 0; r < e.nodes.length; r++) {
      let n = e.nodes[r], o = this.raw(n, "before");
      o && this.builder(o), this.stringify(n, t !== r || s);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), s = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + s + "*/", e);
  }
  decl(e, t) {
    let s = this.raw(e, "between", "colon"), r = e.prop + s + this.rawValue(e, "value");
    e.important && (r += e.raws.important || " !important"), t && (r += ";"), this.builder(r, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, s) {
    let r;
    if (s || (s = t), t && (r = e.raws[t], typeof r < "u"))
      return r;
    let n = e.parent;
    if (s === "before" && (!n || n.type === "root" && n.first === e || n && n.type === "document"))
      return "";
    if (!n) return Un[s];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[s] < "u")
      return o.rawCache[s];
    if (s === "before" || s === "after")
      return this.beforeAfter(e, s);
    {
      let a = "raw" + Du(s);
      this[a] ? r = this[a](o, e) : o.walk((i) => {
        if (r = i.raws[t], typeof r < "u") return !1;
      });
    }
    return typeof r > "u" && (r = Un[s]), o.rawCache[s] = r, r;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && s.nodes.length > 0 && typeof s.raws.after < "u")
        return t = s.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let s;
    return e.walkComments((r) => {
      if (typeof r.raws.before < "u")
        return s = r.raws.before, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
    }), typeof s > "u" ? s = this.raw(t, null, "beforeDecl") : s && (s = s.replace(/\S/g, "")), s;
  }
  rawBeforeDecl(e, t) {
    let s;
    return e.walkDecls((r) => {
      if (typeof r.raws.before < "u")
        return s = r.raws.before, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
    }), typeof s > "u" ? s = this.raw(t, null, "beforeRule") : s && (s = s.replace(/\S/g, "")), s;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((s) => {
      if (s.type !== "decl" && (t = s.raws.between, typeof t < "u"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && (s.parent !== e || e.first !== s) && typeof s.raws.before < "u")
        return t = s.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((s) => {
      if (typeof s.raws.between < "u")
        return t = s.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && s.nodes.length === 0 && (t = s.raws.after, typeof t < "u"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((s) => {
      let r = s.parent;
      if (r && r !== e && r.parent && r.parent === e && typeof s.raws.before < "u") {
        let n = s.raws.before.split(`
`);
        return t = n[n.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((s) => {
      if (s.nodes && s.nodes.length && s.last.type === "decl" && (t = s.raws.semicolon, typeof t < "u"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let s = e[t], r = e.raws[t];
    return r && r.value === s ? r.raw : s;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var Do = ur;
ur.default = ur;
let Ru = Do;
function hr(e, t) {
  new Ru(t).stringify(e);
}
var bs = hr;
hr.default = hr;
var Tt = {};
Tt.isClean = Symbol("isClean");
Tt.my = Symbol("my");
let Ou = Yr, Au = Do, Iu = bs, { isClean: it, my: Pu } = Tt;
function pr(e, t) {
  let s = new e.constructor();
  for (let r in e) {
    if (!Object.prototype.hasOwnProperty.call(e, r) || r === "proxyCache") continue;
    let n = e[r], o = typeof n;
    r === "parent" && o === "object" ? t && (s[r] = t) : r === "source" ? s[r] = n : Array.isArray(n) ? s[r] = n.map((a) => pr(a, s)) : (o === "object" && n !== null && (n = pr(n)), s[r] = n);
  }
  return s;
}
function ot(e, t) {
  if (t && typeof t.offset < "u")
    return t.offset;
  let s = 1, r = 1, n = 0;
  for (let o = 0; o < e.length; o++) {
    if (r === t.line && s === t.column) {
      n = o;
      break;
    }
    e[o] === `
` ? (s = 1, r += 1) : s += 1;
  }
  return n;
}
let dr = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[it] = !1, this[Pu] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let s of e[t])
          typeof s.clone == "function" ? this.append(s.clone()) : this.append(s);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = pr(this);
    for (let s in e)
      t[s] = e[s];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: s, start: r } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: r.column, line: r.line },
        { column: s.column, line: s.line },
        t
      );
    }
    return new Ou(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, s) {
        return e[t] === s || (e[t] = s, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[it] = !0;
  }
  markDirty() {
    if (this[it]) {
      this[it] = !1;
      let e = this;
      for (; e = e.parent; )
        e[it] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let s = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = s.slice(
        ot(s, this.source.start),
        ot(s, this.source.end)
      ).indexOf(e.word);
      r !== -1 && (t = this.positionInside(r));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, s = this.source.start.line, r = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = ot(r, this.source.start), o = n + e;
    for (let a = n; a < o; a++)
      r[a] === `
` ? (t = 1, s += 1) : t += 1;
    return { column: t, line: s };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, s = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let r = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = r.slice(
        ot(r, this.source.start),
        ot(r, this.source.end)
      ).indexOf(e.word);
      n !== -1 && (t = this.positionInside(n), s = this.positionInside(
        n + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? s = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? s = this.positionInside(e.endIndex) : e.index && (s = this.positionInside(e.index + 1));
    return (s.line < t.line || s.line === t.line && s.column <= t.column) && (s = { column: t.column + 1, line: t.line }), { end: s, start: t };
  }
  raw(e, t) {
    return new Au().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, s = !1;
      for (let r of e)
        r === this ? s = !0 : s ? (this.parent.insertAfter(t, r), t = r) : this.parent.insertBefore(t, r);
      s || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let s = {}, r = t == null;
    t = t || /* @__PURE__ */ new Map();
    let n = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let a = this[o];
      if (Array.isArray(a))
        s[o] = a.map((i) => typeof i == "object" && i.toJSON ? i.toJSON(null, t) : i);
      else if (typeof a == "object" && a.toJSON)
        s[o] = a.toJSON(null, t);
      else if (o === "source") {
        let i = t.get(a.input);
        i == null && (i = n, t.set(a.input, n), n++), s[o] = {
          end: a.end,
          inputId: i,
          start: a.start
        };
      } else
        s[o] = a;
    }
    return r && (s.inputs = [...t.keys()].map((o) => o.toJSON())), s;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = Iu) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (s) => {
      t += s;
    }), t;
  }
  warn(e, t, s) {
    let r = { node: this };
    for (let n in s) r[n] = s[n];
    return e.warn(t, r);
  }
};
var Ss = dr;
dr.default = dr;
let _u = Ss, fr = class extends _u {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var xs = fr;
fr.default = fr;
let Fu = Ss, mr = class extends Fu {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value < "u" && typeof e.value != "string" && (e = { ...e, value: String(e.value) }), super(e), this.type = "decl";
  }
};
var Cs = mr;
mr.default = mr;
let Ro = xs, Oo = Cs, Lu = Ss, { isClean: Ao, my: Io } = Tt, Gr, Po, _o, Zr;
function Fo(e) {
  return e.map((t) => (t.nodes && (t.nodes = Fo(t.nodes)), delete t.source, t));
}
function Lo(e) {
  if (e[Ao] = !1, e.proxyOf.nodes)
    for (let t of e.proxyOf.nodes)
      Lo(t);
}
let ke = class Uo extends Lu {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...t) {
    for (let s of t) {
      let r = this.normalize(s, this.last);
      for (let n of r) this.proxyOf.nodes.push(n);
    }
    return this.markDirty(), this;
  }
  cleanRaws(t) {
    if (super.cleanRaws(t), this.nodes)
      for (let s of this.nodes) s.cleanRaws(t);
  }
  each(t) {
    if (!this.proxyOf.nodes) return;
    let s = this.getIterator(), r, n;
    for (; this.indexes[s] < this.proxyOf.nodes.length && (r = this.indexes[s], n = t(this.proxyOf.nodes[r], r), n !== !1); )
      this.indexes[s] += 1;
    return delete this.indexes[s], n;
  }
  every(t) {
    return this.nodes.every(t);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let t = this.lastEach;
    return this.indexes[t] = 0, t;
  }
  getProxyProcessor() {
    return {
      get(t, s) {
        return s === "proxyOf" ? t : t[s] ? s === "each" || typeof s == "string" && s.startsWith("walk") ? (...r) => t[s](
          ...r.map((n) => typeof n == "function" ? (o, a) => n(o.toProxy(), a) : n)
        ) : s === "every" || s === "some" ? (r) => t[s](
          (n, ...o) => r(n.toProxy(), ...o)
        ) : s === "root" ? () => t.root().toProxy() : s === "nodes" ? t.nodes.map((r) => r.toProxy()) : s === "first" || s === "last" ? t[s].toProxy() : t[s] : t[s];
      },
      set(t, s, r) {
        return t[s] === r || (t[s] = r, (s === "name" || s === "params" || s === "selector") && t.markDirty()), !0;
      }
    };
  }
  index(t) {
    return typeof t == "number" ? t : (t.proxyOf && (t = t.proxyOf), this.proxyOf.nodes.indexOf(t));
  }
  insertAfter(t, s) {
    let r = this.index(t), n = this.normalize(s, this.proxyOf.nodes[r]).reverse();
    r = this.index(t);
    for (let a of n) this.proxyOf.nodes.splice(r + 1, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], r < o && (this.indexes[a] = o + n.length);
    return this.markDirty(), this;
  }
  insertBefore(t, s) {
    let r = this.index(t), n = r === 0 ? "prepend" : !1, o = this.normalize(
      s,
      this.proxyOf.nodes[r],
      n
    ).reverse();
    r = this.index(t);
    for (let i of o) this.proxyOf.nodes.splice(r, 0, i);
    let a;
    for (let i in this.indexes)
      a = this.indexes[i], r <= a && (this.indexes[i] = a + o.length);
    return this.markDirty(), this;
  }
  normalize(t, s) {
    if (typeof t == "string")
      t = Fo(Po(t).nodes);
    else if (typeof t > "u")
      t = [];
    else if (Array.isArray(t)) {
      t = t.slice(0);
      for (let r of t)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (t.type === "root" && this.type !== "document") {
      t = t.nodes.slice(0);
      for (let r of t)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (t.type)
      t = [t];
    else if (t.prop) {
      if (typeof t.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof t.value != "string" && (t.value = String(t.value)), t = [new Oo(t)];
    } else if (t.selector || t.selectors)
      t = [new Zr(t)];
    else if (t.name)
      t = [new Gr(t)];
    else if (t.text)
      t = [new Ro(t)];
    else
      throw new Error("Unknown node type in node creation");
    return t.map((r) => (r[Io] || Uo.rebuild(r), r = r.proxyOf, r.parent && r.parent.removeChild(r), r[Ao] && Lo(r), r.raws || (r.raws = {}), typeof r.raws.before > "u" && s && typeof s.raws.before < "u" && (r.raws.before = s.raws.before.replace(/\S/g, "")), r.parent = this.proxyOf, r));
  }
  prepend(...t) {
    t = t.reverse();
    for (let s of t) {
      let r = this.normalize(s, this.first, "prepend").reverse();
      for (let n of r) this.proxyOf.nodes.unshift(n);
      for (let n in this.indexes)
        this.indexes[n] = this.indexes[n] + r.length;
    }
    return this.markDirty(), this;
  }
  push(t) {
    return t.parent = this, this.proxyOf.nodes.push(t), this;
  }
  removeAll() {
    for (let t of this.proxyOf.nodes) t.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(t) {
    t = this.index(t), this.proxyOf.nodes[t].parent = void 0, this.proxyOf.nodes.splice(t, 1);
    let s;
    for (let r in this.indexes)
      s = this.indexes[r], s >= t && (this.indexes[r] = s - 1);
    return this.markDirty(), this;
  }
  replaceValues(t, s, r) {
    return r || (r = s, s = {}), this.walkDecls((n) => {
      s.props && !s.props.includes(n.prop) || s.fast && !n.value.includes(s.fast) || (n.value = n.value.replace(t, r));
    }), this.markDirty(), this;
  }
  some(t) {
    return this.nodes.some(t);
  }
  walk(t) {
    return this.each((s, r) => {
      let n;
      try {
        n = t(s, r);
      } catch (o) {
        throw s.addToError(o);
      }
      return n !== !1 && s.walk && (n = s.walk(t)), n;
    });
  }
  walkAtRules(t, s) {
    return s ? t instanceof RegExp ? this.walk((r, n) => {
      if (r.type === "atrule" && t.test(r.name))
        return s(r, n);
    }) : this.walk((r, n) => {
      if (r.type === "atrule" && r.name === t)
        return s(r, n);
    }) : (s = t, this.walk((r, n) => {
      if (r.type === "atrule")
        return s(r, n);
    }));
  }
  walkComments(t) {
    return this.walk((s, r) => {
      if (s.type === "comment")
        return t(s, r);
    });
  }
  walkDecls(t, s) {
    return s ? t instanceof RegExp ? this.walk((r, n) => {
      if (r.type === "decl" && t.test(r.prop))
        return s(r, n);
    }) : this.walk((r, n) => {
      if (r.type === "decl" && r.prop === t)
        return s(r, n);
    }) : (s = t, this.walk((r, n) => {
      if (r.type === "decl")
        return s(r, n);
    }));
  }
  walkRules(t, s) {
    return s ? t instanceof RegExp ? this.walk((r, n) => {
      if (r.type === "rule" && t.test(r.selector))
        return s(r, n);
    }) : this.walk((r, n) => {
      if (r.type === "rule" && r.selector === t)
        return s(r, n);
    }) : (s = t, this.walk((r, n) => {
      if (r.type === "rule")
        return s(r, n);
    }));
  }
};
ke.registerParse = (e) => {
  Po = e;
};
ke.registerRule = (e) => {
  Zr = e;
};
ke.registerAtRule = (e) => {
  Gr = e;
};
ke.registerRoot = (e) => {
  _o = e;
};
var _e = ke;
ke.default = ke;
ke.rebuild = (e) => {
  e.type === "atrule" ? Object.setPrototypeOf(e, Gr.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, Zr.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, Oo.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, Ro.prototype) : e.type === "root" && Object.setPrototypeOf(e, _o.prototype), e[Io] = !0, e.nodes && e.nodes.forEach((t) => {
    ke.rebuild(t);
  });
};
let Bo = _e, as = class extends Bo {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var Xr = as;
as.default = as;
Bo.registerAtRule(as);
let Uu = _e, zo, jo, St = class extends Uu {
  constructor(e) {
    super({ type: "document", ...e }), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new zo(new jo(), this, e).stringify();
  }
};
St.registerLazyResult = (e) => {
  zo = e;
};
St.registerProcessor = (e) => {
  jo = e;
};
var Hr = St;
St.default = St;
let Bu = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", zu = (e = 21) => {
  let t = "", s = e | 0;
  for (; s--; )
    t += Bu[Math.random() * 64 | 0];
  return t;
};
var ju = { nanoid: zu };
let { existsSync: Wu, readFileSync: Vu } = me, { dirname: Fs, join: Yu } = me, { SourceMapConsumer: Bn, SourceMapGenerator: zn } = me;
function Gu(e) {
  return Buffer ? Buffer.from(e, "base64").toString() : window.atob(e);
}
let gr = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let s = t.map ? t.map.prev : void 0, r = this.loadMap(t.from, s);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = Fs(this.mapFile)), r && (this.text = r);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new Bn(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, s = /^data:application\/json;base64,/, r = /^data:application\/json;charset=utf-?8,/, n = /^data:application\/json,/, o = e.match(r) || e.match(n);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let a = e.match(t) || e.match(s);
    if (a)
      return Gu(e.substr(a[0].length));
    let i = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + i);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let s = e.lastIndexOf(t.pop()), r = e.indexOf("*/", s);
    s > -1 && r > -1 && (this.annotation = this.getAnnotationURL(e.substring(s, r)));
  }
  loadFile(e) {
    if (this.root = Fs(e), Wu(e))
      return this.mapFile = e, Vu(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let s = t(e);
        if (s) {
          let r = this.loadFile(s);
          if (!r)
            throw new Error(
              "Unable to load previous source map: " + s.toString()
            );
          return r;
        }
      } else {
        if (t instanceof Bn)
          return zn.fromSourceMap(t).toString();
        if (t instanceof zn)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let s = this.annotation;
        return e && (s = Yu(Fs(e), s)), this.loadFile(s);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Wo = gr;
gr.default = gr;
let { nanoid: Zu } = ju, { isAbsolute: yr, resolve: wr } = me, { SourceMapConsumer: Xu, SourceMapGenerator: Hu } = me, { fileURLToPath: jn, pathToFileURL: zt } = me, Wn = Yr, Ju = Wo, Ls = me, Us = Symbol("fromOffsetCache"), Qu = !!(Xu && Hu), Vn = !!(wr && yr), ls = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e > "u" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!Vn || /^\w+:\/\//.test(t.from) || yr(t.from) ? this.file = t.from : this.file = wr(t.from)), Vn && Qu) {
      let s = new Ju(this.css, t);
      if (s.text) {
        this.map = s;
        let r = s.consumer().file;
        !this.file && r && (this.file = this.mapResolve(r));
      }
    }
    this.file || (this.id = "<input css " + Zu(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, s, r = {}) {
    let n, o, a;
    if (t && typeof t == "object") {
      let l = t, c = s;
      if (typeof l.offset == "number") {
        let u = this.fromOffset(l.offset);
        t = u.line, s = u.col;
      } else
        t = l.line, s = l.column;
      if (typeof c.offset == "number") {
        let u = this.fromOffset(c.offset);
        o = u.line, n = u.col;
      } else
        o = c.line, n = c.column;
    } else if (!s) {
      let l = this.fromOffset(t);
      t = l.line, s = l.col;
    }
    let i = this.origin(t, s, o, n);
    return i ? a = new Wn(
      e,
      i.endLine === void 0 ? i.line : { column: i.column, line: i.line },
      i.endLine === void 0 ? i.column : { column: i.endColumn, line: i.endLine },
      i.source,
      i.file,
      r.plugin
    ) : a = new Wn(
      e,
      o === void 0 ? t : { column: s, line: t },
      o === void 0 ? s : { column: n, line: o },
      this.css,
      this.file,
      r.plugin
    ), a.input = { column: s, endColumn: n, endLine: o, line: t, source: this.css }, this.file && (zt && (a.input.url = zt(this.file).toString()), a.input.file = this.file), a;
  }
  fromOffset(e) {
    let t, s;
    if (this[Us])
      s = this[Us];
    else {
      let n = this.css.split(`
`);
      s = new Array(n.length);
      let o = 0;
      for (let a = 0, i = n.length; a < i; a++)
        s[a] = o, o += n[a].length + 1;
      this[Us] = s;
    }
    t = s[s.length - 1];
    let r = 0;
    if (e >= t)
      r = s.length - 1;
    else {
      let n = s.length - 2, o;
      for (; r < n; )
        if (o = r + (n - r >> 1), e < s[o])
          n = o - 1;
        else if (e >= s[o + 1])
          r = o + 1;
        else {
          r = o;
          break;
        }
    }
    return {
      col: e - s[r] + 1,
      line: r + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : wr(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, s, r) {
    if (!this.map) return !1;
    let n = this.map.consumer(), o = n.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let a;
    typeof s == "number" && (a = n.originalPositionFor({ column: r, line: s }));
    let i;
    yr(o.source) ? i = zt(o.source) : i = new URL(
      o.source,
      this.map.consumer().sourceRoot || zt(this.map.mapFile)
    );
    let l = {
      column: o.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: o.line,
      url: i.toString()
    };
    if (i.protocol === "file:")
      if (jn)
        l.file = jn(i);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let c = n.sourceContentFor(o.source);
    return c && (l.source = c), l;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = { ...this.map }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var Es = ls;
ls.default = ls;
Ls && Ls.registerInput && Ls.registerInput(ls);
let Vo = _e, Yo, Go, Qe = class extends Vo {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, s) {
    let r = super.normalize(e);
    if (t) {
      if (s === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let n of r)
          n.raws.before = t.raws.before;
    }
    return r;
  }
  removeChild(e, t) {
    let s = this.index(e);
    return !t && s === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[s].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new Yo(new Go(), this, e).stringify();
  }
};
Qe.registerLazyResult = (e) => {
  Yo = e;
};
Qe.registerProcessor = (e) => {
  Go = e;
};
var Dt = Qe;
Qe.default = Qe;
Vo.registerRoot(Qe);
let xt = {
  comma(e) {
    return xt.split(e, [","], !0);
  },
  space(e) {
    let t = [" ", `
`, "	"];
    return xt.split(e, t);
  },
  split(e, t, s) {
    let r = [], n = "", o = !1, a = 0, i = !1, l = "", c = !1;
    for (let u of e)
      c ? c = !1 : u === "\\" ? c = !0 : i ? u === l && (i = !1) : u === '"' || u === "'" ? (i = !0, l = u) : u === "(" ? a += 1 : u === ")" ? a > 0 && (a -= 1) : a === 0 && t.includes(u) && (o = !0), o ? (n !== "" && r.push(n.trim()), n = "", o = !1) : n += u;
    return (s || n !== "") && r.push(n.trim()), r;
  }
};
var Zo = xt;
xt.default = xt;
let Xo = _e, Ku = Zo, cs = class extends Xo {
  get selectors() {
    return Ku.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, s = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(s);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var Jr = cs;
cs.default = cs;
Xo.registerRule(cs);
let qu = Xr, $u = xs, eh = Cs, th = Es, sh = Wo, rh = Dt, nh = Jr;
function Ct(e, t) {
  if (Array.isArray(e)) return e.map((n) => Ct(n));
  let { inputs: s, ...r } = e;
  if (s) {
    t = [];
    for (let n of s) {
      let o = { ...n, __proto__: th.prototype };
      o.map && (o.map = {
        ...o.map,
        __proto__: sh.prototype
      }), t.push(o);
    }
  }
  if (r.nodes && (r.nodes = e.nodes.map((n) => Ct(n, t))), r.source) {
    let { inputId: n, ...o } = r.source;
    r.source = o, n != null && (r.source.input = t[n]);
  }
  if (r.type === "root")
    return new rh(r);
  if (r.type === "decl")
    return new eh(r);
  if (r.type === "rule")
    return new nh(r);
  if (r.type === "comment")
    return new $u(r);
  if (r.type === "atrule")
    return new qu(r);
  throw new Error("Unknown node type: " + e.type);
}
var ih = Ct;
Ct.default = Ct;
let { dirname: qt, relative: Ho, resolve: Jo, sep: Qo } = me, { SourceMapConsumer: Ko, SourceMapGenerator: $t } = me, { pathToFileURL: Yn } = me, oh = Es, ah = !!(Ko && $t), lh = !!(qt && Jo && Ho && Qo), ch = class {
  constructor(e, t, s, r) {
    this.stringify = e, this.mapOpts = s.map || {}, this.root = t, this.opts = s, this.css = r, this.originalCSS = r, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), s = e.root || qt(e.file), r;
      this.mapOpts.sourcesContent === !1 ? (r = new Ko(e.text), r.sourcesContent && (r.sourcesContent = null)) : r = e.consumer(), this.map.applySourceMap(r, t, this.toUrl(this.path(s)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), lh && ah && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = $t.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new $t({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new $t({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, s = "<no source>", r = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, n, o;
    this.stringify(this.root, (a, i, l) => {
      if (this.css += a, i && l !== "end" && (r.generated.line = e, r.generated.column = t - 1, i.source && i.source.start ? (r.source = this.sourcePath(i), r.original.line = i.source.start.line, r.original.column = i.source.start.column - 1, this.map.addMapping(r)) : (r.source = s, r.original.line = 1, r.original.column = 0, this.map.addMapping(r))), o = a.match(/\n/g), o ? (e += o.length, n = a.lastIndexOf(`
`), t = a.length - n) : t += a.length, i && l !== "start") {
        let c = i.parent || { raws: {} };
        (!(i.type === "decl" || i.type === "atrule" && !i.nodes) || i !== c.last || c.raws.semicolon) && (i.source && i.source.end ? (r.source = this.sourcePath(i), r.original.line = i.source.end.line, r.original.column = i.source.end.column - 1, r.generated.line = e, r.generated.column = t - 2, this.map.addMapping(r)) : (r.source = s, r.original.line = 1, r.original.column = 0, r.generated.line = e, r.generated.column = t - 1, this.map.addMapping(r)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let s = this.opts.to ? qt(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (s = qt(Jo(s, this.mapOpts.annotation)));
    let r = Ho(s, e);
    return this.memoizedPaths.set(e, r), r;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new oh(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let s = t.source.input.from;
          if (s && !e[s]) {
            e[s] = !0;
            let r = this.usesFileUrls ? this.toFileUrl(s) : this.toUrl(this.path(s));
            this.map.setSourceContent(r, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (Yn) {
      let s = Yn(e).toString();
      return this.memoizedFileURLs.set(e, s), s;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    Qo === "\\" && (e = e.replace(/\\/g, "/"));
    let s = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, s), s;
  }
};
var qo = ch;
const Bs = 39, Gn = 34, jt = 92, Zn = 47, Wt = 10, at = 32, Vt = 12, Yt = 9, Gt = 13, uh = 91, hh = 93, ph = 40, dh = 41, fh = 123, mh = 125, gh = 59, yh = 42, wh = 58, vh = 64, Zt = /[\t\n\f\r "#'()/;[\\\]{}]/g, Xt = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, bh = /.[\r\n"'(/\\]/, Xn = /[\da-f]/i;
var Sh = function(e, t = {}) {
  let s = e.css.valueOf(), r = t.ignoreErrors, n, o, a, i, l, c, u, h, p, y, g = s.length, d = 0, S = [], f = [];
  function v() {
    return d;
  }
  function w(_) {
    throw e.error("Unclosed " + _, d);
  }
  function k() {
    return f.length === 0 && d >= g;
  }
  function E(_) {
    if (f.length) return f.pop();
    if (d >= g) return;
    let Y = _ ? _.ignoreUnclosed : !1;
    switch (n = s.charCodeAt(d), n) {
      case Wt:
      case at:
      case Yt:
      case Gt:
      case Vt: {
        i = d;
        do
          i += 1, n = s.charCodeAt(i);
        while (n === at || n === Wt || n === Yt || n === Gt || n === Vt);
        c = ["space", s.slice(d, i)], d = i - 1;
        break;
      }
      case uh:
      case hh:
      case fh:
      case mh:
      case wh:
      case gh:
      case dh: {
        let q = String.fromCharCode(n);
        c = [q, q, d];
        break;
      }
      case ph: {
        if (y = S.length ? S.pop()[1] : "", p = s.charCodeAt(d + 1), y === "url" && p !== Bs && p !== Gn && p !== at && p !== Wt && p !== Yt && p !== Vt && p !== Gt) {
          i = d;
          do {
            if (u = !1, i = s.indexOf(")", i + 1), i === -1)
              if (r || Y) {
                i = d;
                break;
              } else
                w("bracket");
            for (h = i; s.charCodeAt(h - 1) === jt; )
              h -= 1, u = !u;
          } while (u);
          c = ["brackets", s.slice(d, i + 1), d, i], d = i;
        } else
          i = s.indexOf(")", d + 1), o = s.slice(d, i + 1), i === -1 || bh.test(o) ? c = ["(", "(", d] : (c = ["brackets", o, d, i], d = i);
        break;
      }
      case Bs:
      case Gn: {
        l = n === Bs ? "'" : '"', i = d;
        do {
          if (u = !1, i = s.indexOf(l, i + 1), i === -1)
            if (r || Y) {
              i = d + 1;
              break;
            } else
              w("string");
          for (h = i; s.charCodeAt(h - 1) === jt; )
            h -= 1, u = !u;
        } while (u);
        c = ["string", s.slice(d, i + 1), d, i], d = i;
        break;
      }
      case vh: {
        Zt.lastIndex = d + 1, Zt.test(s), Zt.lastIndex === 0 ? i = s.length - 1 : i = Zt.lastIndex - 2, c = ["at-word", s.slice(d, i + 1), d, i], d = i;
        break;
      }
      case jt: {
        for (i = d, a = !0; s.charCodeAt(i + 1) === jt; )
          i += 1, a = !a;
        if (n = s.charCodeAt(i + 1), a && n !== Zn && n !== at && n !== Wt && n !== Yt && n !== Gt && n !== Vt && (i += 1, Xn.test(s.charAt(i)))) {
          for (; Xn.test(s.charAt(i + 1)); )
            i += 1;
          s.charCodeAt(i + 1) === at && (i += 1);
        }
        c = ["word", s.slice(d, i + 1), d, i], d = i;
        break;
      }
      default: {
        n === Zn && s.charCodeAt(d + 1) === yh ? (i = s.indexOf("*/", d + 2) + 1, i === 0 && (r || Y ? i = s.length : w("comment")), c = ["comment", s.slice(d, i + 1), d, i], d = i) : (Xt.lastIndex = d + 1, Xt.test(s), Xt.lastIndex === 0 ? i = s.length - 1 : i = Xt.lastIndex - 2, c = ["word", s.slice(d, i + 1), d, i], S.push(c), d = i);
        break;
      }
    }
    return d++, c;
  }
  function A(_) {
    f.push(_);
  }
  return {
    back: A,
    endOfFile: k,
    nextToken: E,
    position: v
  };
};
let xh = Xr, Ch = xs, Eh = Cs, kh = Dt, Hn = Jr, Mh = Sh;
const Jn = {
  empty: !0,
  space: !0
};
function Nh(e) {
  for (let t = e.length - 1; t >= 0; t--) {
    let s = e[t], r = s[3] || s[2];
    if (r) return r;
  }
}
let Th = class {
  constructor(e) {
    this.input = e, this.root = new kh(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new xh();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let s, r, n, o = !1, a = !1, i = [], l = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), s = e[0], s === "(" || s === "[" ? l.push(s === "(" ? ")" : "]") : s === "{" && l.length > 0 ? l.push("}") : s === l[l.length - 1] && l.pop(), l.length === 0)
        if (s === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (s === "{") {
          a = !0;
          break;
        } else if (s === "}") {
          if (i.length > 0) {
            for (n = i.length - 1, r = i[n]; r && r[0] === "space"; )
              r = i[--n];
            r && (t.source.end = this.getPosition(r[3] || r[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          i.push(e);
      else
        i.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(i), i.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(i), this.raw(t, "params", i), o && (e = i[i.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let s = 0, r;
    for (let n = t - 1; n >= 0 && (r = e[n], !(r[0] !== "space" && (s += 1, s === 2))); n--)
      ;
    throw this.input.error(
      "Missed semicolon",
      r[0] === "word" ? r[3] + 1 : r[2]
    );
  }
  colon(e) {
    let t = 0, s, r, n;
    for (let [o, a] of e.entries()) {
      if (r = a, n = r[0], n === "(" && (t += 1), n === ")" && (t -= 1), t === 0 && n === ":")
        if (!s)
          this.doubleColon(r);
        else {
          if (s[0] === "word" && s[1] === "progid")
            continue;
          return o;
        }
      s = r;
    }
    return !1;
  }
  comment(e) {
    let t = new Ch();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let s = e[1].slice(2, -2);
    if (/^\s*$/.test(s))
      t.text = "", t.raws.left = s, t.raws.right = "";
    else {
      let r = s.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = r[2], t.raws.left = r[1], t.raws.right = r[3];
    }
  }
  createTokenizer() {
    this.tokenizer = Mh(this.input);
  }
  decl(e, t) {
    let s = new Eh();
    this.init(s, e[0][2]);
    let r = e[e.length - 1];
    for (r[0] === ";" && (this.semicolon = !0, e.pop()), s.source.end = this.getPosition(
      r[3] || r[2] || Nh(e)
    ), s.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), s.raws.before += e.shift()[1];
    for (s.source.start = this.getPosition(e[0][2]), s.prop = ""; e.length; ) {
      let i = e[0][0];
      if (i === ":" || i === "space" || i === "comment")
        break;
      s.prop += e.shift()[1];
    }
    s.raws.between = "";
    let n;
    for (; e.length; )
      if (n = e.shift(), n[0] === ":") {
        s.raws.between += n[1];
        break;
      } else
        n[0] === "word" && /\w/.test(n[1]) && this.unknownWord([n]), s.raws.between += n[1];
    (s.prop[0] === "_" || s.prop[0] === "*") && (s.raws.before += s.prop[0], s.prop = s.prop.slice(1));
    let o = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let i = e.length - 1; i >= 0; i--) {
      if (n = e[i], n[1].toLowerCase() === "!important") {
        s.important = !0;
        let l = this.stringFrom(e, i);
        l = this.spacesFromEnd(e) + l, l !== " !important" && (s.raws.important = l);
        break;
      } else if (n[1].toLowerCase() === "important") {
        let l = e.slice(0), c = "";
        for (let u = i; u > 0; u--) {
          let h = l[u][0];
          if (c.trim().startsWith("!") && h !== "space")
            break;
          c = l.pop()[1] + c;
        }
        c.trim().startsWith("!") && (s.important = !0, s.raws.important = c, e = l);
      }
      if (n[0] !== "space" && n[0] !== "comment")
        break;
    }
    e.some((i) => i[0] !== "space" && i[0] !== "comment") && (s.raws.between += o.map((i) => i[1]).join(""), o = []), this.raw(s, "value", o.concat(e), t), s.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new Hn();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, s = null, r = !1, n = null, o = [], a = e[1].startsWith("--"), i = [], l = e;
    for (; l; ) {
      if (s = l[0], i.push(l), s === "(" || s === "[")
        n || (n = l), o.push(s === "(" ? ")" : "]");
      else if (a && r && s === "{")
        n || (n = l), o.push("}");
      else if (o.length === 0)
        if (s === ";")
          if (r) {
            this.decl(i, a);
            return;
          } else
            break;
        else if (s === "{") {
          this.rule(i);
          return;
        } else if (s === "}") {
          this.tokenizer.back(i.pop()), t = !0;
          break;
        } else s === ":" && (r = !0);
      else s === o[o.length - 1] && (o.pop(), o.length === 0 && (n = null));
      l = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(n), t && r) {
      if (!a)
        for (; i.length && (l = i[i.length - 1][0], !(l !== "space" && l !== "comment")); )
          this.tokenizer.back(i.pop());
      this.decl(i, a);
    } else
      this.unknownWord(i);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, s, r) {
    let n, o, a = s.length, i = "", l = !0, c, u;
    for (let h = 0; h < a; h += 1)
      n = s[h], o = n[0], o === "space" && h === a - 1 && !r ? l = !1 : o === "comment" ? (u = s[h - 1] ? s[h - 1][0] : "empty", c = s[h + 1] ? s[h + 1][0] : "empty", !Jn[u] && !Jn[c] ? i.slice(-1) === "," ? l = !1 : i += n[1] : l = !1) : i += n[1];
    if (!l) {
      let h = s.reduce((p, y) => p + y[1], "");
      e.raws[t] = { raw: h, value: i };
    }
    e[t] = i;
  }
  rule(e) {
    e.pop();
    let t = new Hn();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, s = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      s = e.pop()[1] + s;
    return s;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, s = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      s += e.shift()[1];
    return s;
  }
  spacesFromEnd(e) {
    let t, s = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      s = e.pop()[1] + s;
    return s;
  }
  stringFrom(e, t) {
    let s = "";
    for (let r = t; r < e.length; r++)
      s += e[r][1];
    return e.splice(t, e.length - t), s;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var Dh = Th;
let Rh = _e, Oh = Es, Ah = Dh;
function us(e, t) {
  let s = new Oh(e, t), r = new Ah(s);
  try {
    r.parse();
  } catch (n) {
    throw process.env.NODE_ENV !== "production" && n.name === "CssSyntaxError" && t && t.from && (/\.scss$/i.test(t.from) ? n.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(t.from) ? n.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(t.from) && (n.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), n;
  }
  return r.root;
}
var Qr = us;
us.default = us;
Rh.registerParse(us);
let vr = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let s = t.node.rangeBy(t);
      this.line = s.start.line, this.column = s.start.column, this.endLine = s.end.line, this.endColumn = s.end.column;
    }
    for (let s in t) this[s] = t[s];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var $o = vr;
vr.default = vr;
let Ih = $o, br = class {
  get content() {
    return this.css;
  }
  constructor(e, t, s) {
    this.processor = e, this.messages = [], this.root = t, this.opts = s, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let s = new Ih(e, t);
    return this.messages.push(s), s;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var Kr = br;
br.default = br;
let Qn = {};
var ea = function(e) {
  Qn[e] || (Qn[e] = !0, typeof console < "u" && console.warn && console.warn(e));
};
let Ph = _e, _h = Hr, Fh = qo, Lh = Qr, Kn = Kr, Uh = Dt, Bh = bs, { isClean: be, my: zh } = Tt, jh = ea;
const Wh = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, Vh = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, Yh = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, Ke = 0;
function lt(e) {
  return typeof e == "object" && typeof e.then == "function";
}
function ta(e) {
  let t = !1, s = Wh[e.type];
  return e.type === "decl" ? t = e.prop.toLowerCase() : e.type === "atrule" && (t = e.name.toLowerCase()), t && e.append ? [
    s,
    s + "-" + t,
    Ke,
    s + "Exit",
    s + "Exit-" + t
  ] : t ? [s, s + "-" + t, s + "Exit", s + "Exit-" + t] : e.append ? [s, Ke, s + "Exit"] : [s, s + "Exit"];
}
function qn(e) {
  let t;
  return e.type === "document" ? t = ["Document", Ke, "DocumentExit"] : e.type === "root" ? t = ["Root", Ke, "RootExit"] : t = ta(e), {
    eventIndex: 0,
    events: t,
    iterator: 0,
    node: e,
    visitorIndex: 0,
    visitors: []
  };
}
function Sr(e) {
  return e[be] = !1, e.nodes && e.nodes.forEach((t) => Sr(t)), e;
}
let xr = {}, qe = class sa {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(t, s, r) {
    this.stringified = !1, this.processed = !1;
    let n;
    if (typeof s == "object" && s !== null && (s.type === "root" || s.type === "document"))
      n = Sr(s);
    else if (s instanceof sa || s instanceof Kn)
      n = Sr(s.root), s.map && (typeof r.map > "u" && (r.map = {}), r.map.inline || (r.map.inline = !1), r.map.prev = s.map);
    else {
      let o = Lh;
      r.syntax && (o = r.syntax.parse), r.parser && (o = r.parser), o.parse && (o = o.parse);
      try {
        n = o(s, r);
      } catch (a) {
        this.processed = !0, this.error = a;
      }
      n && !n[zh] && Ph.rebuild(n);
    }
    this.result = new Kn(t, n, r), this.helpers = { ...xr, postcss: xr, result: this.result }, this.plugins = this.processor.plugins.map((o) => typeof o == "object" && o.prepare ? { ...o, ...o.prepare(this.result) } : o);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(t) {
    return this.async().catch(t);
  }
  finally(t) {
    return this.async().then(t, t);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(t, s) {
    let r = this.result.lastPlugin;
    try {
      if (s && s.addToError(t), this.error = t, t.name === "CssSyntaxError" && !t.plugin)
        t.plugin = r.postcssPlugin, t.setMessage();
      else if (r.postcssVersion && process.env.NODE_ENV !== "production") {
        let n = r.postcssPlugin, o = r.postcssVersion, a = this.result.processor.version, i = o.split("."), l = a.split(".");
        (i[0] !== l[0] || parseInt(i[1]) > parseInt(l[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + a + ", but " + n + " uses " + o + ". Perhaps this is the source of the error below."
        );
      }
    } catch (n) {
      console && console.error && console.error(n);
    }
    return t;
  }
  prepareVisitors() {
    this.listeners = {};
    let t = (s, r, n) => {
      this.listeners[r] || (this.listeners[r] = []), this.listeners[r].push([s, n]);
    };
    for (let s of this.plugins)
      if (typeof s == "object")
        for (let r in s) {
          if (!Vh[r] && /^[A-Z]/.test(r))
            throw new Error(
              `Unknown event ${r} in ${s.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!Yh[r])
            if (typeof s[r] == "object")
              for (let n in s[r])
                n === "*" ? t(s, r, s[r][n]) : t(
                  s,
                  r + "-" + n.toLowerCase(),
                  s[r][n]
                );
            else typeof s[r] == "function" && t(s, r, s[r]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let t = 0; t < this.plugins.length; t++) {
      let s = this.plugins[t], r = this.runOnRoot(s);
      if (lt(r))
        try {
          await r;
        } catch (n) {
          throw this.handleError(n);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[be]; ) {
        t[be] = !0;
        let s = [qn(t)];
        for (; s.length > 0; ) {
          let r = this.visitTick(s);
          if (lt(r))
            try {
              await r;
            } catch (n) {
              let o = s[s.length - 1].node;
              throw this.handleError(n, o);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [s, r] of this.listeners.OnceExit) {
          this.result.lastPlugin = s;
          try {
            if (t.type === "document") {
              let n = t.nodes.map(
                (o) => r(o, this.helpers)
              );
              await Promise.all(n);
            } else
              await r(t, this.helpers);
          } catch (n) {
            throw this.handleError(n);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(t) {
    this.result.lastPlugin = t;
    try {
      if (typeof t == "object" && t.Once) {
        if (this.result.root.type === "document") {
          let s = this.result.root.nodes.map(
            (r) => t.Once(r, this.helpers)
          );
          return lt(s[0]) ? Promise.all(s) : s;
        }
        return t.Once(this.result.root, this.helpers);
      } else if (typeof t == "function")
        return t(this.result.root, this.result);
    } catch (s) {
      throw this.handleError(s);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let t = this.result.opts, s = Bh;
    t.syntax && (s = t.syntax.stringify), t.stringifier && (s = t.stringifier), s.stringify && (s = s.stringify);
    let r = new Fh(s, this.result.root, this.result.opts).generate();
    return this.result.css = r[0], this.result.map = r[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let t of this.plugins) {
      let s = this.runOnRoot(t);
      if (lt(s))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let t = this.result.root;
      for (; !t[be]; )
        t[be] = !0, this.walkSync(t);
      if (this.listeners.OnceExit)
        if (t.type === "document")
          for (let s of t.nodes)
            this.visitSync(this.listeners.OnceExit, s);
        else
          this.visitSync(this.listeners.OnceExit, t);
    }
    return this.result;
  }
  then(t, s) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || jh(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(t, s);
  }
  toString() {
    return this.css;
  }
  visitSync(t, s) {
    for (let [r, n] of t) {
      this.result.lastPlugin = r;
      let o;
      try {
        o = n(s, this.helpers);
      } catch (a) {
        throw this.handleError(a, s.proxyOf);
      }
      if (s.type !== "root" && s.type !== "document" && !s.parent)
        return !0;
      if (lt(o))
        throw this.getAsyncError();
    }
  }
  visitTick(t) {
    let s = t[t.length - 1], { node: r, visitors: n } = s;
    if (r.type !== "root" && r.type !== "document" && !r.parent) {
      t.pop();
      return;
    }
    if (n.length > 0 && s.visitorIndex < n.length) {
      let [a, i] = n[s.visitorIndex];
      s.visitorIndex += 1, s.visitorIndex === n.length && (s.visitors = [], s.visitorIndex = 0), this.result.lastPlugin = a;
      try {
        return i(r.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, r);
      }
    }
    if (s.iterator !== 0) {
      let a = s.iterator, i;
      for (; i = r.nodes[r.indexes[a]]; )
        if (r.indexes[a] += 1, !i[be]) {
          i[be] = !0, t.push(qn(i));
          return;
        }
      s.iterator = 0, delete r.indexes[a];
    }
    let o = s.events;
    for (; s.eventIndex < o.length; ) {
      let a = o[s.eventIndex];
      if (s.eventIndex += 1, a === Ke) {
        r.nodes && r.nodes.length && (r[be] = !0, s.iterator = r.getIterator());
        return;
      } else if (this.listeners[a]) {
        s.visitors = this.listeners[a];
        return;
      }
    }
    t.pop();
  }
  walkSync(t) {
    t[be] = !0;
    let s = ta(t);
    for (let r of s)
      if (r === Ke)
        t.nodes && t.each((n) => {
          n[be] || this.walkSync(n);
        });
      else {
        let n = this.listeners[r];
        if (n && this.visitSync(n, t.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
qe.registerPostcss = (e) => {
  xr = e;
};
var ra = qe;
qe.default = qe;
Uh.registerLazyResult(qe);
_h.registerLazyResult(qe);
let Gh = qo, Zh = Qr;
const Xh = Kr;
let Hh = bs, Jh = ea, Cr = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = Zh;
    try {
      e = t(this._css, this._opts);
    } catch (s) {
      this.error = s;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, s) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = s, this._map = void 0;
    let r, n = Hh;
    this.result = new Xh(this._processor, r, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let a = new Gh(n, r, this._opts, t);
    if (a.isMap()) {
      let [i, l] = a.generate();
      i && (this.result.css = i), l && (this.result.map = l);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || Jh(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var Qh = Cr;
Cr.default = Cr;
let Kh = Hr, qh = ra, $h = Qh, ep = Dt, Et = class {
  constructor(e = []) {
    this.version = "8.5.3", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let s of e)
      if (s.postcss === !0 ? s = s() : s.postcss && (s = s.postcss), typeof s == "object" && Array.isArray(s.plugins))
        t = t.concat(s.plugins);
      else if (typeof s == "object" && s.postcssPlugin)
        t.push(s);
      else if (typeof s == "function")
        t.push(s);
      else if (typeof s == "object" && (s.parse || s.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(s + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new $h(this, e, t) : new qh(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var tp = Et;
Et.default = Et;
ep.registerProcessor(Et);
Kh.registerProcessor(Et);
let na = Xr, ia = xs, sp = _e, rp = Yr, oa = Cs, aa = Hr, np = ih, ip = Es, op = ra, ap = Zo, lp = Ss, cp = Qr, qr = tp, up = Kr, la = Dt, ca = Jr, hp = bs, pp = $o;
function z(...e) {
  return e.length === 1 && Array.isArray(e[0]) && (e = e[0]), new qr(e);
}
z.plugin = function(e, t) {
  let s = !1;
  function r(...o) {
    console && console.warn && !s && (s = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...o);
    return a.postcssPlugin = e, a.postcssVersion = new qr().version, a;
  }
  let n;
  return Object.defineProperty(r, "postcss", {
    get() {
      return n || (n = r()), n;
    }
  }), r.process = function(o, a, i) {
    return z([r(i)]).process(o, a);
  }, r;
};
z.stringify = hp;
z.parse = cp;
z.fromJSON = np;
z.list = ap;
z.comment = (e) => new ia(e);
z.atRule = (e) => new na(e);
z.decl = (e) => new oa(e);
z.rule = (e) => new ca(e);
z.root = (e) => new la(e);
z.document = (e) => new aa(e);
z.CssSyntaxError = rp;
z.Declaration = oa;
z.Container = sp;
z.Processor = qr;
z.Document = aa;
z.Comment = ia;
z.Warning = pp;
z.AtRule = na;
z.Result = up;
z.Input = ip;
z.Rule = ca;
z.Root = la;
z.Node = lp;
op.registerPostcss(z);
var dp = z;
z.default = z;
const H = /* @__PURE__ */ Eu(dp);
H.stringify;
H.fromJSON;
H.plugin;
H.parse;
H.list;
H.document;
H.comment;
H.atRule;
H.rule;
H.decl;
H.root;
H.CssSyntaxError;
H.Declaration;
H.Container;
H.Processor;
H.Document;
H.Comment;
H.Warning;
H.AtRule;
H.Result;
H.Input;
H.Rule;
H.Root;
H.Node;
function fp(e) {
  const t = {}, s = /;(?![^(]*\))/g, r = /:(.+)/, n = /\/\*.*?\*\//g;
  return e.replace(n, "").split(s).forEach(function(o) {
    if (o) {
      const a = o.split(r);
      a.length > 1 && (t[Er(a[0].trim())] = a[1].trim());
    }
  }), t;
}
function $n(e) {
  const t = [];
  for (const s in e) {
    const r = e[s];
    if (typeof r != "string") continue;
    const n = wp(s);
    t.push(`${n}: ${r};`);
  }
  return t.join(" ");
}
const mp = /-([a-z])/g, gp = /^--[a-zA-Z0-9-]+$/, Er = (e) => gp.test(e) ? e : e.replace(mp, (t, s) => s ? s.toUpperCase() : ""), yp = /\B([A-Z])/g, wp = (e) => e.replace(yp, "-$1").toLowerCase();
class Re {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  constructor(...t) {
    C(this, "parentElement", null), C(this, "parentNode", null), C(this, "ownerDocument"), C(this, "firstChild", null), C(this, "lastChild", null), C(this, "previousSibling", null), C(this, "nextSibling", null), C(this, "ELEMENT_NODE", 1), C(this, "TEXT_NODE", 3), C(this, "nodeType"), C(this, "nodeName"), C(this, "RRNodeType");
  }
  get childNodes() {
    const t = [];
    let s = this.firstChild;
    for (; s; )
      t.push(s), s = s.nextSibling;
    return t;
  }
  contains(t) {
    if (t instanceof Re) {
      if (t.ownerDocument !== this.ownerDocument) return !1;
      if (t === this) return !0;
    } else return !1;
    for (; t.parentNode; ) {
      if (t.parentNode === this) return !0;
      t = t.parentNode;
    }
    return !1;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  appendChild(t) {
    throw new Error(
      "RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  insertBefore(t, s) {
    throw new Error(
      "RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeChild(t) {
    throw new Error(
      "RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  toString() {
    return "RRNode";
  }
}
class $r extends Re {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(...t) {
    super(t), C(this, "nodeType", 9), C(this, "nodeName", "#document"), C(this, "compatMode", "CSS1Compat"), C(this, "RRNodeType", O.Document), C(this, "textContent", null), this.ownerDocument = this;
  }
  get documentElement() {
    return this.childNodes.find(
      (t) => t.RRNodeType === O.Element && t.tagName === "HTML"
    ) || null;
  }
  get body() {
    var t;
    return ((t = this.documentElement) == null ? void 0 : t.childNodes.find(
      (s) => s.RRNodeType === O.Element && s.tagName === "BODY"
    )) || null;
  }
  get head() {
    var t;
    return ((t = this.documentElement) == null ? void 0 : t.childNodes.find(
      (s) => s.RRNodeType === O.Element && s.tagName === "HEAD"
    )) || null;
  }
  get implementation() {
    return this;
  }
  get firstElementChild() {
    return this.documentElement;
  }
  appendChild(t) {
    const s = t.RRNodeType;
    if ((s === O.Element || s === O.DocumentType) && this.childNodes.some((n) => n.RRNodeType === s))
      throw new Error(
        `RRDomException: Failed to execute 'appendChild' on 'RRNode': Only one ${s === O.Element ? "RRElement" : "RRDoctype"} on RRDocument allowed.`
      );
    const r = tn(this, t);
    return r.parentElement = null, r;
  }
  insertBefore(t, s) {
    const r = t.RRNodeType;
    if ((r === O.Element || r === O.DocumentType) && this.childNodes.some((o) => o.RRNodeType === r))
      throw new Error(
        `RRDomException: Failed to execute 'insertBefore' on 'RRNode': Only one ${r === O.Element ? "RRElement" : "RRDoctype"} on RRDocument allowed.`
      );
    const n = fa(this, t, s);
    return n.parentElement = null, n;
  }
  removeChild(t) {
    return ma(this, t);
  }
  open() {
    this.firstChild = null, this.lastChild = null;
  }
  close() {
  }
  /**
   * Adhoc implementation for setting xhtml namespace in rebuilt.ts (rrweb-snapshot).
   * There are two lines used this function:
   * 1. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" ""\>')
   * 2. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" ""\>')
   */
  write(t) {
    let s;
    if (t === '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">' ? s = "-//W3C//DTD XHTML 1.0 Transitional//EN" : t === '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">' && (s = "-//W3C//DTD HTML 4.0 Transitional//EN"), s) {
      const r = this.createDocumentType("html", s, "");
      this.open(), this.appendChild(r);
    }
  }
  createDocument(t, s, r) {
    return new $r();
  }
  createDocumentType(t, s, r) {
    const n = new ua(t, s, r);
    return n.ownerDocument = this, n;
  }
  createElement(t) {
    const s = new en(t);
    return s.ownerDocument = this, s;
  }
  createElementNS(t, s) {
    return this.createElement(s);
  }
  createTextNode(t) {
    const s = new ha(t);
    return s.ownerDocument = this, s;
  }
  createComment(t) {
    const s = new pa(t);
    return s.ownerDocument = this, s;
  }
  createCDATASection(t) {
    const s = new da(t);
    return s.ownerDocument = this, s;
  }
  toString() {
    return "RRDocument";
  }
}
class ua extends Re {
  constructor(t, s, r) {
    super(), C(this, "nodeType", 10), C(this, "RRNodeType", O.DocumentType), C(this, "name"), C(this, "publicId"), C(this, "systemId"), C(this, "textContent", null), this.name = t, this.publicId = s, this.systemId = r, this.nodeName = t;
  }
  toString() {
    return "RRDocumentType";
  }
}
class en extends Re {
  constructor(t) {
    super(), C(this, "nodeType", 1), C(this, "RRNodeType", O.Element), C(this, "tagName"), C(this, "attributes", {}), C(this, "shadowRoot", null), C(this, "scrollLeft"), C(this, "scrollTop"), this.tagName = t.toUpperCase(), this.nodeName = t.toUpperCase();
  }
  get textContent() {
    let t = "";
    return this.childNodes.forEach((s) => t += s.textContent), t;
  }
  set textContent(t) {
    this.firstChild = null, this.lastChild = null, this.appendChild(this.ownerDocument.createTextNode(t));
  }
  get classList() {
    return new bp(
      this.attributes.class,
      (t) => {
        this.attributes.class = t;
      }
    );
  }
  get id() {
    return this.attributes.id || "";
  }
  get className() {
    return this.attributes.class || "";
  }
  get style() {
    const t = this.attributes.style ? fp(this.attributes.style) : {}, s = /\B([A-Z])/g;
    return t.setProperty = (r, n, o) => {
      if (s.test(r)) return;
      const a = Er(r);
      n ? t[a] = n : delete t[a], o === "important" && (t[a] += " !important"), this.attributes.style = $n(t);
    }, t.removeProperty = (r) => {
      if (s.test(r)) return "";
      const n = Er(r), o = t[n] || "";
      return delete t[n], this.attributes.style = $n(t), o;
    }, t;
  }
  getAttribute(t) {
    return this.attributes[t] || null;
  }
  setAttribute(t, s) {
    this.attributes[t] = s;
  }
  setAttributeNS(t, s, r) {
    this.setAttribute(s, r);
  }
  removeAttribute(t) {
    delete this.attributes[t];
  }
  appendChild(t) {
    return tn(this, t);
  }
  insertBefore(t, s) {
    return fa(this, t, s);
  }
  removeChild(t) {
    return ma(this, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  attachShadow(t) {
    const s = this.ownerDocument.createElement("SHADOWROOT");
    return this.shadowRoot = s, s;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dispatchEvent(t) {
    return !0;
  }
  toString() {
    let t = "";
    for (const s in this.attributes)
      t += `${s}="${this.attributes[s]}" `;
    return `${this.tagName} ${t}`;
  }
}
class vp extends en {
  constructor() {
    super(...arguments), C(this, "currentTime"), C(this, "volume"), C(this, "paused"), C(this, "muted"), C(this, "playbackRate"), C(this, "loop");
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  attachShadow(t) {
    throw new Error(
      "RRDomException: Failed to execute 'attachShadow' on 'RRElement': This RRElement does not support attachShadow"
    );
  }
  play() {
    this.paused = !1;
  }
  pause() {
    this.paused = !0;
  }
}
class ha extends Re {
  constructor(t) {
    super(), C(this, "nodeType", 3), C(this, "nodeName", "#text"), C(this, "RRNodeType", O.Text), C(this, "data"), this.data = t;
  }
  get textContent() {
    return this.data;
  }
  set textContent(t) {
    this.data = t;
  }
  toString() {
    return `RRText text=${JSON.stringify(this.data)}`;
  }
}
class pa extends Re {
  constructor(t) {
    super(), C(this, "nodeType", 8), C(this, "nodeName", "#comment"), C(this, "RRNodeType", O.Comment), C(this, "data"), this.data = t;
  }
  get textContent() {
    return this.data;
  }
  set textContent(t) {
    this.data = t;
  }
  toString() {
    return `RRComment text=${JSON.stringify(this.data)}`;
  }
}
class da extends Re {
  constructor(t) {
    super(), C(this, "nodeName", "#cdata-section"), C(this, "nodeType", 4), C(this, "RRNodeType", O.CDATA), C(this, "data"), this.data = t;
  }
  get textContent() {
    return this.data;
  }
  set textContent(t) {
    this.data = t;
  }
  toString() {
    return `RRCDATASection data=${JSON.stringify(this.data)}`;
  }
}
class bp {
  constructor(t, s) {
    if (C(this, "onChange"), C(this, "classes", []), C(this, "add", (...r) => {
      for (const n of r) {
        const o = String(n);
        this.classes.indexOf(o) >= 0 || this.classes.push(o);
      }
      this.onChange && this.onChange(this.classes.join(" "));
    }), C(this, "remove", (...r) => {
      this.classes = this.classes.filter(
        (n) => r.indexOf(n) === -1
      ), this.onChange && this.onChange(this.classes.join(" "));
    }), t) {
      const r = t.trim().split(/\s+/);
      this.classes.push(...r);
    }
    this.onChange = s;
  }
}
function tn(e, t) {
  return t.parentNode && t.parentNode.removeChild(t), e.lastChild ? (e.lastChild.nextSibling = t, t.previousSibling = e.lastChild) : (e.firstChild = t, t.previousSibling = null), e.lastChild = t, t.nextSibling = null, t.parentNode = e, t.parentElement = e, t.ownerDocument = e.ownerDocument, t;
}
function fa(e, t, s) {
  if (!s) return tn(e, t);
  if (s.parentNode !== e)
    throw new Error(
      "Failed to execute 'insertBefore' on 'RRNode': The RRNode before which the new node is to be inserted is not a child of this RRNode."
    );
  return t === s || (t.parentNode && t.parentNode.removeChild(t), t.previousSibling = s.previousSibling, s.previousSibling = t, t.nextSibling = s, t.previousSibling ? t.previousSibling.nextSibling = t : e.firstChild = t, t.parentElement = e, t.parentNode = e, t.ownerDocument = e.ownerDocument), t;
}
function ma(e, t) {
  if (t.parentNode !== e)
    throw new Error(
      "Failed to execute 'removeChild' on 'RRNode': The RRNode to be removed is not a child of this RRNode."
    );
  return t.previousSibling ? t.previousSibling.nextSibling = t.nextSibling : e.firstChild = t.nextSibling, t.nextSibling ? t.nextSibling.previousSibling = t.previousSibling : e.lastChild = t.previousSibling, t.previousSibling = null, t.nextSibling = null, t.parentElement = null, t.parentNode = null, t;
}
var le = /* @__PURE__ */ ((e) => (e[e.PLACEHOLDER = 0] = "PLACEHOLDER", e[e.ELEMENT_NODE = 1] = "ELEMENT_NODE", e[e.ATTRIBUTE_NODE = 2] = "ATTRIBUTE_NODE", e[e.TEXT_NODE = 3] = "TEXT_NODE", e[e.CDATA_SECTION_NODE = 4] = "CDATA_SECTION_NODE", e[e.ENTITY_REFERENCE_NODE = 5] = "ENTITY_REFERENCE_NODE", e[e.ENTITY_NODE = 6] = "ENTITY_NODE", e[e.PROCESSING_INSTRUCTION_NODE = 7] = "PROCESSING_INSTRUCTION_NODE", e[e.COMMENT_NODE = 8] = "COMMENT_NODE", e[e.DOCUMENT_NODE = 9] = "DOCUMENT_NODE", e[e.DOCUMENT_TYPE_NODE = 10] = "DOCUMENT_TYPE_NODE", e[e.DOCUMENT_FRAGMENT_NODE = 11] = "DOCUMENT_FRAGMENT_NODE", e))(le || {});
const kr = {
  svg: "http://www.w3.org/2000/svg",
  "xlink:href": "http://www.w3.org/1999/xlink",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, Sp = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  fedropshadow: "feDropShadow",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient"
};
let Se = null;
function hs(e, t, s, r = t.mirror || t.ownerDocument.mirror) {
  e = xp(
    e,
    t,
    s,
    r
  ), ga(e, t, s, r), Cp(e, t, s);
}
function xp(e, t, s, r) {
  var n;
  if (s.afterAppend && !Se && (Se = /* @__PURE__ */ new WeakSet(), setTimeout(() => {
    Se = null;
  }, 0)), !sn(e, t)) {
    const o = ps(
      t,
      s.mirror,
      r
    );
    (n = e.parentNode) == null || n.replaceChild(o, e), e = o;
  }
  switch (t.RRNodeType) {
    case O.Document: {
      if (!ze(e, t, s.mirror, r)) {
        const o = r.getMeta(t);
        o && (s.mirror.removeNodeFromMap(e), e.close(), e.open(), s.mirror.add(e, o), Se == null || Se.add(e));
      }
      break;
    }
    case O.Element: {
      const o = e, a = t;
      switch (a.tagName) {
        case "IFRAME": {
          const i = e.contentDocument;
          if (!i) break;
          hs(
            i,
            t.contentDocument,
            s,
            r
          );
          break;
        }
      }
      a.shadowRoot && (o.shadowRoot || o.attachShadow({ mode: "open" }), ga(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        o.shadowRoot,
        a.shadowRoot,
        s,
        r
      )), Ep(o, a, r);
      break;
    }
  }
  return e;
}
function Cp(e, t, s) {
  var r;
  switch (t.RRNodeType) {
    case O.Document: {
      const n = t.scrollData;
      n && s.applyScroll(n, !0);
      break;
    }
    case O.Element: {
      const n = e, o = t;
      switch (o.scrollData && s.applyScroll(o.scrollData, !0), o.inputData && s.applyInput(o.inputData), o.tagName) {
        case "AUDIO":
        case "VIDEO": {
          const a = e, i = o;
          i.paused !== void 0 && (i.paused ? a.pause() : a.play()), i.muted !== void 0 && (a.muted = i.muted), i.volume !== void 0 && (a.volume = i.volume), i.currentTime !== void 0 && (a.currentTime = i.currentTime), i.playbackRate !== void 0 && (a.playbackRate = i.playbackRate), i.loop !== void 0 && (a.loop = i.loop);
          break;
        }
        case "CANVAS": {
          const a = t;
          if (a.rr_dataURL !== null) {
            const i = document.createElement("img");
            i.onload = () => {
              const l = n.getContext("2d");
              l && l.drawImage(i, 0, 0, i.width, i.height);
            }, i.src = a.rr_dataURL;
          }
          a.canvasMutations.forEach(
            (i) => s.applyCanvas(
              i.event,
              i.mutation,
              e
            )
          );
          break;
        }
        case "STYLE": {
          const a = n.sheet;
          a && t.rules.forEach(
            (i) => s.applyStyleSheetMutation(i, a)
          );
          break;
        }
      }
      break;
    }
    case O.Text:
    case O.Comment:
    case O.CDATA: {
      e.textContent !== t.data && (e.textContent = t.data);
      break;
    }
  }
  Se != null && Se.has(e) && (Se.delete(e), (r = s.afterAppend) == null || r.call(s, e, s.mirror.getId(e)));
}
function Ep(e, t, s) {
  const r = e.attributes, n = t.attributes;
  for (const o in n) {
    const a = n[o], i = s.getMeta(t);
    if (i != null && i.isSVG && kr[o])
      e.setAttributeNS(kr[o], o, a);
    else if (t.tagName === "CANVAS" && o === "rr_dataURL") {
      const l = document.createElement("img");
      l.src = a, l.onload = () => {
        const c = e.getContext("2d");
        c && c.drawImage(l, 0, 0, l.width, l.height);
      };
    } else {
      if (t.tagName === "IFRAME" && o === "srcdoc") continue;
      e.setAttribute(o, a);
    }
  }
  for (const { name: o } of Array.from(r))
    o in n || e.removeAttribute(o);
  t.scrollLeft && (e.scrollLeft = t.scrollLeft), t.scrollTop && (e.scrollTop = t.scrollTop);
}
function ga(e, t, s, r) {
  const n = Array.from(e.childNodes), o = t.childNodes;
  if (n.length === 0 && o.length === 0) return;
  let a = 0, i = n.length - 1, l = 0, c = o.length - 1, u = n[a], h = n[i], p = o[l], y = o[c], g, d;
  for (; a <= i && l <= c; )
    if (u === void 0)
      u = n[++a];
    else if (h === void 0)
      h = n[--i];
    else if (
      // same first node?
      ze(u, p, s.mirror, r)
    )
      u = n[++a], p = o[++l];
    else if (
      // same last node?
      ze(h, y, s.mirror, r)
    )
      h = n[--i], y = o[--c];
    else if (
      // is the first old node the same as the last new node?
      ze(u, y, s.mirror, r)
    ) {
      try {
        e.insertBefore(u, h.nextSibling);
      } catch (v) {
        console.warn(v);
      }
      u = n[++a], y = o[--c];
    } else if (
      // is the last old node the same as the first new node?
      ze(h, p, s.mirror, r)
    ) {
      try {
        e.insertBefore(h, u);
      } catch (v) {
        console.warn(v);
      }
      h = n[--i], p = o[++l];
    } else {
      if (!g) {
        g = {};
        for (let w = a; w <= i; w++) {
          const k = n[w];
          k && s.mirror.hasNode(k) && (g[s.mirror.getId(k)] = w);
        }
      }
      d = g[r.getId(p)];
      const v = n[d];
      if (d !== void 0 && v && ze(v, p, s.mirror, r)) {
        try {
          e.insertBefore(v, u);
        } catch (w) {
          console.warn(w);
        }
        n[d] = void 0;
      } else {
        const w = ps(
          p,
          s.mirror,
          r
        );
        e.nodeName === "#document" && u && /**
        * Special case 1: one document isn't allowed to have two doctype nodes at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A parent document in the old tree already has a doctype node with an id e.g. #1. A new full snapshot rebuilds the replayer with a new doctype node with another id #2. According to the algorithm, the new doctype node will be inserted before the old one, which is not allowed by the Document standard.
        */
        (w.nodeType === w.DOCUMENT_TYPE_NODE && u.nodeType === u.DOCUMENT_TYPE_NODE || /**
        * Special case 2: one document isn't allowed to have two HTMLElements at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A mounted iframe element has an automatically created HTML element. We should delete it before inserting a serialized one. Otherwise, an error 'Only one element on document allowed' will be thrown.
        */
        w.nodeType === w.ELEMENT_NODE && u.nodeType === u.ELEMENT_NODE) && (e.removeChild(u), s.mirror.removeNodeFromMap(u), u = n[++a]);
        try {
          e.insertBefore(w, u || null);
        } catch (k) {
          console.warn(k);
        }
      }
      p = o[++l];
    }
  if (a > i) {
    const v = o[c + 1];
    let w = null;
    for (v && (w = s.mirror.getNode(
      r.getId(v)
    )); l <= c; ++l) {
      const k = ps(
        o[l],
        s.mirror,
        r
      );
      try {
        e.insertBefore(k, w);
      } catch (E) {
        console.warn(E);
      }
    }
  } else if (l > c)
    for (; a <= i; a++) {
      const v = n[a];
      if (!(!v || v.parentNode !== e))
        try {
          e.removeChild(v), s.mirror.removeNodeFromMap(v);
        } catch (w) {
          console.warn(w);
        }
    }
  let S = e.firstChild, f = t.firstChild;
  for (; S !== null && f !== null; )
    hs(S, f, s, r), S = S.nextSibling, f = f.nextSibling;
}
function ps(e, t, s) {
  const r = s.getId(e), n = s.getMeta(e);
  let o = null;
  if (r > -1 && (o = t.getNode(r)), o !== null && sn(o, e)) return o;
  switch (e.RRNodeType) {
    case O.Document:
      o = new Document();
      break;
    case O.DocumentType:
      o = document.implementation.createDocumentType(
        e.name,
        e.publicId,
        e.systemId
      );
      break;
    case O.Element: {
      let a = e.tagName.toLowerCase();
      a = Sp[a] || a, n && "isSVG" in n && n != null && n.isSVG ? o = document.createElementNS(kr.svg, a) : o = document.createElement(e.tagName);
      break;
    }
    case O.Text:
      o = document.createTextNode(e.data);
      break;
    case O.Comment:
      o = document.createComment(e.data);
      break;
    case O.CDATA:
      o = document.createCDATASection(e.data);
      break;
  }
  n && t.add(o, { ...n });
  try {
    Se == null || Se.add(o);
  } catch {
  }
  return o;
}
function sn(e, t) {
  return e.nodeType !== t.nodeType ? !1 : e.nodeType !== e.ELEMENT_NODE || e.tagName.toUpperCase() === t.tagName;
}
function ze(e, t, s, r) {
  const n = s.getId(e), o = r.getId(t);
  return n === -1 || n !== o ? !1 : sn(e, t);
}
class et extends $r {
  constructor(t) {
    super(), C(this, "UNSERIALIZED_STARTING_ID", -2), C(this, "_unserializedId", this.UNSERIALIZED_STARTING_ID), C(this, "mirror", _p()), C(this, "scrollData", null), t && (this.mirror = t);
  }
  /**
   * Every time the id is used, it will minus 1 automatically to avoid collisions.
   */
  get unserializedId() {
    return this._unserializedId--;
  }
  createDocument(t, s, r) {
    return new et();
  }
  createDocumentType(t, s, r) {
    const n = new kp(
      t,
      s,
      r
    );
    return n.ownerDocument = this, n;
  }
  createElement(t) {
    const s = t.toUpperCase();
    let r;
    switch (s) {
      case "AUDIO":
      case "VIDEO":
        r = new Mp(s);
        break;
      case "IFRAME":
        r = new Dp(s, this.mirror);
        break;
      case "CANVAS":
        r = new Np(s);
        break;
      case "STYLE":
        r = new Tp(s);
        break;
      default:
        r = new ks(s);
        break;
    }
    return r.ownerDocument = this, r;
  }
  createComment(t) {
    const s = new Op(t);
    return s.ownerDocument = this, s;
  }
  createCDATASection(t) {
    const s = new Ap(t);
    return s.ownerDocument = this, s;
  }
  createTextNode(t) {
    const s = new Rp(t);
    return s.ownerDocument = this, s;
  }
  destroyTree() {
    this.firstChild = null, this.lastChild = null, this.mirror.reset();
  }
  open() {
    super.open(), this._unserializedId = this.UNSERIALIZED_STARTING_ID;
  }
}
const kp = ua;
class ks extends en {
  constructor() {
    super(...arguments), C(this, "inputData", null), C(this, "scrollData", null);
  }
}
class Mp extends vp {
}
class Np extends ks {
  constructor() {
    super(...arguments), C(this, "rr_dataURL", null), C(this, "canvasMutations", []);
  }
  /**
   * This is a dummy implementation to distinguish RRCanvasElement from real HTMLCanvasElement.
   */
  getContext() {
    return null;
  }
}
class Tp extends ks {
  constructor() {
    super(...arguments), C(this, "rules", []);
  }
}
class Dp extends ks {
  constructor(t, s) {
    super(t), C(this, "contentDocument", new et()), this.contentDocument.mirror = s;
  }
}
const Rp = ha, Op = pa, Ap = da;
function Ip(e) {
  return e instanceof HTMLFormElement ? "FORM" : e.tagName.toUpperCase();
}
function ya(e, t, s, r) {
  let n;
  switch (e.nodeType) {
    case le.DOCUMENT_NODE:
      r && r.nodeName === "IFRAME" ? n = r.contentDocument : (n = t, n.compatMode = e.compatMode);
      break;
    case le.DOCUMENT_TYPE_NODE: {
      const a = e;
      n = t.createDocumentType(
        a.name,
        a.publicId,
        a.systemId
      );
      break;
    }
    case le.ELEMENT_NODE: {
      const a = e, i = Ip(a);
      n = t.createElement(i);
      const l = n;
      for (const { name: c, value: u } of Array.from(a.attributes))
        l.attributes[c] = u;
      a.scrollLeft && (l.scrollLeft = a.scrollLeft), a.scrollTop && (l.scrollTop = a.scrollTop);
      break;
    }
    case le.TEXT_NODE:
      n = t.createTextNode(e.textContent || "");
      break;
    case le.CDATA_SECTION_NODE:
      n = t.createCDATASection(e.data);
      break;
    case le.COMMENT_NODE:
      n = t.createComment(e.textContent || "");
      break;
    case le.DOCUMENT_FRAGMENT_NODE:
      n = r.attachShadow({ mode: "open" });
      break;
    default:
      return null;
  }
  let o = s.getMeta(e);
  return t instanceof et && (o || (o = wa(n, t.unserializedId), s.add(e, o)), t.mirror.add(n, { ...o })), n;
}
function Pp(e, t = Cu(), s = new et()) {
  function r(n, o) {
    const a = ya(n, s, t, o);
    if (a !== null)
      if (
        // if the parentRRNode isn't a RRIFrameElement
        (o == null ? void 0 : o.nodeName) !== "IFRAME" && // if node isn't a shadow root
        n.nodeType !== le.DOCUMENT_FRAGMENT_NODE && (o == null || o.appendChild(a), a.parentNode = o, a.parentElement = o), n.nodeName === "IFRAME"
      ) {
        const i = n.contentDocument;
        i && r(i, a);
      } else (n.nodeType === le.DOCUMENT_NODE || n.nodeType === le.ELEMENT_NODE || n.nodeType === le.DOCUMENT_FRAGMENT_NODE) && (n.nodeType === le.ELEMENT_NODE && n.shadowRoot && r(n.shadowRoot, a), n.childNodes.forEach((i) => r(i, a)));
  }
  return r(e, null), s;
}
function _p() {
  return new Fp();
}
class Fp {
  constructor() {
    C(this, "idNodeMap", /* @__PURE__ */ new Map()), C(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    var s;
    return t ? ((s = this.getMeta(t)) == null ? void 0 : s.id) ?? -1 : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const s = this.getId(t);
    this.idNodeMap.delete(s), t.childNodes && t.childNodes.forEach((r) => this.removeNodeFromMap(r));
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, s) {
    const r = s.id;
    this.idNodeMap.set(r, t), this.nodeMetaMap.set(t, s);
  }
  replace(t, s) {
    const r = this.getNode(t);
    if (r) {
      const n = this.nodeMetaMap.get(r);
      n && this.nodeMetaMap.set(s, n);
    }
    this.idNodeMap.set(t, s);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function wa(e, t) {
  switch (e.RRNodeType) {
    case O.Document:
      return {
        id: t,
        type: e.RRNodeType,
        childNodes: []
      };
    case O.DocumentType: {
      const s = e;
      return {
        id: t,
        type: e.RRNodeType,
        name: s.name,
        publicId: s.publicId,
        systemId: s.systemId
      };
    }
    case O.Element:
      return {
        id: t,
        type: e.RRNodeType,
        tagName: e.tagName.toLowerCase(),
        // In rrweb data, all tagNames are lowercase.
        attributes: {},
        childNodes: []
      };
    case O.Text:
      return {
        id: t,
        type: e.RRNodeType,
        textContent: e.textContent || ""
      };
    case O.Comment:
      return {
        id: t,
        type: e.RRNodeType,
        textContent: e.textContent || ""
      };
    case O.CDATA:
      return {
        id: t,
        type: e.RRNodeType,
        textContent: ""
      };
  }
}
function va(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, s) {
    var r = e.get(t);
    r ? r.push(s) : e.set(t, [s]);
  }, off: function(t, s) {
    var r = e.get(t);
    r && (s ? r.splice(r.indexOf(s) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, s) {
    var r = e.get(t);
    r && r.slice().map(function(n) {
      n(s);
    }), (r = e.get("*")) && r.slice().map(function(n) {
      n(t, s);
    });
  } };
}
const Lp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: va
}, Symbol.toStringTag, { value: "Module" })), ei = /* @__PURE__ */ new Map();
function ba(e, t) {
  let s = ei.get(e);
  return s || (s = /* @__PURE__ */ new Map(), ei.set(e, s)), s.has(t) || s.set(t, []), s.get(t);
}
function De(e, t, s) {
  return async (r) => {
    if (r && typeof r == "object" && "rr_type" in r)
      if (s && (s.isUnchanged = !1), r.rr_type === "ImageBitmap" && "args" in r) {
        const n = await De(e, t, s)(r.args);
        return await createImageBitmap.apply(null, n);
      } else if ("index" in r) {
        if (s || t === null) return r;
        const { rr_type: n, index: o } = r;
        return ba(t, n)[o];
      } else if ("args" in r) {
        const { rr_type: n, args: o } = r, a = window[n];
        return new a(
          ...await Promise.all(
            o.map(De(e, t, s))
          )
        );
      } else {
        if ("base64" in r)
          return yu(r.base64);
        if ("src" in r) {
          const n = e.get(r.src);
          if (n)
            return n;
          {
            const o = new Image();
            return o.src = r.src, e.set(r.src, o), o;
          }
        } else if ("data" in r && r.rr_type === "Blob") {
          const n = await Promise.all(
            r.data.map(De(e, t, s))
          );
          return new Blob(n, {
            type: r.type
          });
        }
      }
    else if (Array.isArray(r))
      return await Promise.all(
        r.map(De(e, t, s))
      );
    return r;
  };
}
async function Up({
  event: e,
  mutations: t,
  target: s,
  imageMap: r,
  errorHandler: n
}) {
  const o = s.getContext("2d");
  if (!o) {
    n(t[0], new Error("Canvas context is null"));
    return;
  }
  const a = t.map(
    async (i) => Promise.all(i.args.map(De(r, o)))
  );
  (await Promise.all(a)).forEach((i, l) => {
    const c = t[l];
    try {
      if (c.setter) {
        o[c.property] = c.args[0];
        return;
      }
      const u = o[c.property];
      c.property === "drawImage" && typeof c.args[0] == "string" ? (r.get(e), u.apply(o, c.args)) : u.apply(o, i);
    } catch (u) {
      n(c, u);
    }
  });
}
function Bp(e, t) {
  try {
    return t === os.WebGL ? e.getContext("webgl") || e.getContext("experimental-webgl") : e.getContext("webgl2");
  } catch {
    return null;
  }
}
const zp = [
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject"
];
function jp(e, t) {
  if (!(t != null && t.constructor)) return;
  const { name: s } = t.constructor;
  if (!zp.includes(s)) return;
  const r = ba(e, s);
  r.includes(t) || r.push(t);
}
async function Wp({
  mutation: e,
  target: t,
  type: s,
  imageMap: r,
  errorHandler: n
}) {
  try {
    const o = Bp(t, s);
    if (!o) return;
    if (e.setter) {
      o[e.property] = e.args[0];
      return;
    }
    const a = o[e.property], i = await Promise.all(
      e.args.map(De(r, o))
    ), l = a.apply(o, i);
    jp(o, l);
    const c = !1;
  } catch (o) {
    n(e, o);
  }
}
async function ti({
  event: e,
  mutation: t,
  target: s,
  imageMap: r,
  canvasEventMap: n,
  errorHandler: o
}) {
  try {
    const a = n.get(e) || t, i = "commands" in a ? a.commands : [a];
    if ([os.WebGL, os.WebGL2].includes(t.type)) {
      for (let l = 0; l < i.length; l++) {
        const c = i[l];
        await Wp({
          mutation: c,
          type: t.type,
          target: s,
          imageMap: r,
          errorHandler: o
        });
      }
      return;
    }
    await Up({
      event: e,
      mutations: i,
      target: s,
      imageMap: r,
      errorHandler: o
    });
  } catch (a) {
    o(t, a);
  }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function si(e, t) {
  var s = typeof Symbol == "function" && e[Symbol.iterator];
  if (!s) return e;
  var r, n, o = s.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; ) a.push(r.value);
  } catch (i) {
    n = { error: i };
  } finally {
    try {
      r && !r.done && (s = o.return) && s.call(o);
    } finally {
      if (n) throw n.error;
    }
  }
  return a;
}
var Ve;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(Ve || (Ve = {}));
var Sa = { type: "xstate.init" };
function zs(e) {
  return e === void 0 ? [] : [].concat(e);
}
function je(e) {
  return { type: "xstate.assign", assignment: e };
}
function ri(e, t) {
  return typeof (e = typeof e == "string" && t && t[e] ? t[e] : e) == "string" ? { type: e } : typeof e == "function" ? { type: e.name, exec: e } : e;
}
function ds(e) {
  return function(t) {
    return e === t;
  };
}
function xa(e) {
  return typeof e == "string" ? { type: e } : e;
}
function ni(e, t) {
  return { value: e, context: t, actions: [], changed: !1, matches: ds(e) };
}
function ii(e, t, s) {
  var r = t, n = !1;
  return [e.filter(function(o) {
    if (o.type === "xstate.assign") {
      n = !0;
      var a = Object.assign({}, r);
      return typeof o.assignment == "function" ? a = o.assignment(r, s) : Object.keys(o.assignment).forEach(function(i) {
        a[i] = typeof o.assignment[i] == "function" ? o.assignment[i](r, s) : o.assignment[i];
      }), r = a, !1;
    }
    return !0;
  }), r, n];
}
function Ca(e, t) {
  t === void 0 && (t = {});
  var s = si(ii(zs(e.states[e.initial].entry).map(function(a) {
    return ri(a, t.actions);
  }), e.context, Sa), 2), r = s[0], n = s[1], o = { config: e, _options: t, initialState: { value: e.initial, actions: r, context: n, matches: ds(e.initial) }, transition: function(a, i) {
    var l, c, u = typeof a == "string" ? { value: a, context: e.context } : a, h = u.value, p = u.context, y = xa(i), g = e.states[h];
    if (g.on) {
      var d = zs(g.on[y.type]);
      try {
        for (var S = function(G) {
          var ae = typeof Symbol == "function" && Symbol.iterator, ie = ae && G[ae], $ = 0;
          if (ie) return ie.call(G);
          if (G && typeof G.length == "number") return { next: function() {
            return G && $ >= G.length && (G = void 0), { value: G && G[$++], done: !G };
          } };
          throw new TypeError(ae ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }(d), f = S.next(); !f.done; f = S.next()) {
          var v = f.value;
          if (v === void 0) return ni(h, p);
          var w = typeof v == "string" ? { target: v } : v, k = w.target, E = w.actions, A = E === void 0 ? [] : E, _ = w.cond, Y = _ === void 0 ? function() {
            return !0;
          } : _, q = k === void 0, j = k ?? h, se = e.states[j];
          if (Y(p, y)) {
            var oe = si(ii((q ? zs(A) : [].concat(g.exit, A, se.entry).filter(function(G) {
              return G;
            })).map(function(G) {
              return ri(G, o._options.actions);
            }), p, y), 3), re = oe[0], P = oe[1], ne = oe[2], V = k ?? h;
            return { value: V, context: P, actions: re, changed: k !== h || re.length > 0 || ne, matches: ds(V) };
          }
        }
      } catch (G) {
        l = { error: G };
      } finally {
        try {
          f && !f.done && (c = S.return) && c.call(S);
        } finally {
          if (l) throw l.error;
        }
      }
    }
    return ni(h, p);
  } };
  return o;
}
var oi = function(e, t) {
  return e.actions.forEach(function(s) {
    var r = s.exec;
    return r && r(e.context, t);
  });
};
function Ea(e) {
  var t = e.initialState, s = Ve.NotStarted, r = /* @__PURE__ */ new Set(), n = { _machine: e, send: function(o) {
    s === Ve.Running && (t = e.transition(t, o), oi(t, xa(o)), r.forEach(function(a) {
      return a(t);
    }));
  }, subscribe: function(o) {
    return r.add(o), o(t), { unsubscribe: function() {
      return r.delete(o);
    } };
  }, start: function(o) {
    if (o) {
      var a = typeof o == "object" ? o : { context: e.config.context, value: o };
      t = { value: a.value, actions: [], context: a.context, matches: ds(a.value) };
    }
    return s = Ve.Running, oi(t, Sa), n;
  }, stop: function() {
    return s = Ve.Stopped, r.clear(), n;
  }, get state() {
    return t;
  }, get status() {
    return s;
  } };
  return n;
}
class Vp {
  constructor(t = [], s) {
    M(this, "timeOffset", 0), M(this, "speed"), M(this, "actions"), M(this, "raf", null), M(this, "lastTimestamp"), this.actions = t, this.speed = s.speed;
  }
  /**
   * Add an action, possibly after the timer starts.
   */
  addAction(t) {
    const s = this.raf === !0;
    if (!this.actions.length || this.actions[this.actions.length - 1].delay <= t.delay)
      this.actions.push(t);
    else {
      const r = this.findActionIndex(t);
      this.actions.splice(r, 0, t);
    }
    s && (this.raf = requestAnimationFrame(this.rafCheck.bind(this)));
  }
  start() {
    this.timeOffset = 0, this.lastTimestamp = performance.now(), this.raf = requestAnimationFrame(this.rafCheck.bind(this));
  }
  rafCheck() {
    const t = performance.now();
    for (this.timeOffset += (t - this.lastTimestamp) * this.speed, this.lastTimestamp = t; this.actions.length; ) {
      const s = this.actions[0];
      if (this.timeOffset >= s.delay)
        this.actions.shift(), s.doAction();
      else
        break;
    }
    this.actions.length > 0 ? this.raf = requestAnimationFrame(this.rafCheck.bind(this)) : this.raf = !0;
  }
  clear() {
    this.raf && (this.raf !== !0 && cancelAnimationFrame(this.raf), this.raf = null), this.actions.length = 0;
  }
  setSpeed(t) {
    this.speed = t;
  }
  isActive() {
    return this.raf !== null;
  }
  findActionIndex(t) {
    let s = 0, r = this.actions.length - 1;
    for (; s <= r; ) {
      const n = Math.floor((s + r) / 2);
      if (this.actions[n].delay < t.delay)
        s = n + 1;
      else if (this.actions[n].delay > t.delay)
        r = n - 1;
      else
        return n + 1;
    }
    return s;
  }
}
function ai(e, t) {
  if (e.type === Q.IncrementalSnapshot && e.data.source === U.MouseMove && e.data.positions && e.data.positions.length) {
    const s = e.data.positions[0].timeOffset, r = e.timestamp + s;
    return e.delay = r - t, r - t;
  }
  return e.delay = e.timestamp - t, e.delay;
}
function Yp(e, t) {
  for (let s = e.length - 1; s >= 0; s--) {
    const r = e[s];
    if (r.type === Q.Meta && r.timestamp <= t)
      return e.slice(s);
  }
  return e;
}
function Gp(e, { getCastFn: t, applyEventsSynchronously: s, emitter: r }) {
  const n = Ca(
    {
      id: "player",
      context: e,
      initial: "paused",
      states: {
        playing: {
          on: {
            PAUSE: {
              target: "paused",
              actions: ["pause"]
            },
            CAST_EVENT: {
              target: "playing",
              actions: "castEvent"
            },
            END: {
              target: "paused",
              actions: ["resetLastPlayedEvent", "pause"]
            },
            ADD_EVENT: {
              target: "playing",
              actions: ["addEvent"]
            }
          }
        },
        paused: {
          on: {
            PLAY: {
              target: "playing",
              actions: ["recordTimeOffset", "play"]
            },
            CAST_EVENT: {
              target: "paused",
              actions: "castEvent"
            },
            TO_LIVE: {
              target: "live",
              actions: ["startLive"]
            },
            ADD_EVENT: {
              target: "paused",
              actions: ["addEvent"]
            }
          }
        },
        live: {
          on: {
            ADD_EVENT: {
              target: "live",
              actions: ["addEvent"]
            },
            CAST_EVENT: {
              target: "live",
              actions: ["castEvent"]
            }
          }
        }
      }
    },
    {
      actions: {
        castEvent: je({
          lastPlayedEvent: (o, a) => a.type === "CAST_EVENT" ? a.payload.event : o.lastPlayedEvent
        }),
        recordTimeOffset: je((o, a) => {
          let i = o.timeOffset;
          return "payload" in a && "timeOffset" in a.payload && (i = a.payload.timeOffset), {
            ...o,
            timeOffset: i,
            baselineTime: o.events[0].timestamp + i
          };
        }),
        play(o) {
          const { timer: a, events: i, baselineTime: l } = o;
          a.clear();
          for (const h of i)
            ai(h, l);
          const c = Yp(i, l);
          r.emit(F.PlayBack);
          const u = new Array();
          for (const h of c)
            if (h.timestamp < l)
              u.push(h);
            else {
              const p = t(h, !1);
              a.addAction({
                doAction: () => {
                  p();
                },
                delay: h.delay
              });
            }
          s(u), r.emit(F.Flush), a.start();
        },
        pause(o) {
          o.timer.clear();
        },
        resetLastPlayedEvent: je((o) => ({
          ...o,
          lastPlayedEvent: null
        })),
        startLive: je({
          baselineTime: (o, a) => (o.timer.start(), a.type === "TO_LIVE" && a.payload.baselineTime ? a.payload.baselineTime : Date.now())
        }),
        addEvent: je((o, a) => {
          const { baselineTime: i, timer: l, events: c } = o;
          if (a.type === "ADD_EVENT") {
            const { event: u } = a.payload;
            ai(u, i);
            let h = c.length - 1;
            if (!c[h] || c[h].timestamp <= u.timestamp)
              c.push(u);
            else {
              let g = -1, d = 0;
              for (; d <= h; ) {
                const S = Math.floor((d + h) / 2);
                c[S].timestamp <= u.timestamp ? d = S + 1 : h = S - 1;
              }
              g === -1 && (g = d), c.splice(g, 0, u);
            }
            const p = u.timestamp < i, y = t(u, p);
            p ? y() : l.isActive() && l.addAction({
              doAction: () => {
                y();
              },
              delay: u.delay
            });
          }
          return { ...o, events: c };
        })
      }
    }
  );
  return Ea(n);
}
function Zp(e) {
  const t = Ca(
    {
      id: "speed",
      context: e,
      initial: "normal",
      states: {
        normal: {
          on: {
            FAST_FORWARD: {
              target: "skipping",
              actions: ["recordSpeed", "setSpeed"]
            },
            SET_SPEED: {
              target: "normal",
              actions: ["setSpeed"]
            }
          }
        },
        skipping: {
          on: {
            BACK_TO_NORMAL: {
              target: "normal",
              actions: ["restoreSpeed"]
            },
            SET_SPEED: {
              target: "normal",
              actions: ["setSpeed"]
            }
          }
        }
      }
    },
    {
      actions: {
        setSpeed: (s, r) => {
          "payload" in r && s.timer.setSpeed(r.payload.speed);
        },
        recordSpeed: je({
          normalSpeed: (s) => s.timer.speed
        }),
        restoreSpeed: (s) => {
          s.timer.setSpeed(s.normalSpeed);
        }
      }
    }
  );
  return Ea(t);
}
class Xp {
  constructor(t) {
    M(this, "mediaMap", /* @__PURE__ */ new Map()), M(this, "warn"), M(this, "service"), M(this, "speedService"), M(this, "emitter"), M(this, "getCurrentTime"), M(this, "metadataCallbackMap", /* @__PURE__ */ new Map()), this.warn = t.warn, this.service = t.service, this.speedService = t.speedService, this.emitter = t.emitter, this.getCurrentTime = t.getCurrentTime, this.emitter.on(F.Start, this.start.bind(this)), this.emitter.on(F.SkipStart, this.start.bind(this)), this.emitter.on(F.Pause, this.pause.bind(this)), this.emitter.on(F.Finish, this.pause.bind(this)), this.speedService.subscribe(() => {
      this.syncAllMediaElements();
    });
  }
  syncAllMediaElements(t = { pause: !1 }) {
    this.mediaMap.forEach((s, r) => {
      this.syncTargetWithState(r), t.pause && r.pause();
    });
  }
  start() {
    this.syncAllMediaElements();
  }
  pause() {
    this.syncAllMediaElements({ pause: !0 });
  }
  seekTo({
    time: t,
    target: s,
    mediaState: r
  }) {
    if (r.isPlaying) {
      const n = (t - r.lastInteractionTimeOffset) / 1e3 * r.playbackRate, o = "duration" in s && s.duration;
      if (Number.isNaN(o)) {
        this.waitForMetadata(s);
        return;
      }
      let a = r.currentTimeAtLastInteraction + n;
      s.loop && // RRMediaElement doesn't have a duration property
      o !== !1 && (a = a % o), s.currentTime = a;
    } else
      s.pause(), s.currentTime = r.currentTimeAtLastInteraction;
  }
  waitForMetadata(t) {
    if (this.metadataCallbackMap.has(t) || !("addEventListener" in t)) return;
    const s = () => {
      this.metadataCallbackMap.delete(t);
      const r = this.mediaMap.get(t);
      r && this.seekTo({
        time: this.getCurrentTime(),
        target: t,
        mediaState: r
      });
    };
    this.metadataCallbackMap.set(t, s), t.addEventListener("loadedmetadata", s, {
      once: !0
    });
  }
  getMediaStateFromMutation({
    target: t,
    timeOffset: s,
    mutation: r
  }) {
    const n = this.mediaMap.get(t), { type: o, playbackRate: a, currentTime: i, muted: l, volume: c, loop: u } = r;
    return {
      isPlaying: o === lr.Play || o !== lr.Pause && ((n == null ? void 0 : n.isPlaying) || t.getAttribute("autoplay") !== null),
      currentTimeAtLastInteraction: i ?? (n == null ? void 0 : n.currentTimeAtLastInteraction) ?? 0,
      lastInteractionTimeOffset: s,
      playbackRate: a ?? (n == null ? void 0 : n.playbackRate) ?? 1,
      volume: c ?? (n == null ? void 0 : n.volume) ?? 1,
      muted: l ?? (n == null ? void 0 : n.muted) ?? t.getAttribute("muted") === null,
      loop: u ?? (n == null ? void 0 : n.loop) ?? t.getAttribute("loop") === null
    };
  }
  syncTargetWithState(t) {
    const s = this.mediaMap.get(t);
    if (!s) return;
    const { muted: r, loop: n, volume: o, isPlaying: a } = s, i = this.service.state.matches("paused"), l = s.playbackRate * this.speedService.state.context.timer.speed;
    try {
      this.seekTo({
        time: this.getCurrentTime(),
        target: t,
        mediaState: s
      }), t.volume !== o && (t.volume = o), t.muted = r, t.loop = n, t.playbackRate !== l && (t.playbackRate = l), a && !i ? t.play() : t.pause();
    } catch (c) {
      this.warn(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-template-expressions
        `Failed to replay media interactions: ${c.message || c}`
      );
    }
  }
  addMediaElements(t, s, r) {
    if (!["AUDIO", "VIDEO"].includes(t.nodeName)) return;
    const n = t, o = r.getMeta(n);
    if (!o || !("attributes" in o)) return;
    const a = this.service.state.matches("paused"), i = o.attributes;
    let l = !1;
    i.rr_mediaState ? l = i.rr_mediaState === "played" : l = n.getAttribute("autoplay") !== null, l && a && n.pause();
    let c = 1;
    typeof i.rr_mediaPlaybackRate == "number" && (c = i.rr_mediaPlaybackRate);
    let u = !1;
    typeof i.rr_mediaMuted == "boolean" ? u = i.rr_mediaMuted : u = n.getAttribute("muted") !== null;
    let h = !1;
    typeof i.rr_mediaLoop == "boolean" ? h = i.rr_mediaLoop : h = n.getAttribute("loop") !== null;
    let p = 1;
    typeof i.rr_mediaVolume == "number" && (p = i.rr_mediaVolume);
    let y = 0;
    typeof i.rr_mediaCurrentTime == "number" && (y = i.rr_mediaCurrentTime), this.mediaMap.set(n, {
      isPlaying: l,
      currentTimeAtLastInteraction: y,
      lastInteractionTimeOffset: s,
      playbackRate: c,
      volume: p,
      muted: u,
      loop: h
    }), this.syncTargetWithState(n);
  }
  mediaMutation({
    target: t,
    timeOffset: s,
    mutation: r
  }) {
    this.mediaMap.set(
      t,
      this.getMediaStateFromMutation({
        target: t,
        timeOffset: s,
        mutation: r
      })
    ), this.syncTargetWithState(t);
  }
  isSupportedMediaElement(t) {
    return ["AUDIO", "VIDEO"].includes(t.nodeName);
  }
  reset() {
    this.mediaMap.clear();
  }
}
function Hp(e = window, t = document) {
  if ("scrollBehavior" in t.documentElement.style && e.__forceSmoothScrollPolyfill__ !== !0)
    return;
  const s = e.HTMLElement || e.Element, r = 468, n = {
    scroll: e.scroll || e.scrollTo,
    scrollBy: e.scrollBy,
    elementScroll: s.prototype.scroll || l,
    scrollIntoView: s.prototype.scrollIntoView
  }, o = e.performance && e.performance.now ? e.performance.now.bind(e.performance) : Date.now;
  function a(f) {
    const v = ["MSIE ", "Trident/", "Edge/"];
    return new RegExp(v.join("|")).test(f);
  }
  const i = a(e.navigator.userAgent) ? 1 : 0;
  function l(f, v) {
    this.scrollLeft = f, this.scrollTop = v;
  }
  function c(f) {
    return 0.5 * (1 - Math.cos(Math.PI * f));
  }
  function u(f) {
    if (f === null || typeof f != "object" || f.behavior === void 0 || f.behavior === "auto" || f.behavior === "instant")
      return !0;
    if (typeof f == "object" && f.behavior === "smooth")
      return !1;
    throw new TypeError(
      "behavior member of ScrollOptions " + f.behavior + " is not a valid value for enumeration ScrollBehavior."
    );
  }
  function h(f, v) {
    if (v === "Y")
      return f.clientHeight + i < f.scrollHeight;
    if (v === "X")
      return f.clientWidth + i < f.scrollWidth;
  }
  function p(f, v) {
    const w = e.getComputedStyle(f, null)["overflow" + v];
    return w === "auto" || w === "scroll";
  }
  function y(f) {
    const v = h(f, "Y") && p(f, "Y"), w = h(f, "X") && p(f, "X");
    return v || w;
  }
  function g(f) {
    for (; f !== t.body && y(f) === !1; )
      f = f.parentNode || f.host;
    return f;
  }
  function d(f) {
    const v = o();
    let w, k, E, A = (v - f.startTime) / r;
    A = A > 1 ? 1 : A, w = c(A), k = f.startX + (f.x - f.startX) * w, E = f.startY + (f.y - f.startY) * w, f.method.call(f.scrollable, k, E), (k !== f.x || E !== f.y) && e.requestAnimationFrame(d.bind(e, f));
  }
  function S(f, v, w) {
    let k, E, A, _;
    const Y = o();
    f === t.body ? (k = e, E = e.scrollX || e.pageXOffset, A = e.scrollY || e.pageYOffset, _ = n.scroll) : (k = f, E = f.scrollLeft, A = f.scrollTop, _ = l), d({
      scrollable: k,
      method: _,
      startTime: Y,
      startX: E,
      startY: A,
      x: v,
      y: w
    });
  }
  e.scroll = e.scrollTo = function() {
    if (arguments[0] !== void 0) {
      if (u(arguments[0]) === !0) {
        n.scroll.call(
          e,
          arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] != "object" ? arguments[0] : e.scrollX || e.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : e.scrollY || e.pageYOffset
        );
        return;
      }
      S.call(
        e,
        t.body,
        arguments[0].left !== void 0 ? ~~arguments[0].left : e.scrollX || e.pageXOffset,
        arguments[0].top !== void 0 ? ~~arguments[0].top : e.scrollY || e.pageYOffset
      );
    }
  }, e.scrollBy = function() {
    if (arguments[0] !== void 0) {
      if (u(arguments[0])) {
        n.scrollBy.call(
          e,
          arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] != "object" ? arguments[0] : 0,
          arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : 0
        );
        return;
      }
      S.call(
        e,
        t.body,
        ~~arguments[0].left + (e.scrollX || e.pageXOffset),
        ~~arguments[0].top + (e.scrollY || e.pageYOffset)
      );
    }
  }, s.prototype.scroll = s.prototype.scrollTo = function() {
    if (arguments[0] === void 0)
      return;
    if (u(arguments[0]) === !0) {
      if (typeof arguments[0] == "number" && arguments[1] === void 0)
        throw new SyntaxError("Value could not be converted");
      n.elementScroll.call(
        this,
        // use left prop, first number argument or fallback to scrollLeft
        arguments[0].left !== void 0 ? ~~arguments[0].left : typeof arguments[0] != "object" ? ~~arguments[0] : this.scrollLeft,
        // use top prop, second argument or fallback to scrollTop
        arguments[0].top !== void 0 ? ~~arguments[0].top : arguments[1] !== void 0 ? ~~arguments[1] : this.scrollTop
      );
      return;
    }
    const f = arguments[0].left, v = arguments[0].top;
    S.call(
      this,
      this,
      typeof f > "u" ? this.scrollLeft : ~~f,
      typeof v > "u" ? this.scrollTop : ~~v
    );
  }, s.prototype.scrollBy = function() {
    if (arguments[0] !== void 0) {
      if (u(arguments[0]) === !0) {
        n.elementScroll.call(
          this,
          arguments[0].left !== void 0 ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== void 0 ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop
        );
        return;
      }
      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    }
  }, s.prototype.scrollIntoView = function() {
    if (u(arguments[0]) === !0) {
      n.scrollIntoView.call(
        this,
        arguments[0] === void 0 ? !0 : arguments[0]
      );
      return;
    }
    const f = g(this), v = f.getBoundingClientRect(), w = this.getBoundingClientRect();
    f !== t.body ? (S.call(
      this,
      f,
      f.scrollLeft + w.left - v.left,
      f.scrollTop + w.top - v.top
    ), e.getComputedStyle(f).position !== "fixed" && e.scrollBy({
      left: v.left,
      top: v.top,
      behavior: "smooth"
    })) : e.scrollBy({
      left: w.left,
      top: w.top,
      behavior: "smooth"
    });
  };
}
const Jp = (e) => [
  `.${e} { background: currentColor }`,
  "noscript { display: none !important; }"
], Qp = 5 * 1e3, Kp = va || Lp, li = "[replayer]", js = {
  duration: 500,
  lineCap: "round",
  lineWidth: 3,
  strokeStyle: "red"
};
function ci(e) {
  return e.type == Q.IncrementalSnapshot && (e.data.source == U.TouchMove || e.data.source == U.MouseInteraction && e.data.type == ee.TouchStart);
}
class qp {
  constructor(t, s) {
    if (M(this, "wrapper"), M(this, "iframe"), M(this, "service"), M(this, "speedService"), M(this, "config"), M(this, "usingVirtualDom", !1), M(this, "virtualDom", new et()), M(this, "mouse"), M(this, "mouseTail", null), M(this, "tailPositions", []), M(this, "emitter", Kp()), M(this, "nextUserInteractionEvent"), M(this, "legacy_missingNodeRetryMap", {}), M(this, "cache", Rn()), M(this, "imageMap", /* @__PURE__ */ new Map()), M(this, "canvasEventMap", /* @__PURE__ */ new Map()), M(this, "mirror", zi()), M(this, "styleMirror", new fu()), M(this, "mediaManager"), M(this, "firstFullSnapshot", null), M(this, "newDocumentQueue", []), M(this, "mousePos", null), M(this, "touchActive", null), M(this, "lastMouseDownEvent", null), M(this, "lastHoveredRootNode"), M(this, "lastSelectionData", null), M(this, "constructedStyleMutations", []), M(this, "adoptedStyleSheets", []), M(this, "handleResize", (i) => {
      this.iframe.style.display = "inherit";
      for (const l of [this.mouseTail, this.iframe])
        l && (l.setAttribute("width", String(i.width)), l.setAttribute("height", String(i.height)));
    }), M(this, "applyEventsSynchronously", (i) => {
      for (const l of i) {
        switch (l.type) {
          case Q.DomContentLoaded:
          case Q.Load:
          case Q.Custom:
            continue;
          case Q.FullSnapshot:
          case Q.Meta:
          case Q.Plugin:
          case Q.IncrementalSnapshot:
            break;
        }
        this.getCastFn(l, !0)();
      }
    }), M(this, "getCastFn", (i, l = !1) => {
      let c;
      switch (i.type) {
        case Q.DomContentLoaded:
        case Q.Load:
          break;
        case Q.Custom:
          c = () => {
            this.emitter.emit(F.CustomEvent, i);
          };
          break;
        case Q.Meta:
          c = () => this.emitter.emit(F.Resize, {
            width: i.data.width,
            height: i.data.height
          });
          break;
        case Q.FullSnapshot:
          c = () => {
            var u;
            if (this.firstFullSnapshot) {
              if (this.firstFullSnapshot === i) {
                this.firstFullSnapshot = !0;
                return;
              }
            } else
              this.firstFullSnapshot = !0;
            this.mediaManager.reset(), this.styleMirror.reset(), this.rebuildFullSnapshot(i, l), (u = this.iframe.contentWindow) == null || u.scrollTo(i.data.initialOffset);
          };
          break;
        case Q.IncrementalSnapshot:
          c = () => {
            if (this.applyIncremental(i, l), !l && (i === this.nextUserInteractionEvent && (this.nextUserInteractionEvent = null, this.backToNormal()), !this.nextUserInteractionEvent)) {
              for (const u of this.service.state.context.events)
                if (!(u.timestamp <= i.timestamp) && this.isUserInteraction(u)) {
                  u.delay - i.delay > this.config.inactivePeriodThreshold * this.speedService.state.context.timer.speed && (this.nextUserInteractionEvent = u);
                  break;
                }
              if (this.nextUserInteractionEvent)
                if (this.config.skipInactive)
                  this.play(
                    this.nextUserInteractionEvent.timestamp - this.getMetaData().startTime - 1e3
                  );
                else {
                  const u = (
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.nextUserInteractionEvent.delay - i.delay
                  ), h = {
                    speed: Math.min(
                      Math.round(u / Qp),
                      this.config.maxSpeed
                    )
                  };
                  this.speedService.send({ type: "FAST_FORWARD", payload: h }), this.emitter.emit(F.SkipStart, h);
                }
            }
          };
          break;
      }
      return () => {
        c && c();
        for (const h of this.config.plugins || [])
          h.handler && h.handler(i, l, { replayer: this });
        this.service.send({ type: "CAST_EVENT", payload: { event: i } });
        const u = this.service.state.context.events.length - 1;
        if (!this.config.liveMode && i === this.service.state.context.events[u]) {
          const h = () => {
            u < this.service.state.context.events.length - 1 || (this.backToNormal(), this.service.send("END"), this.emitter.emit(F.Finish));
          };
          let p = 50;
          i.type === Q.IncrementalSnapshot && i.data.source === U.MouseMove && i.data.positions.length && (p += Math.max(0, -i.data.positions[0].timeOffset)), setTimeout(h, p);
        }
        this.emitter.emit(F.EventCast, i);
      };
    }), !(s != null && s.liveMode) && t.length < 2)
      throw new Error("Replayer need at least 2 events.");
    const r = {
      speed: 1,
      maxSpeed: 360,
      root: document.body,
      loadTimeout: 0,
      skipInactive: !1,
      inactivePeriodThreshold: 10 * 1e3,
      showWarning: !0,
      showDebug: !1,
      blockClass: "rr-block",
      liveMode: !1,
      insertStyleRules: [],
      triggerFocus: !0,
      UNSAFE_replayCanvas: !1,
      pauseAnimation: !0,
      mouseTail: js,
      useVirtualDom: !0,
      // Virtual-dom optimization is enabled by default.
      logger: console
    };
    this.config = Object.assign({}, r, s), this.handleResize = this.handleResize.bind(this), this.getCastFn = this.getCastFn.bind(this), this.applyEventsSynchronously = this.applyEventsSynchronously.bind(this), this.emitter.on(F.Resize, this.handleResize), this.setupDom();
    for (const i of this.config.plugins || [])
      i.getMirror && i.getMirror({ nodeMirror: this.mirror });
    this.emitter.on(F.Flush, () => {
      if (this.usingVirtualDom) {
        const i = {
          mirror: this.mirror,
          applyCanvas: (l, c, u) => {
            ti({
              event: l,
              mutation: c,
              target: u,
              imageMap: this.imageMap,
              canvasEventMap: this.canvasEventMap,
              errorHandler: this.warnCanvasMutationFailed.bind(this)
            });
          },
          applyInput: this.applyInput.bind(this),
          applyScroll: this.applyScroll.bind(this),
          applyStyleSheetMutation: (l, c) => {
            l.source === U.StyleSheetRule ? this.applyStyleSheetRule(l, c) : l.source === U.StyleDeclaration && this.applyStyleDeclaration(l, c);
          },
          afterAppend: (l, c) => {
            for (const u of this.config.plugins || [])
              u.onBuild && u.onBuild(l, { id: c, replayer: this });
          }
        };
        if (this.iframe.contentDocument)
          try {
            hs(
              this.iframe.contentDocument,
              this.virtualDom,
              i,
              this.virtualDom.mirror
            );
          } catch (l) {
            console.warn(l);
          }
        if (this.virtualDom.destroyTree(), this.usingVirtualDom = !1, Object.keys(this.legacy_missingNodeRetryMap).length)
          for (const l in this.legacy_missingNodeRetryMap)
            try {
              const c = this.legacy_missingNodeRetryMap[l], u = ps(
                c.node,
                this.mirror,
                this.virtualDom.mirror
              );
              hs(
                u,
                c.node,
                i,
                this.virtualDom.mirror
              ), c.node = u;
            } catch (c) {
              this.warn(c);
            }
        this.constructedStyleMutations.forEach((l) => {
          this.applyStyleSheetMutation(l);
        }), this.constructedStyleMutations = [], this.adoptedStyleSheets.forEach((l) => {
          this.applyAdoptedStyleSheet(l);
        }), this.adoptedStyleSheets = [];
      }
      if (this.mousePos && (this.moveAndHover(
        this.mousePos.x,
        this.mousePos.y,
        this.mousePos.id,
        !0,
        this.mousePos.debugData
      ), this.mousePos = null), this.touchActive === !0 ? this.mouse.classList.add("touch-active") : this.touchActive === !1 && this.mouse.classList.remove("touch-active"), this.touchActive = null, this.lastMouseDownEvent) {
        const [i, l] = this.lastMouseDownEvent;
        i.dispatchEvent(l);
      }
      this.lastMouseDownEvent = null, this.lastSelectionData && (this.applySelection(this.lastSelectionData), this.lastSelectionData = null);
    }), this.emitter.on(F.PlayBack, () => {
      this.firstFullSnapshot = null, this.mirror.reset(), this.styleMirror.reset(), this.mediaManager.reset();
    });
    const n = new Vp([], {
      speed: this.config.speed
    });
    this.service = Gp(
      {
        events: t.map((i) => s && s.unpackFn ? s.unpackFn(i) : i).sort((i, l) => i.timestamp - l.timestamp),
        timer: n,
        timeOffset: 0,
        baselineTime: 0,
        lastPlayedEvent: null
      },
      {
        getCastFn: this.getCastFn,
        applyEventsSynchronously: this.applyEventsSynchronously,
        emitter: this.emitter
      }
    ), this.service.start(), this.service.subscribe((i) => {
      this.emitter.emit(F.StateChange, {
        player: i
      });
    }), this.speedService = Zp({
      normalSpeed: -1,
      timer: n
    }), this.speedService.start(), this.speedService.subscribe((i) => {
      this.emitter.emit(F.StateChange, {
        speed: i
      });
    }), this.mediaManager = new Xp({
      warn: this.warn.bind(this),
      service: this.service,
      speedService: this.speedService,
      emitter: this.emitter,
      getCurrentTime: this.getCurrentTime.bind(this)
    });
    const o = this.service.state.context.events.find(
      (i) => i.type === Q.Meta
    ), a = this.service.state.context.events.find(
      (i) => i.type === Q.FullSnapshot
    );
    if (o) {
      const { width: i, height: l } = o.data;
      setTimeout(() => {
        this.emitter.emit(F.Resize, {
          width: i,
          height: l
        });
      }, 0);
    }
    a && setTimeout(() => {
      var i;
      this.firstFullSnapshot || (this.firstFullSnapshot = a, this.rebuildFullSnapshot(
        a
      ), (i = this.iframe.contentWindow) == null || i.scrollTo(
        a.data.initialOffset
      ));
    }, 1), this.service.state.context.events.find(ci) && this.mouse.classList.add("touch-device");
  }
  get timer() {
    return this.service.state.context.timer;
  }
  on(t, s) {
    return this.emitter.on(t, s), this;
  }
  off(t, s) {
    return this.emitter.off(t, s), this;
  }
  setConfig(t) {
    Object.keys(t).forEach((s) => {
      t[s], this.config[s] = t[s];
    }), this.config.skipInactive || this.backToNormal(), typeof t.speed < "u" && this.speedService.send({
      type: "SET_SPEED",
      payload: {
        speed: t.speed
      }
    }), typeof t.mouseTail < "u" && (t.mouseTail === !1 ? this.mouseTail && (this.mouseTail.style.display = "none") : (this.mouseTail || (this.mouseTail = document.createElement("canvas"), this.mouseTail.width = Number.parseFloat(this.iframe.width), this.mouseTail.height = Number.parseFloat(this.iframe.height), this.mouseTail.classList.add("replayer-mouse-tail"), this.wrapper.insertBefore(this.mouseTail, this.iframe)), this.mouseTail.style.display = "inherit"));
  }
  getMetaData() {
    const t = this.service.state.context.events[0], s = this.service.state.context.events[this.service.state.context.events.length - 1];
    return {
      startTime: t.timestamp,
      endTime: s.timestamp,
      totalTime: s.timestamp - t.timestamp
    };
  }
  /**
   * Get the actual time offset the player is at now compared to the first event.
   */
  getCurrentTime() {
    return this.timer.timeOffset + this.getTimeOffset();
  }
  /**
   * Get the time offset the player is at now compared to the first event, but without regard for the timer.
   */
  getTimeOffset() {
    const { baselineTime: t, events: s } = this.service.state.context;
    return t - s[0].timestamp;
  }
  getMirror() {
    return this.mirror;
  }
  /**
   * This API was designed to be used as play at any time offset.
   * Since we minimized the data collected from recorder, we do not
   * have the ability of undo an event.
   * So the implementation of play at any time offset will always iterate
   * all of the events, cast event before the offset synchronously
   * and cast event after the offset asynchronously with timer.
   * @param timeOffset - number
   */
  play(t = 0) {
    var s, r;
    this.service.state.matches("paused") ? this.service.send({ type: "PLAY", payload: { timeOffset: t } }) : (this.service.send({ type: "PAUSE" }), this.service.send({ type: "PLAY", payload: { timeOffset: t } })), (r = (s = this.iframe.contentDocument) == null ? void 0 : s.getElementsByTagName("html")[0]) == null || r.classList.remove("@sailfish-rrweb/rrweb-paused"), this.emitter.emit(F.Start);
  }
  pause(t) {
    var s, r;
    t === void 0 && this.service.state.matches("playing") && this.service.send({ type: "PAUSE" }), typeof t == "number" && (this.play(t), this.service.send({ type: "PAUSE" })), (r = (s = this.iframe.contentDocument) == null ? void 0 : s.getElementsByTagName("html")[0]) == null || r.classList.add("@sailfish-rrweb/rrweb-paused"), this.emitter.emit(F.Pause);
  }
  resume(t = 0) {
    this.warn(
      "The 'resume' was deprecated in 1.0. Please use 'play' method which has the same interface."
    ), this.play(t), this.emitter.emit(F.Resume);
  }
  /**
   * Totally destroy this replayer and please be careful that this operation is irreversible.
   * Memory occupation can be released by removing all references to this replayer.
   */
  destroy() {
    this.pause(), this.mirror.reset(), this.styleMirror.reset(), this.mediaManager.reset(), this.config.root.removeChild(this.wrapper), this.emitter.emit(F.Destroy);
  }
  startLive(t) {
    this.service.send({ type: "TO_LIVE", payload: { baselineTime: t } });
  }
  addEvent(t) {
    const s = this.config.unpackFn ? this.config.unpackFn(t) : t;
    ci(s) && this.mouse.classList.add("touch-device"), Promise.resolve().then(
      () => this.service.send({ type: "ADD_EVENT", payload: { event: s } })
    );
  }
  enableInteract() {
    this.iframe.setAttribute("scrolling", "auto"), this.iframe.style.pointerEvents = "auto";
  }
  disableInteract() {
    this.iframe.setAttribute("scrolling", "no"), this.iframe.style.pointerEvents = "none";
  }
  /**
   * Empties the replayer's cache and reclaims memory.
   * The replayer will use this cache to speed up the playback.
   */
  resetCache() {
    this.cache = Rn();
  }
  setupDom() {
    this.wrapper = document.createElement("div"), this.wrapper.classList.add("replayer-wrapper"), this.config.root.appendChild(this.wrapper), this.mouse = document.createElement("div"), this.mouse.classList.add("replayer-mouse"), this.wrapper.appendChild(this.mouse), this.config.mouseTail !== !1 && (this.mouseTail = document.createElement("canvas"), this.mouseTail.classList.add("replayer-mouse-tail"), this.mouseTail.style.display = "inherit", this.wrapper.appendChild(this.mouseTail)), this.iframe = document.createElement("iframe");
    const t = ["allow-same-origin"];
    this.config.UNSAFE_replayCanvas && t.push("allow-scripts"), this.iframe.style.display = "none", this.iframe.setAttribute("sandbox", t.join(" ")), this.disableInteract(), this.wrapper.appendChild(this.iframe), this.iframe.contentWindow && this.iframe.contentDocument && (Hp(
      this.iframe.contentWindow,
      this.iframe.contentDocument
    ), hu(this.iframe.contentWindow));
  }
  rebuildFullSnapshot(t, s = !1) {
    if (!this.iframe.contentDocument)
      return this.warn("Looks like your replayer has been destroyed.");
    Object.keys(this.legacy_missingNodeRetryMap).length && this.warn(
      "Found unresolved missing node map",
      this.legacy_missingNodeRetryMap
    ), this.legacy_missingNodeRetryMap = {};
    const r = [], n = (i, l) => {
      if (this.collectIframeAndAttachDocument(r, i), this.mediaManager.isSupportedMediaElement(i)) {
        const { events: c } = this.service.state.context;
        this.mediaManager.addMediaElements(
          i,
          t.timestamp - c[0].timestamp,
          this.mirror
        );
      }
      for (const c of this.config.plugins || [])
        c.onBuild && c.onBuild(i, {
          id: l,
          replayer: this
        });
    };
    this.usingVirtualDom && (this.virtualDom.destroyTree(), this.usingVirtualDom = !1), this.mirror.reset(), uu(t.data.node, {
      doc: this.iframe.contentDocument,
      afterAppend: n,
      cache: this.cache,
      mirror: this.mirror
    }), n(this.iframe.contentDocument, t.data.node.id);
    for (const { mutationInQueue: i, builtNode: l } of r)
      this.attachDocumentToIframe(i, l), this.newDocumentQueue = this.newDocumentQueue.filter(
        (c) => c !== i
      );
    const { documentElement: o, head: a } = this.iframe.contentDocument;
    this.insertStyleRules(o, a), this.service.state.matches("playing") || this.iframe.contentDocument.getElementsByTagName("html")[0].classList.add("@sailfish-rrweb/rrweb-paused"), this.emitter.emit(F.FullsnapshotRebuilded, t), s || this.waitForStylesheetLoad(), this.config.UNSAFE_replayCanvas && this.preloadAllImages();
  }
  insertStyleRules(t, s) {
    var r;
    const n = Jp(
      this.config.blockClass
    ).concat(this.config.insertStyleRules);
    if (this.config.pauseAnimation && n.push(
      "html.rrweb-paused *, html.rrweb-paused *:before, html.rrweb-paused *:after { animation-play-state: paused !important; }"
    ), this.usingVirtualDom) {
      const o = this.virtualDom.createElement("style");
      this.virtualDom.mirror.add(
        o,
        wa(o, this.virtualDom.unserializedId)
      ), t.insertBefore(o, s), o.rules.push({
        source: U.StyleSheetRule,
        adds: n.map((a, i) => ({
          rule: a,
          index: i
        }))
      });
    } else {
      const o = document.createElement("style");
      t.insertBefore(
        o,
        s
      );
      for (let a = 0; a < n.length; a++)
        (r = o.sheet) == null || r.insertRule(n[a], a);
    }
  }
  attachDocumentToIframe(t, s) {
    const r = this.usingVirtualDom ? this.virtualDom.mirror : this.mirror, n = [], o = (a, i) => {
      this.collectIframeAndAttachDocument(n, a);
      const l = r.getMeta(a);
      if ((l == null ? void 0 : l.type) === W.Element && (l == null ? void 0 : l.tagName.toUpperCase()) === "HTML") {
        const { documentElement: c, head: u } = s.contentDocument;
        this.insertStyleRules(
          c,
          u
        );
      }
      if (!this.usingVirtualDom)
        for (const c of this.config.plugins || [])
          c.onBuild && c.onBuild(a, {
            id: i,
            replayer: this
          });
    };
    ft(t.node, {
      doc: s.contentDocument,
      mirror: r,
      hackCss: !0,
      skipChild: !1,
      afterAppend: o,
      cache: this.cache
    }), o(s.contentDocument, t.node.id);
    for (const { mutationInQueue: a, builtNode: i } of n)
      this.attachDocumentToIframe(a, i), this.newDocumentQueue = this.newDocumentQueue.filter(
        (l) => l !== a
      );
  }
  collectIframeAndAttachDocument(t, s) {
    if (_s(s, this.mirror)) {
      const r = this.newDocumentQueue.find(
        (n) => n.parentId === this.mirror.getId(s)
      );
      r && t.push({
        mutationInQueue: r,
        builtNode: s
      });
    }
  }
  /**
   * pause when loading style sheet, resume when loaded all timeout exceed
   */
  waitForStylesheetLoad() {
    var t;
    const s = (t = this.iframe.contentDocument) == null ? void 0 : t.head;
    if (s) {
      const r = /* @__PURE__ */ new Set();
      let n, o = this.service.state;
      const a = () => {
        o = this.service.state;
      };
      this.emitter.on(F.Start, a), this.emitter.on(F.Pause, a);
      const i = () => {
        this.emitter.off(F.Start, a), this.emitter.off(F.Pause, a);
      };
      s.querySelectorAll('link[rel="stylesheet"]').forEach((l) => {
        l.sheet || (r.add(l), l.addEventListener("load", () => {
          r.delete(l), r.size === 0 && n !== -1 && (o.matches("playing") && this.play(this.getCurrentTime()), this.emitter.emit(F.LoadStylesheetEnd), n && clearTimeout(n), i());
        }));
      }), r.size > 0 && (this.service.send({ type: "PAUSE" }), this.emitter.emit(F.LoadStylesheetStart), n = setTimeout(() => {
        o.matches("playing") && this.play(this.getCurrentTime()), n = -1, i();
      }, this.config.loadTimeout));
    }
  }
  /**
   * pause when there are some canvas drawImage args need to be loaded
   */
  async preloadAllImages() {
    const t = [];
    for (const s of this.service.state.context.events)
      s.type === Q.IncrementalSnapshot && s.data.source === U.CanvasMutation && (t.push(
        this.deserializeAndPreloadCanvasEvents(s.data, s)
      ), ("commands" in s.data ? s.data.commands : [s.data]).forEach((r) => {
        this.preloadImages(r, s);
      }));
    return Promise.all(t);
  }
  preloadImages(t, s) {
    if (t.property === "drawImage" && typeof t.args[0] == "string" && !this.imageMap.has(s)) {
      const r = document.createElement("canvas"), n = r.getContext("2d"), o = n == null ? void 0 : n.createImageData(r.width, r.height);
      n == null || n.putImageData(o, 0, 0);
    }
  }
  async deserializeAndPreloadCanvasEvents(t, s) {
    if (!this.canvasEventMap.has(s)) {
      const r = {
        isUnchanged: !0
      };
      if ("commands" in t) {
        const n = await Promise.all(
          t.commands.map(async (o) => {
            const a = await Promise.all(
              o.args.map(De(this.imageMap, null, r))
            );
            return { ...o, args: a };
          })
        );
        r.isUnchanged === !1 && this.canvasEventMap.set(s, { ...t, commands: n });
      } else {
        const n = await Promise.all(
          t.args.map(De(this.imageMap, null, r))
        );
        r.isUnchanged === !1 && this.canvasEventMap.set(s, { ...t, args: n });
      }
    }
  }
  applyIncremental(t, s) {
    var r, n, o;
    const { data: a } = t;
    switch (a.source) {
      case U.Mutation: {
        try {
          this.applyMutation(a, s);
        } catch (i) {
          this.warn(`Exception in mutation ${i.message || i}`, a);
        }
        break;
      }
      case U.Drag:
      case U.TouchMove:
      case U.MouseMove:
        if (s) {
          const i = a.positions[a.positions.length - 1];
          this.mousePos = {
            x: i.x,
            y: i.y,
            id: i.id,
            debugData: a
          };
        } else
          a.positions.forEach((i) => {
            const l = {
              doAction: () => {
                this.moveAndHover(i.x, i.y, i.id, s, a);
              },
              delay: i.timeOffset + t.timestamp - this.service.state.context.baselineTime
            };
            this.timer.addAction(l);
          }), this.timer.addAction({
            doAction() {
            },
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            delay: t.delay - ((r = a.positions[0]) == null ? void 0 : r.timeOffset)
          });
        break;
      case U.MouseInteraction: {
        if (a.id === -1)
          break;
        const i = new Event(hl(ee[a.type])), l = this.mirror.getNode(a.id);
        if (!l)
          return this.debugNodeNotFound(a, a.id);
        this.emitter.emit(F.MouseInteraction, {
          type: a.type,
          target: l
        });
        const { triggerFocus: c } = this.config;
        switch (a.type) {
          case ee.Blur:
            "blur" in l && l.blur();
            break;
          case ee.Focus:
            c && l.focus && l.focus({
              preventScroll: !0
            });
            break;
          case ee.Click:
          case ee.TouchStart:
          case ee.TouchEnd:
          case ee.MouseDown:
          case ee.MouseUp:
            s ? (a.type === ee.TouchStart ? this.touchActive = !0 : a.type === ee.TouchEnd && (this.touchActive = !1), a.type === ee.MouseDown ? this.lastMouseDownEvent = [l, i] : a.type === ee.MouseUp && (this.lastMouseDownEvent = null), this.mousePos = {
              x: a.x || 0,
              y: a.y || 0,
              id: a.id,
              debugData: a
            }) : (a.type === ee.TouchStart && (this.tailPositions.length = 0), this.moveAndHover(a.x || 0, a.y || 0, a.id, s, a), a.type === ee.Click ? (this.mouse.classList.remove("active"), this.mouse.offsetWidth, this.mouse.classList.add("active")) : a.type === ee.TouchStart ? (this.mouse.offsetWidth, this.mouse.classList.add("touch-active")) : a.type === ee.TouchEnd ? this.mouse.classList.remove("touch-active") : l.dispatchEvent(i));
            break;
          case ee.TouchCancel:
            s ? this.touchActive = !1 : this.mouse.classList.remove("touch-active");
            break;
          default:
            l.dispatchEvent(i);
        }
        break;
      }
      case U.Scroll: {
        if (a.id === -1)
          break;
        if (this.usingVirtualDom) {
          const i = this.virtualDom.mirror.getNode(a.id);
          if (!i)
            return this.debugNodeNotFound(a, a.id);
          i.scrollData = a;
          break;
        }
        this.applyScroll(a, s);
        break;
      }
      case U.ViewportResize:
        this.emitter.emit(F.Resize, {
          width: a.width,
          height: a.height
        });
        break;
      case U.Input: {
        if (a.id === -1)
          break;
        if (this.usingVirtualDom) {
          const i = this.virtualDom.mirror.getNode(a.id);
          if (!i)
            return this.debugNodeNotFound(a, a.id);
          i.inputData = a;
          break;
        }
        this.applyInput(a);
        break;
      }
      case U.MediaInteraction: {
        const i = this.usingVirtualDom ? this.virtualDom.mirror.getNode(a.id) : this.mirror.getNode(a.id);
        if (!i)
          return this.debugNodeNotFound(a, a.id);
        const l = i, { events: c } = this.service.state.context;
        this.mediaManager.mediaMutation({
          target: l,
          timeOffset: t.timestamp - c[0].timestamp,
          mutation: a
        });
        break;
      }
      case U.StyleSheetRule:
      case U.StyleDeclaration: {
        this.usingVirtualDom ? a.styleId ? this.constructedStyleMutations.push(a) : a.id && ((n = this.virtualDom.mirror.getNode(a.id)) == null || n.rules.push(a)) : this.applyStyleSheetMutation(a);
        break;
      }
      case U.CanvasMutation: {
        if (!this.config.UNSAFE_replayCanvas)
          return;
        if (this.usingVirtualDom) {
          const i = this.virtualDom.mirror.getNode(
            a.id
          );
          if (!i)
            return this.debugNodeNotFound(a, a.id);
          i.canvasMutations.push({
            event: t,
            mutation: a
          });
        } else {
          const i = this.mirror.getNode(a.id);
          if (!i)
            return this.debugNodeNotFound(a, a.id);
          ti({
            event: t,
            mutation: a,
            target: i,
            imageMap: this.imageMap,
            canvasEventMap: this.canvasEventMap,
            errorHandler: this.warnCanvasMutationFailed.bind(this)
          });
        }
        break;
      }
      case U.Font: {
        try {
          const i = new FontFace(
            a.family,
            a.buffer ? new Uint8Array(JSON.parse(a.fontSource)) : a.fontSource,
            a.descriptors
          );
          (o = this.iframe.contentDocument) == null || o.fonts.add(i);
        } catch (i) {
          this.warn(i);
        }
        break;
      }
      case U.Selection: {
        if (s) {
          this.lastSelectionData = a;
          break;
        }
        this.applySelection(a);
        break;
      }
      case U.AdoptedStyleSheet: {
        this.usingVirtualDom ? this.adoptedStyleSheets.push(a) : this.applyAdoptedStyleSheet(a);
        break;
      }
    }
  }
  /**
   * Apply the mutation to the virtual dom or the real dom.
   * @param d - The mutation data.
   * @param isSync - Whether the mutation should be applied synchronously (while fast-forwarding).
   */
  applyMutation(t, s) {
    if (this.config.useVirtualDom && !this.usingVirtualDom && s && (this.usingVirtualDom = !0, Pp(this.iframe.contentDocument, this.mirror, this.virtualDom), Object.keys(this.legacy_missingNodeRetryMap).length))
      for (const c in this.legacy_missingNodeRetryMap)
        try {
          const u = this.legacy_missingNodeRetryMap[c], h = ya(
            u.node,
            this.virtualDom,
            this.mirror
          );
          h && (u.node = h);
        } catch (u) {
          this.warn(u);
        }
    const r = this.usingVirtualDom ? this.virtualDom.mirror : this.mirror;
    t.removes = t.removes.filter((c) => r.getNode(c.id) ? !0 : (this.warnNodeNotFound(t, c.id), !1)), t.removes.forEach((c) => {
      var u;
      const h = r.getNode(c.id);
      if (!h)
        return;
      let p = r.getNode(
        c.parentId
      );
      if (!p)
        return this.warnNodeNotFound(t, c.parentId);
      if (c.isShadow && Ut(p) && (p = p.shadowRoot), r.removeNodeFromMap(h), p)
        try {
          p.removeChild(h), this.usingVirtualDom && h.nodeName === "#text" && p.nodeName === "STYLE" && ((u = p.rules) == null ? void 0 : u.length) > 0 && (p.rules = []);
        } catch (y) {
          if (y instanceof DOMException)
            this.warn(
              "parent could not remove child in mutation",
              p,
              h,
              t
            );
          else
            throw y;
        }
    });
    const n = {
      ...this.legacy_missingNodeRetryMap
    }, o = [], a = (c) => {
      let u = null;
      return c.nextId && (u = r.getNode(c.nextId)), c.nextId !== null && c.nextId !== void 0 && c.nextId !== -1 && !u;
    }, i = (c) => {
      var u, h;
      if (!this.iframe.contentDocument)
        return this.warn("Looks like your replayer has been destroyed.");
      let p = r.getNode(
        c.parentId
      );
      if (!p)
        return c.node.type === W.Document ? this.newDocumentQueue.push(c) : o.push(c);
      c.node.isShadow && (Ut(p) || p.attachShadow({ mode: "open" }), p = p.shadowRoot);
      let y = null, g = null;
      if (c.previousId && (y = r.getNode(c.previousId)), c.nextId && (g = r.getNode(c.nextId)), a(c))
        return o.push(c);
      if (c.node.rootId && !r.getNode(c.node.rootId))
        return;
      const d = c.node.rootId ? r.getNode(c.node.rootId) : this.usingVirtualDom ? this.virtualDom : this.iframe.contentDocument;
      if (_s(p, r)) {
        this.attachDocumentToIframe(
          c,
          p
        );
        return;
      }
      const S = (w, k) => {
        if (!this.usingVirtualDom)
          for (const E of this.config.plugins || [])
            E.onBuild && E.onBuild(w, { id: k, replayer: this });
      }, f = ft(c.node, {
        doc: d,
        // can be Document or RRDocument
        mirror: r,
        // can be this.mirror or virtualDom.mirror
        skipChild: !0,
        hackCss: !0,
        cache: this.cache,
        /**
         * caveat: `afterAppend` only gets called on child nodes of target
         * we have to call it again below when this target was added to the DOM
         */
        afterAppend: S
      });
      if (c.previousId === -1 || c.nextId === -1) {
        n[c.node.id] = {
          node: f,
          mutation: c
        };
        return;
      }
      const v = r.getMeta(p);
      if (v && v.type === W.Element && c.node.type === W.Text) {
        const w = Array.isArray(p.childNodes) ? p.childNodes : Array.from(p.childNodes);
        if (v.tagName === "textarea")
          for (const k of w)
            k.nodeType === p.TEXT_NODE && p.removeChild(k);
        else if (v.tagName === "style" && w.length === 1)
          for (const k of w)
            k.nodeType === p.TEXT_NODE && !r.hasNode(k) && (f.textContent = k.textContent, p.removeChild(k));
      } else if ((v == null ? void 0 : v.type) === W.Document) {
        const w = p;
        c.node.type === W.DocumentType && ((u = w.childNodes[0]) == null ? void 0 : u.nodeType) === Node.DOCUMENT_TYPE_NODE && w.removeChild(w.childNodes[0]), f.nodeName === "HTML" && w.documentElement && w.removeChild(
          w.documentElement
        );
      }
      if (y && y.nextSibling && y.nextSibling.parentNode ? p.insertBefore(
        f,
        y.nextSibling
      ) : g && g.parentNode ? p.contains(g) ? p.insertBefore(f, g) : p.insertBefore(f, null) : p.appendChild(f), S(f, c.node.id), this.usingVirtualDom && f.nodeName === "#text" && p.nodeName === "STYLE" && ((h = p.rules) == null ? void 0 : h.length) > 0 && (p.rules = []), _s(f, this.mirror)) {
        const w = this.mirror.getId(f), k = this.newDocumentQueue.find(
          (E) => E.parentId === w
        );
        k && (this.attachDocumentToIframe(
          k,
          f
        ), this.newDocumentQueue = this.newDocumentQueue.filter(
          (E) => E !== k
        ));
      }
      (c.previousId || c.nextId) && this.legacy_resolveMissingNode(
        n,
        p,
        f,
        c
      );
    };
    t.adds.forEach((c) => {
      i(c);
    });
    const l = Date.now();
    for (; o.length; ) {
      const c = pu(o);
      if (o.length = 0, Date.now() - l > 500) {
        this.warn(
          "Timeout in the loop, please check the resolve tree data:",
          c
        );
        break;
      }
      for (const u of c)
        r.getNode(u.value.parentId) ? ko(u, (h) => {
          i(h);
        }) : this.debug(
          "Drop resolve tree since there is no parent for the root node.",
          u
        );
    }
    Object.keys(n).length && Object.assign(this.legacy_missingNodeRetryMap, n), du(t.texts).forEach((c) => {
      var u;
      const h = r.getNode(c.id);
      if (!h)
        return t.removes.find((p) => p.id === c.id) ? void 0 : this.warnNodeNotFound(t, c.id);
      if (h.textContent = c.value, this.usingVirtualDom) {
        const p = h.parentNode;
        ((u = p == null ? void 0 : p.rules) == null ? void 0 : u.length) > 0 && (p.rules = []);
      }
    }), t.attributes.forEach((c) => {
      var u;
      const h = r.getNode(c.id);
      if (!h)
        return t.removes.find((p) => p.id === c.id) ? void 0 : this.warnNodeNotFound(t, c.id);
      for (const p in c.attributes)
        if (typeof p == "string") {
          const y = c.attributes[p];
          if (y === null)
            h.removeAttribute(p);
          else if (typeof y == "string")
            try {
              if (p === "_cssText" && (h.nodeName === "LINK" || h.nodeName === "STYLE"))
                try {
                  const g = r.getMeta(
                    h
                  );
                  Object.assign(
                    g.attributes,
                    c.attributes
                  );
                  const d = ft(g, {
                    doc: h.ownerDocument,
                    // can be Document or RRDocument
                    mirror: r,
                    skipChild: !0,
                    hackCss: !0,
                    cache: this.cache
                  }), S = h.nextSibling, f = h.parentNode;
                  if (d && f) {
                    f.removeChild(h), f.insertBefore(
                      d,
                      S
                    ), r.replace(c.id, d);
                    break;
                  }
                } catch {
                }
              if (p === "value" && h.nodeName === "TEXTAREA") {
                const g = h;
                g.childNodes.forEach(
                  (S) => g.removeChild(S)
                );
                const d = (u = h.ownerDocument) == null ? void 0 : u.createTextNode(y);
                d && g.appendChild(d);
              } else
                h.setAttribute(
                  p,
                  y
                );
            } catch (g) {
              this.warn(
                "An error occurred may due to the checkout feature.",
                g
              );
            }
          else if (p === "style") {
            const g = y, d = h;
            for (const S in g)
              if (g[S] === !1)
                d.style.removeProperty(S);
              else if (g[S] instanceof Array) {
                const f = g[S];
                d.style.setProperty(S, f[0], f[1]);
              } else {
                const f = g[S];
                d.style.setProperty(S, f);
              }
          }
        }
    });
  }
  /**
   * Apply the scroll data on real elements.
   * If the replayer is in sync mode, smooth scroll behavior should be disabled.
   * @param d - the scroll data
   * @param isSync - whether the replayer is in sync mode(fast-forward)
   */
  applyScroll(t, s) {
    var r, n;
    const o = this.mirror.getNode(t.id);
    if (!o)
      return this.debugNodeNotFound(t, t.id);
    const a = this.mirror.getMeta(o);
    if (o === this.iframe.contentDocument)
      (r = this.iframe.contentWindow) == null || r.scrollTo({
        top: t.y,
        left: t.x,
        behavior: s ? "auto" : "smooth"
      });
    else if ((a == null ? void 0 : a.type) === W.Document)
      (n = o.defaultView) == null || n.scrollTo({
        top: t.y,
        left: t.x,
        behavior: s ? "auto" : "smooth"
      });
    else
      try {
        o.scrollTo({
          top: t.y,
          left: t.x,
          behavior: s ? "auto" : "smooth"
        });
      } catch {
      }
  }
  applyInput(t) {
    const s = this.mirror.getNode(t.id);
    if (!s)
      return this.debugNodeNotFound(t, t.id);
    try {
      s.checked = t.isChecked, s.value = t.text;
    } catch {
    }
  }
  applySelection(t) {
    try {
      const s = /* @__PURE__ */ new Set(), r = t.ranges.map(({ start: n, startOffset: o, end: a, endOffset: i }) => {
        const l = this.mirror.getNode(n), c = this.mirror.getNode(a);
        if (!l || !c) return;
        const u = new Range();
        u.setStart(l, o), u.setEnd(c, i);
        const h = l.ownerDocument, p = h == null ? void 0 : h.getSelection();
        return p && s.add(p), {
          range: u,
          selection: p
        };
      });
      s.forEach((n) => n.removeAllRanges()), r.forEach((n) => {
        var o;
        return n && ((o = n.selection) == null ? void 0 : o.addRange(n.range));
      });
    } catch {
    }
  }
  applyStyleSheetMutation(t) {
    var s;
    let r = null;
    t.styleId ? r = this.styleMirror.getStyle(t.styleId) : t.id && (r = ((s = this.mirror.getNode(t.id)) == null ? void 0 : s.sheet) || null), r && (t.source === U.StyleSheetRule ? this.applyStyleSheetRule(t, r) : t.source === U.StyleDeclaration && this.applyStyleDeclaration(t, r));
  }
  applyStyleSheetRule(t, s) {
    var r, n, o, a;
    if ((r = t.adds) == null || r.forEach(({ rule: i, index: l }) => {
      try {
        if (Array.isArray(l)) {
          const { positions: c, index: u } = An(l);
          ut(s.cssRules, c).insertRule(i, u);
        } else {
          const c = l === void 0 ? void 0 : Math.min(l, s.cssRules.length);
          s == null || s.insertRule(i, c);
        }
      } catch {
      }
    }), (n = t.removes) == null || n.forEach(({ index: i }) => {
      try {
        if (Array.isArray(i)) {
          const { positions: l, index: c } = An(i);
          ut(s.cssRules, l).deleteRule(c || 0);
        } else
          s == null || s.deleteRule(i);
      } catch {
      }
    }), t.replace)
      try {
        (o = s.replace) == null || o.call(s, t.replace);
      } catch {
      }
    if (t.replaceSync)
      try {
        (a = s.replaceSync) == null || a.call(s, t.replaceSync);
      } catch {
      }
  }
  applyStyleDeclaration(t, s) {
    t.set && ut(
      s.rules,
      t.index
    ).style.setProperty(
      t.set.property,
      t.set.value,
      t.set.priority
    ), t.remove && ut(
      s.rules,
      t.index
    ).style.removeProperty(t.remove.property);
  }
  applyAdoptedStyleSheet(t) {
    var s;
    const r = this.mirror.getNode(t.id);
    if (!r) return;
    (s = t.styles) == null || s.forEach((i) => {
      var l;
      let c = null, u = null;
      if (Ut(r) ? u = ((l = r.ownerDocument) == null ? void 0 : l.defaultView) || null : r.nodeName === "#document" && (u = r.defaultView), !!u)
        try {
          c = new u.CSSStyleSheet(), this.styleMirror.add(c, i.styleId), this.applyStyleSheetRule(
            {
              source: U.StyleSheetRule,
              adds: i.rules
            },
            c
          );
        } catch {
        }
    });
    const n = 10;
    let o = 0;
    const a = (i, l) => {
      const c = l.map((u) => this.styleMirror.getStyle(u)).filter((u) => u !== null);
      Ut(i) ? i.shadowRoot.adoptedStyleSheets = c : i.nodeName === "#document" && (i.adoptedStyleSheets = c), c.length !== l.length && o < n && (setTimeout(
        () => a(i, l),
        0 + 100 * o
      ), o++);
    };
    a(r, t.styleIds);
  }
  legacy_resolveMissingNode(t, s, r, n) {
    const { previousId: o, nextId: a } = n, i = o && t[o], l = a && t[a];
    if (i) {
      const { node: c, mutation: u } = i;
      s.insertBefore(c, r), delete t[u.node.id], delete this.legacy_missingNodeRetryMap[u.node.id], (u.previousId || u.nextId) && this.legacy_resolveMissingNode(t, s, c, u);
    }
    if (l) {
      const { node: c, mutation: u } = l;
      s.insertBefore(
        c,
        r.nextSibling
      ), delete t[u.node.id], delete this.legacy_missingNodeRetryMap[u.node.id], (u.previousId || u.nextId) && this.legacy_resolveMissingNode(t, s, c, u);
    }
  }
  moveAndHover(t, s, r, n, o) {
    const a = this.mirror.getNode(r);
    if (!a)
      return this.debugNodeNotFound(o, r);
    const i = Mo(a, this.iframe), l = t * i.absoluteScale + i.x, c = s * i.absoluteScale + i.y;
    this.mouse.style.left = `${l}px`, this.mouse.style.top = `${c}px`, n || this.drawMouseTail({ x: l, y: c }), this.hoverElements(a);
  }
  drawMouseTail(t) {
    if (!this.mouseTail)
      return;
    const { lineCap: s, lineWidth: r, strokeStyle: n, duration: o } = this.config.mouseTail === !0 ? js : Object.assign({}, js, this.config.mouseTail), a = () => {
      if (!this.mouseTail)
        return;
      const i = this.mouseTail.getContext("2d");
      !i || !this.tailPositions.length || (i.clearRect(0, 0, this.mouseTail.width, this.mouseTail.height), i.beginPath(), i.lineWidth = r, i.lineCap = s, i.strokeStyle = n, i.moveTo(this.tailPositions[0].x, this.tailPositions[0].y), this.tailPositions.forEach((l) => i.lineTo(l.x, l.y)), i.stroke());
    };
    this.tailPositions.push(t), a(), setTimeout(() => {
      this.tailPositions = this.tailPositions.filter((i) => i !== t), a();
    }, o / this.speedService.state.context.timer.speed);
  }
  hoverElements(t) {
    var s;
    (s = this.lastHoveredRootNode || this.iframe.contentDocument) == null || s.querySelectorAll(".\\:hover").forEach((n) => {
      n.classList.remove(":hover");
    }), this.lastHoveredRootNode = t.getRootNode();
    let r = t;
    for (; r; )
      r.classList && r.classList.add(":hover"), r = r.parentElement;
  }
  isUserInteraction(t) {
    return t.type !== Q.IncrementalSnapshot ? !1 : t.data.source > U.Mutation && t.data.source <= U.Input;
  }
  backToNormal() {
    this.nextUserInteractionEvent = null, !this.speedService.state.matches("normal") && (this.speedService.send({ type: "BACK_TO_NORMAL" }), this.emitter.emit(F.SkipEnd, {
      speed: this.speedService.state.context.normalSpeed
    }));
  }
  warnNodeNotFound(t, s) {
    this.warn(`Node with id '${s}' not found. `, t);
  }
  warnCanvasMutationFailed(t, s) {
    this.warn("Has error on canvas update", s, "canvas mutation:", t);
  }
  debugNodeNotFound(t, s) {
    this.debug(`Node with id '${s}' not found. `, t);
  }
  warn(...t) {
    this.config.showWarning && this.config.logger.warn(li, ...t);
  }
  debug(...t) {
    this.config.showDebug && this.config.logger.log(li, ...t);
  }
}
var rn = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e[e.Device = 24] = "Device", e[e.SailfishCustom = 25] = "SailfishCustom", e))(rn || {}), Mr = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e[e.Typing = 17] = "Typing", e))(Mr || {});
function ui(e) {
  let t = "";
  return Object.keys(e).forEach((s) => {
    t += `${s}: ${e[s]};`;
  }), t;
}
function ct(e, t = 2) {
  let s = String(e);
  const r = Math.pow(10, t - 1);
  if (e < r)
    for (; String(r).length > s.length; )
      s = `0${e}`;
  return s;
}
const ka = 1e3, Nr = 60 * ka, hi = 60 * Nr;
function Ht(e) {
  if (e <= 0)
    return "00:00";
  const t = Math.floor(e / hi);
  e = e % hi;
  const s = Math.floor(e / Nr);
  e = e % Nr;
  const r = Math.floor(e / ka);
  return t ? `${ct(t)}:${ct(s)}:${ct(r)}` : `${ct(s)}:${ct(r)}`;
}
function $p(e) {
  return e.requestFullscreen ? e.requestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.msRequestFullscreen ? e.msRequestFullscreen() : Promise.resolve();
}
function ed() {
  return document.exitFullscreen ? document.exitFullscreen() : document.mozExitFullscreen ? document.mozExitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen ? document.msExitFullscreen() : Promise.resolve();
}
function pi() {
  let e = !1;
  return [
    "fullscreen",
    "webkitIsFullScreen",
    "mozFullScreen",
    "msFullscreenElement"
  ].forEach((t) => {
    t in document && (e = e || !!document[t]);
  }), e;
}
function td(e) {
  return document.addEventListener("fullscreenchange", e), document.addEventListener("webkitfullscreenchange", e), document.addEventListener("mozfullscreenchange", e), document.addEventListener("MSFullscreenChange", e), () => {
    document.removeEventListener("fullscreenchange", e), document.removeEventListener("webkitfullscreenchange", e), document.removeEventListener("mozfullscreenchange", e), document.removeEventListener("MSFullscreenChange", e);
  };
}
function di(e) {
  return {
    "[object Boolean]": "boolean",
    "[object Number]": "number",
    "[object String]": "string",
    "[object Function]": "function",
    "[object Array]": "array",
    "[object Date]": "date",
    "[object RegExp]": "regExp",
    "[object Undefined]": "undefined",
    "[object Null]": "null",
    "[object Object]": "object"
  }[Object.prototype.toString.call(e)];
}
function sd(e) {
  return e.type !== rn.IncrementalSnapshot ? !1 : e.data.source > Mr.Mutation && e.data.source <= Mr.Input;
}
function Ma(e, t) {
  const s = [];
  let r = e[0].timestamp;
  for (const n of e)
    sd(n) && (n.timestamp - r > t && s.push([r, n.timestamp]), r = n.timestamp);
  return s;
}
function rd(e) {
  let t, s, r, n, o, a, i, l, c;
  return {
    c() {
      t = te("div"), s = te("input"), r = ue(), n = te("label"), o = ue(), a = te("span"), i = Ie(
        /*label*/
        e[3]
      ), N(s, "type", "checkbox"), N(
        s,
        "id",
        /*id*/
        e[2]
      ), s.disabled = /*disabled*/
      e[1], N(s, "class", "svelte-a6h7w7"), N(
        n,
        "for",
        /*id*/
        e[2]
      ), N(n, "class", "svelte-a6h7w7"), N(a, "class", "label svelte-a6h7w7"), N(t, "class", "switch svelte-a6h7w7"), Ge(
        t,
        "disabled",
        /*disabled*/
        e[1]
      );
    },
    m(u, h) {
      Me(u, t, h), L(t, s), s.checked = /*checked*/
      e[0], L(t, r), L(t, n), L(t, o), L(t, a), L(a, i), l || (c = We(
        s,
        "change",
        /*input_change_handler*/
        e[4]
      ), l = !0);
    },
    p(u, [h]) {
      h & /*id*/
      4 && N(
        s,
        "id",
        /*id*/
        u[2]
      ), h & /*disabled*/
      2 && (s.disabled = /*disabled*/
      u[1]), h & /*checked*/
      1 && (s.checked = /*checked*/
      u[0]), h & /*id*/
      4 && N(
        n,
        "for",
        /*id*/
        u[2]
      ), h & /*label*/
      8 && ts(
        i,
        /*label*/
        u[3]
      ), h & /*disabled*/
      2 && Ge(
        t,
        "disabled",
        /*disabled*/
        u[1]
      );
    },
    i: mt,
    o: mt,
    d(u) {
      u && xe(t), l = !1, c();
    }
  };
}
function nd(e, t, s) {
  let { disabled: r } = t, { checked: n } = t, { id: o } = t, { label: a } = t;
  function i() {
    n = this.checked, s(0, n);
  }
  return e.$$set = (l) => {
    "disabled" in l && s(1, r = l.disabled), "checked" in l && s(0, n = l.checked), "id" in l && s(2, o = l.id), "label" in l && s(3, a = l.label);
  }, [n, r, o, a, i];
}
class id extends Ar {
  constructor(t) {
    super(), Or(this, t, nd, rd, Tr, { disabled: 1, checked: 0, id: 2, label: 3 });
  }
}
function fi(e, t, s) {
  const r = e.slice();
  return r[38] = t[s], r;
}
function mi(e, t, s) {
  const r = e.slice();
  return r[41] = t[s], r;
}
function gi(e, t, s) {
  const r = e.slice();
  return r[44] = t[s], r;
}
function yi(e) {
  let t, s, r, n = Ht(
    /*currentTime*/
    e[7]
  ) + "", o, a, i, l, c, u, h, p, y, g, d = Ht(
    /*meta*/
    e[9].totalTime
  ) + "", S, f, v, w, k, E, A, _, Y, q, j, se, oe, re = Le(
    /*inactivePeriods*/
    e[2]
  ), P = [];
  for (let x = 0; x < re.length; x += 1)
    P[x] = wi(gi(e, re, x));
  let ne = Le(
    /*customEvents*/
    e[10]
  ), V = [];
  for (let x = 0; x < ne.length; x += 1)
    V[x] = vi(mi(e, ne, x));
  function G(x, b) {
    return (
      /*playerState*/
      x[8] === "playing" ? ad : od
    );
  }
  let ae = G(e), ie = ae(e), $ = Le(
    /*speedOption*/
    e[4]
  ), J = [];
  for (let x = 0; x < $.length; x += 1)
    J[x] = bi(fi(e, $, x));
  function pe(x) {
    e[29](x);
  }
  let ge = {
    id: "skip",
    disabled: (
      /*speedState*/
      e[11] === "skipping"
    ),
    label: "skip inactive"
  };
  return (
    /*skipInactive*/
    e[0] !== void 0 && (ge.checked = /*skipInactive*/
    e[0]), A = new id({ props: ge }), Ae.push(() => Ya(A, "checked", pe)), {
      c() {
        t = te("div"), s = te("div"), r = te("span"), o = Ie(n), a = ue(), i = te("div"), l = te("div"), c = ue();
        for (let x = 0; x < P.length; x += 1)
          P[x].c();
        u = ue();
        for (let x = 0; x < V.length; x += 1)
          V[x].c();
        h = ue(), p = te("div"), y = ue(), g = te("span"), S = Ie(d), f = ue(), v = te("div"), w = te("button"), ie.c(), k = ue();
        for (let x = 0; x < J.length; x += 1)
          J[x].c();
        E = ue(), Oi(A.$$.fragment), Y = ue(), q = te("button"), q.innerHTML = `<svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16"><defs><style type="text/css"></style></defs><path d="M916 380c-26.4 0-48-21.6-48-48L868 223.2 613.6 477.6c-18.4
            18.4-48.8 18.4-68 0-18.4-18.4-18.4-48.8 0-68L800 156 692 156c-26.4
            0-48-21.6-48-48 0-26.4 21.6-48 48-48l224 0c26.4 0 48 21.6 48 48l0
            224C964 358.4 942.4 380 916 380zM231.2 860l108.8 0c26.4 0 48 21.6 48
            48s-21.6 48-48 48l-224 0c-26.4 0-48-21.6-48-48l0-224c0-26.4 21.6-48
            48-48 26.4 0 48 21.6 48 48L164 792l253.6-253.6c18.4-18.4 48.8-18.4
            68 0 18.4 18.4 18.4 48.8 0 68L231.2 860z"></path></svg>`, N(r, "class", "rr-timeline__time svelte-189zk2r"), N(l, "class", "rr-progress__step svelte-189zk2r"), K(
          l,
          "width",
          /*percentage*/
          e[13]
        ), N(p, "class", "rr-progress__handler svelte-189zk2r"), K(
          p,
          "left",
          /*percentage*/
          e[13]
        ), N(i, "class", "rr-progress svelte-189zk2r"), Ge(
          i,
          "disabled",
          /*speedState*/
          e[11] === "skipping"
        ), N(g, "class", "rr-timeline__time svelte-189zk2r"), N(s, "class", "rr-timeline svelte-189zk2r"), N(w, "class", "svelte-189zk2r"), N(q, "class", "svelte-189zk2r"), N(v, "class", "rr-controller__btns svelte-189zk2r"), N(t, "class", "rr-controller svelte-189zk2r");
      },
      m(x, b) {
        Me(x, t, b), L(t, s), L(s, r), L(r, o), L(s, a), L(s, i), L(i, l), L(i, c);
        for (let T = 0; T < P.length; T += 1)
          P[T] && P[T].m(i, null);
        L(i, u);
        for (let T = 0; T < V.length; T += 1)
          V[T] && V[T].m(i, null);
        L(i, h), L(i, p), e[27](i), L(s, y), L(s, g), L(g, S), L(t, f), L(t, v), L(v, w), ie.m(w, null), L(v, k);
        for (let T = 0; T < J.length; T += 1)
          J[T] && J[T].m(v, null);
        L(v, E), Dr(A, v, null), L(v, Y), L(v, q), j = !0, se || (oe = [
          We(
            i,
            "click",
            /*handleProgressClick*/
            e[15]
          ),
          We(
            i,
            "keydown",
            /*handleProgressKeydown*/
            e[16]
          ),
          We(
            w,
            "click",
            /*toggle*/
            e[5]
          ),
          We(
            q,
            "click",
            /*click_handler_1*/
            e[30]
          )
        ], se = !0);
      },
      p(x, b) {
        if ((!j || b[0] & /*currentTime*/
        128) && n !== (n = Ht(
          /*currentTime*/
          x[7]
        ) + "") && ts(o, n), (!j || b[0] & /*percentage*/
        8192) && K(
          l,
          "width",
          /*percentage*/
          x[13]
        ), b[0] & /*inactivePeriods*/
        4) {
          re = Le(
            /*inactivePeriods*/
            x[2]
          );
          let m;
          for (m = 0; m < re.length; m += 1) {
            const I = gi(x, re, m);
            P[m] ? P[m].p(I, b) : (P[m] = wi(I), P[m].c(), P[m].m(i, u));
          }
          for (; m < P.length; m += 1)
            P[m].d(1);
          P.length = re.length;
        }
        if (b[0] & /*customEvents*/
        1024) {
          ne = Le(
            /*customEvents*/
            x[10]
          );
          let m;
          for (m = 0; m < ne.length; m += 1) {
            const I = mi(x, ne, m);
            V[m] ? V[m].p(I, b) : (V[m] = vi(I), V[m].c(), V[m].m(i, h));
          }
          for (; m < V.length; m += 1)
            V[m].d(1);
          V.length = ne.length;
        }
        if ((!j || b[0] & /*percentage*/
        8192) && K(
          p,
          "left",
          /*percentage*/
          x[13]
        ), (!j || b[0] & /*speedState*/
        2048) && Ge(
          i,
          "disabled",
          /*speedState*/
          x[11] === "skipping"
        ), (!j || b[0] & /*meta*/
        512) && d !== (d = Ht(
          /*meta*/
          x[9].totalTime
        ) + "") && ts(S, d), ae !== (ae = G(x)) && (ie.d(1), ie = ae(x), ie && (ie.c(), ie.m(w, null))), b[0] & /*speedState, speedOption, speed, setSpeed*/
        2130) {
          $ = Le(
            /*speedOption*/
            x[4]
          );
          let m;
          for (m = 0; m < $.length; m += 1) {
            const I = fi(x, $, m);
            J[m] ? J[m].p(I, b) : (J[m] = bi(I), J[m].c(), J[m].m(v, E));
          }
          for (; m < J.length; m += 1)
            J[m].d(1);
          J.length = $.length;
        }
        const T = {};
        b[0] & /*speedState*/
        2048 && (T.disabled = /*speedState*/
        x[11] === "skipping"), !_ && b[0] & /*skipInactive*/
        1 && (_ = !0, T.checked = /*skipInactive*/
        x[0], ja(() => _ = !1)), A.$set(T);
      },
      i(x) {
        j || (Ce(A.$$.fragment, x), j = !0);
      },
      o(x) {
        Ze(A.$$.fragment, x), j = !1;
      },
      d(x) {
        x && xe(t), Ns(P, x), Ns(V, x), e[27](null), ie.d(), Ns(J, x), Rr(A), se = !1, $e(oe);
      }
    }
  );
}
function wi(e) {
  let t, s;
  return {
    c() {
      t = te("div"), N(t, "title", s = /*period*/
      e[44].name), K(
        t,
        "width",
        /*period*/
        e[44].width
      ), K(t, "height", "4px"), K(t, "position", "absolute"), K(
        t,
        "background",
        /*period*/
        e[44].background
      ), K(
        t,
        "left",
        /*period*/
        e[44].position
      );
    },
    m(r, n) {
      Me(r, t, n);
    },
    p(r, n) {
      n[0] & /*inactivePeriods*/
      4 && s !== (s = /*period*/
      r[44].name) && N(t, "title", s), n[0] & /*inactivePeriods*/
      4 && K(
        t,
        "width",
        /*period*/
        r[44].width
      ), n[0] & /*inactivePeriods*/
      4 && K(
        t,
        "background",
        /*period*/
        r[44].background
      ), n[0] & /*inactivePeriods*/
      4 && K(
        t,
        "left",
        /*period*/
        r[44].position
      );
    },
    d(r) {
      r && xe(t);
    }
  };
}
function vi(e) {
  let t, s;
  return {
    c() {
      t = te("div"), N(t, "title", s = /*event*/
      e[41].name), K(t, "width", "10px"), K(t, "height", "5px"), K(t, "position", "absolute"), K(t, "top", "2px"), K(t, "transform", "translate(-50%, -50%)"), K(
        t,
        "background",
        /*event*/
        e[41].background
      ), K(
        t,
        "left",
        /*event*/
        e[41].position
      );
    },
    m(r, n) {
      Me(r, t, n);
    },
    p(r, n) {
      n[0] & /*customEvents*/
      1024 && s !== (s = /*event*/
      r[41].name) && N(t, "title", s), n[0] & /*customEvents*/
      1024 && K(
        t,
        "background",
        /*event*/
        r[41].background
      ), n[0] & /*customEvents*/
      1024 && K(
        t,
        "left",
        /*event*/
        r[41].position
      );
    },
    d(r) {
      r && xe(t);
    }
  };
}
function od(e) {
  let t, s;
  return {
    c() {
      t = es("svg"), s = es("path"), N(s, "d", `M170.65984 896l0-768 640 384zM644.66944
              512l-388.66944-233.32864 0 466.65728z`), N(t, "class", "icon"), N(t, "viewBox", "0 0 1024 1024"), N(t, "version", "1.1"), N(t, "xmlns", "http://www.w3.org/2000/svg"), N(t, "xmlns:xlink", "http://www.w3.org/1999/xlink"), N(t, "width", "16"), N(t, "height", "16");
    },
    m(r, n) {
      Me(r, t, n), L(t, s);
    },
    d(r) {
      r && xe(t);
    }
  };
}
function ad(e) {
  let t, s;
  return {
    c() {
      t = es("svg"), s = es("path"), N(s, "d", `M682.65984 128q53.00224 0 90.50112 37.49888t37.49888 90.50112l0
              512q0 53.00224-37.49888 90.50112t-90.50112
              37.49888-90.50112-37.49888-37.49888-90.50112l0-512q0-53.00224
              37.49888-90.50112t90.50112-37.49888zM341.34016 128q53.00224 0
              90.50112 37.49888t37.49888 90.50112l0 512q0 53.00224-37.49888
              90.50112t-90.50112
              37.49888-90.50112-37.49888-37.49888-90.50112l0-512q0-53.00224
              37.49888-90.50112t90.50112-37.49888zM341.34016 213.34016q-17.67424
              0-30.16704 12.4928t-12.4928 30.16704l0 512q0 17.67424 12.4928
              30.16704t30.16704 12.4928 30.16704-12.4928
              12.4928-30.16704l0-512q0-17.67424-12.4928-30.16704t-30.16704-12.4928zM682.65984
              213.34016q-17.67424 0-30.16704 12.4928t-12.4928 30.16704l0 512q0
              17.67424 12.4928 30.16704t30.16704 12.4928 30.16704-12.4928
              12.4928-30.16704l0-512q0-17.67424-12.4928-30.16704t-30.16704-12.4928z`), N(t, "class", "icon"), N(t, "viewBox", "0 0 1024 1024"), N(t, "version", "1.1"), N(t, "xmlns", "http://www.w3.org/2000/svg"), N(t, "xmlns:xlink", "http://www.w3.org/1999/xlink"), N(t, "width", "16"), N(t, "height", "16");
    },
    m(r, n) {
      Me(r, t, n), L(t, s);
    },
    d(r) {
      r && xe(t);
    }
  };
}
function bi(e) {
  let t, s = (
    /*s*/
    e[38] + ""
  ), r, n, o, a, i;
  function l() {
    return (
      /*click_handler*/
      e[28](
        /*s*/
        e[38]
      )
    );
  }
  return {
    c() {
      t = te("button"), r = Ie(s), n = Ie("x"), t.disabled = o = /*speedState*/
      e[11] === "skipping", N(t, "class", "svelte-189zk2r"), Ge(
        t,
        "active",
        /*s*/
        e[38] === /*speed*/
        e[1] && /*speedState*/
        e[11] !== "skipping"
      );
    },
    m(c, u) {
      Me(c, t, u), L(t, r), L(t, n), a || (i = We(t, "click", l), a = !0);
    },
    p(c, u) {
      e = c, u[0] & /*speedOption*/
      16 && s !== (s = /*s*/
      e[38] + "") && ts(r, s), u[0] & /*speedState*/
      2048 && o !== (o = /*speedState*/
      e[11] === "skipping") && (t.disabled = o), u[0] & /*speedOption, speed, speedState*/
      2066 && Ge(
        t,
        "active",
        /*s*/
        e[38] === /*speed*/
        e[1] && /*speedState*/
        e[11] !== "skipping"
      );
    },
    d(c) {
      c && xe(t), a = !1, i();
    }
  };
}
function ld(e) {
  let t, s, r = (
    /*showController*/
    e[3] && yi(e)
  );
  return {
    c() {
      r && r.c(), t = Pa();
    },
    m(n, o) {
      r && r.m(n, o), Me(n, t, o), s = !0;
    },
    p(n, o) {
      /*showController*/
      n[3] ? r ? (r.p(n, o), o[0] & /*showController*/
      8 && Ce(r, 1)) : (r = yi(n), r.c(), Ce(r, 1), r.m(t.parentNode, t)) : r && (Di(), Ze(r, 1, 1, () => {
        r = null;
      }), Ri());
    },
    i(n) {
      s || (Ce(r), s = !0);
    },
    o(n) {
      Ze(r), s = !1;
    },
    d(n) {
      n && xe(t), r && r.d(n);
    }
  };
}
function Si(e, t, s) {
  const r = t - e;
  return (100 - (t - s) / r * 100).toFixed(2);
}
function cd(e, t, s) {
  const r = Ua();
  let { replayer: n } = t, { showController: o } = t, { autoPlay: a } = t, { skipInactive: i } = t, { speedOption: l } = t, { speed: c = l.length ? l[0] : 1 } = t, { tags: u = {} } = t, { inactiveColor: h } = t, p = 0, y = null, g, d, S, f, v = !1, w = null, k = null, E, A, _, { inactivePeriods: Y } = t;
  const q = () => {
    j();
    function b() {
      s(7, p = n.getCurrentTime()), v && p >= v && (k ? ne(k.start, k.end, !0, void 0) : (n.pause(), w && (w(), w = null))), p < E.totalTime && (y = requestAnimationFrame(b));
    }
    y = requestAnimationFrame(b);
  }, j = () => {
    y && (cancelAnimationFrame(y), y = null);
  }, se = () => {
    switch (g) {
      case "playing":
        re();
        break;
      case "paused":
        oe();
        break;
    }
  }, oe = () => {
    g === "paused" && (f ? (n.play(), f = !1) : n.play(p));
  }, re = () => {
    g === "playing" && (n.pause(), v = !1);
  }, P = (b, T) => {
    n.backToNormal(), s(7, p = b), v = !1, f = !1, (typeof T == "boolean" ? T : g === "playing") ? n.play(b) : n.pause(b);
  }, ne = (b, T, m = !1, I = void 0) => {
    m ? k = { start: b, end: T } : k = null, s(7, p = b), v = T, w = I || null, n.play(b);
  }, V = (b) => {
    if (d === "skipping")
      return;
    const T = S.getBoundingClientRect();
    let I = (b.clientX - T.left) / T.width;
    I < 0 ? I = 0 : I > 1 && (I = 1);
    const ce = E.totalTime * I;
    P(ce);
  }, G = (b) => {
    d !== "skipping" && (b.key === "ArrowLeft" ? P(p - 5) : b.key === "ArrowRight" && P(p + 5));
  }, ae = (b) => {
    let T = g === "playing";
    s(1, c = b), T && n.pause(), n.setConfig({ speed: c }), T && n.play(p);
  }, ie = () => {
    s(0, i = !i);
  }, $ = () => Promise.resolve().then(() => {
    s(9, E = n.getMetaData());
  });
  Mi(() => {
    s(8, g = n.service.state.value), s(11, d = n.speedService.state.value), n.on("state-change", (b) => {
      const { player: T, speed: m } = b;
      if (T != null && T.value && g !== T.value)
        switch (s(8, g = T.value), g) {
          case "playing":
            q();
            break;
          case "paused":
            j();
            break;
        }
      m != null && m.value && d !== m.value && s(11, d = m.value);
    }), n.on("finish", () => {
      f = !0, w && (w(), w = null);
    }), a && n.play();
  }), La(() => {
    i !== n.config.skipInactive && n.setConfig({ skipInactive: i });
  }), Ni(() => {
    n.pause(), j();
  });
  function J(b) {
    Ae[b ? "unshift" : "push"](() => {
      S = b, s(12, S);
    });
  }
  const pe = (b) => ae(b);
  function ge(b) {
    i = b, s(0, i);
  }
  const x = () => r("fullscreen");
  return e.$$set = (b) => {
    "replayer" in b && s(17, n = b.replayer), "showController" in b && s(3, o = b.showController), "autoPlay" in b && s(18, a = b.autoPlay), "skipInactive" in b && s(0, i = b.skipInactive), "speedOption" in b && s(4, l = b.speedOption), "speed" in b && s(1, c = b.speed), "tags" in b && s(19, u = b.tags), "inactiveColor" in b && s(20, h = b.inactiveColor), "inactivePeriods" in b && s(2, Y = b.inactivePeriods);
  }, e.$$.update = () => {
    if (e.$$.dirty[0] & /*currentTime*/
    128 && r("ui-update-current-time", { payload: p }), e.$$.dirty[0] & /*playerState*/
    256 && r("ui-update-player-state", { payload: g }), e.$$.dirty[0] & /*replayer*/
    131072 && s(9, E = n.getMetaData()), e.$$.dirty[0] & /*currentTime, meta*/
    640) {
      const b = Math.min(1, p / E.totalTime);
      s(13, A = `${100 * b}%`), r("ui-update-progress", { payload: b });
    }
    e.$$.dirty[0] & /*replayer, tags*/
    655360 && s(10, _ = (() => {
      const { context: b } = n.service.state, T = b.events.length, m = b.events[0].timestamp, I = b.events[T - 1].timestamp, ce = [];
      return b.events.forEach((ye) => {
        if (ye.type === rn.Custom) {
          const we = {
            name: ye.data.tag,
            background: u[ye.data.tag] || "rgb(73, 80, 246)",
            position: `${Si(m, I, ye.timestamp)}%`
          };
          ce.push(we);
        }
      }), ce;
    })()), e.$$.dirty[0] & /*replayer, inactiveColor*/
    1179648 && s(2, Y = (() => {
      try {
        const { context: b } = n.service.state, T = b.events.length, m = b.events[0].timestamp, I = b.events[T - 1].timestamp, ce = Ma(b.events, n.config.inactivePeriodThreshold), ye = (we, Na, Ta, Da) => {
          const Ra = Na - we;
          return ((Da - Ta) / Ra * 100).toFixed(2);
        };
        return ce.map((we) => ({
          name: "inactive period",
          background: h,
          position: `${Si(m, I, we[0])}%`,
          width: `${ye(m, I, we[0], we[1])}%`
        }));
      } catch {
        return [];
      }
    })());
  }, [
    i,
    c,
    Y,
    o,
    l,
    se,
    ae,
    p,
    g,
    E,
    _,
    d,
    S,
    A,
    r,
    V,
    G,
    n,
    a,
    u,
    h,
    oe,
    re,
    P,
    ne,
    ie,
    $,
    J,
    pe,
    ge,
    x
  ];
}
class ud extends Ar {
  constructor(t) {
    super(), Or(
      this,
      t,
      cd,
      ld,
      Tr,
      {
        replayer: 17,
        showController: 3,
        autoPlay: 18,
        skipInactive: 0,
        speedOption: 4,
        speed: 1,
        tags: 19,
        inactiveColor: 20,
        inactivePeriods: 2,
        toggle: 5,
        play: 21,
        pause: 22,
        goto: 23,
        playRange: 24,
        setSpeed: 6,
        toggleSkipInactive: 25,
        triggerUpdateMeta: 26
      },
      null,
      [-1, -1]
    );
  }
  get toggle() {
    return this.$$.ctx[5];
  }
  get play() {
    return this.$$.ctx[21];
  }
  get pause() {
    return this.$$.ctx[22];
  }
  get goto() {
    return this.$$.ctx[23];
  }
  get playRange() {
    return this.$$.ctx[24];
  }
  get setSpeed() {
    return this.$$.ctx[6];
  }
  get toggleSkipInactive() {
    return this.$$.ctx[25];
  }
  get triggerUpdateMeta() {
    return this.$$.ctx[26];
  }
}
function xi(e) {
  let t, s, r = {
    replayer: (
      /*replayer*/
      e[7]
    ),
    showController: (
      /*showController*/
      e[3]
    ),
    autoPlay: (
      /*autoPlay*/
      e[1]
    ),
    speedOption: (
      /*speedOption*/
      e[2]
    ),
    skipInactive: (
      /*skipInactive*/
      e[0]
    ),
    tags: (
      /*tags*/
      e[4]
    ),
    inactiveColor: (
      /*inactiveColor*/
      e[5]
    )
  };
  return t = new ud({ props: r }), e[33](t), t.$on(
    "fullscreen",
    /*fullscreen_handler*/
    e[34]
  ), {
    c() {
      Oi(t.$$.fragment);
    },
    m(n, o) {
      Dr(t, n, o), s = !0;
    },
    p(n, o) {
      const a = {};
      o[0] & /*replayer*/
      128 && (a.replayer = /*replayer*/
      n[7]), o[0] & /*showController*/
      8 && (a.showController = /*showController*/
      n[3]), o[0] & /*autoPlay*/
      2 && (a.autoPlay = /*autoPlay*/
      n[1]), o[0] & /*speedOption*/
      4 && (a.speedOption = /*speedOption*/
      n[2]), o[0] & /*skipInactive*/
      1 && (a.skipInactive = /*skipInactive*/
      n[0]), o[0] & /*tags*/
      16 && (a.tags = /*tags*/
      n[4]), o[0] & /*inactiveColor*/
      32 && (a.inactiveColor = /*inactiveColor*/
      n[5]), t.$set(a);
    },
    i(n) {
      s || (Ce(t.$$.fragment, n), s = !0);
    },
    o(n) {
      Ze(t.$$.fragment, n), s = !1;
    },
    d(n) {
      e[33](null), Rr(t, n);
    }
  };
}
function hd(e) {
  let t, s, r, n, o = (
    /*replayer*/
    e[7] && xi(e)
  );
  return {
    c() {
      t = te("div"), s = te("div"), r = ue(), o && o.c(), N(s, "class", "rr-player__frame"), N(
        s,
        "style",
        /*style*/
        e[11]
      ), N(t, "class", "rr-player"), N(
        t,
        "style",
        /*playerStyle*/
        e[12]
      );
    },
    m(a, i) {
      Me(a, t, i), L(t, s), e[32](s), L(t, r), o && o.m(t, null), e[35](t), n = !0;
    },
    p(a, i) {
      (!n || i[0] & /*style*/
      2048) && N(
        s,
        "style",
        /*style*/
        a[11]
      ), /*replayer*/
      a[7] ? o ? (o.p(a, i), i[0] & /*replayer*/
      128 && Ce(o, 1)) : (o = xi(a), o.c(), Ce(o, 1), o.m(t, null)) : o && (Di(), Ze(o, 1, 1, () => {
        o = null;
      }), Ri()), (!n || i[0] & /*playerStyle*/
      4096) && N(
        t,
        "style",
        /*playerStyle*/
        a[12]
      );
    },
    i(a) {
      n || (Ce(o), n = !0);
    },
    o(a) {
      Ze(o), n = !1;
    },
    d(a) {
      a && xe(t), e[32](null), o && o.d(), e[35](null);
    }
  };
}
const Ci = 80;
function pd(e, t, s) {
  let { width: r = 1024 } = t, { height: n = 576 } = t, { maxScale: o = 1 } = t, { events: a } = t, { skipInactive: i = !0 } = t, { autoPlay: l = !0 } = t, { speedOption: c = [1, 2, 4, 8] } = t, { speed: u = 1 } = t, { showController: h = !0 } = t, { tags: p = {} } = t, { inactiveColor: y = "#D4D4D4" } = t, g;
  const d = () => g.getMirror();
  let S, f, v, w = r, k = n, E, A, _;
  const Y = (m, I) => {
    const ce = r / I.width, ye = n / I.height, we = [ce, ye];
    o && we.push(o), m.style.transform = `scale(${Math.min(...we)})translate(-50%, -50%)`;
  }, q = () => {
    Y(g.wrapper, {
      width: g.iframe.offsetWidth,
      height: g.iframe.offsetHeight
    });
  }, j = () => {
    const m = g.service.state.context;
    return Ma(m.events, g.config.inactivePeriodThreshold);
  }, se = () => {
    S && (pi() ? ed() : $p(S));
  }, oe = (m, I) => {
    switch (g.on(m, I), m) {
      case "ui-update-current-time":
      case "ui-update-progress":
      case "ui-update-player-state":
        E.$on(m, ({ detail: ce }) => I(ce));
    }
  }, re = (m) => {
    g.addEvent(m), E.triggerUpdateMeta();
  }, P = () => g.getMetaData(), ne = () => g, V = () => {
    E.toggle();
  }, G = (m) => {
    E.setSpeed(m);
  }, ae = () => {
    E.toggleSkipInactive();
  }, ie = () => {
    E.play();
  }, $ = () => {
    E.pause();
  }, J = (m, I) => {
    E.goto(m, I);
  }, pe = (m, I, ce = !1, ye = void 0) => {
    E.playRange(m, I, ce, ye);
  };
  Mi(() => {
    if (c !== void 0 && di(c) !== "array")
      throw new Error("speedOption must be array");
    if (c.forEach((m) => {
      if (di(m) !== "number")
        throw new Error("item of speedOption must be number");
    }), c.indexOf(u) < 0)
      throw new Error(`speed must be one of speedOption,
        current config:
        {
          ...
          speed: ${u},
          speedOption: [${c.toString()}]
          ...
        }
        `);
    s(7, g = new qp(
      a,
      {
        speed: u,
        root: f,
        unpackFn: il,
        ...t
      }
    )), g.on("resize", (m) => {
      Y(g.wrapper, m);
    }), v = td(() => {
      pi() ? setTimeout(
        () => {
          w = r, k = n, s(13, r = S.offsetWidth), s(14, n = S.offsetHeight - (h ? Ci : 0)), Y(g.wrapper, {
            width: g.iframe.offsetWidth,
            height: g.iframe.offsetHeight
          });
        },
        0
      ) : (s(13, r = w), s(14, n = k), Y(g.wrapper, {
        width: g.iframe.offsetWidth,
        height: g.iframe.offsetHeight
      }));
    });
  }), Ni(() => {
    v && v();
  });
  function ge(m) {
    Ae[m ? "unshift" : "push"](() => {
      f = m, s(9, f);
    });
  }
  function x(m) {
    Ae[m ? "unshift" : "push"](() => {
      E = m, s(10, E);
    });
  }
  const b = () => se();
  function T(m) {
    Ae[m ? "unshift" : "push"](() => {
      S = m, s(8, S);
    });
  }
  return e.$$set = (m) => {
    s(40, t = nn(nn({}, t), an(m))), "width" in m && s(13, r = m.width), "height" in m && s(14, n = m.height), "maxScale" in m && s(15, o = m.maxScale), "events" in m && s(16, a = m.events), "skipInactive" in m && s(0, i = m.skipInactive), "autoPlay" in m && s(1, l = m.autoPlay), "speedOption" in m && s(2, c = m.speedOption), "speed" in m && s(17, u = m.speed), "showController" in m && s(3, h = m.showController), "tags" in m && s(4, p = m.tags), "inactiveColor" in m && s(5, y = m.inactiveColor);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*width, height*/
    24576 && s(11, A = ui({
      width: `${r}px`,
      height: `${n}px`
    })), e.$$.dirty[0] & /*width, height, showController*/
    24584 && s(12, _ = ui({
      width: `${r}px`,
      height: `${n + (h ? Ci : 0)}px`
    }));
  }, t = an(t), [
    i,
    l,
    c,
    h,
    p,
    y,
    se,
    g,
    S,
    f,
    E,
    A,
    _,
    r,
    n,
    o,
    a,
    u,
    d,
    q,
    j,
    oe,
    re,
    P,
    ne,
    V,
    G,
    ae,
    ie,
    $,
    J,
    pe,
    ge,
    x,
    b,
    T
  ];
}
let dd = class extends Ar {
  constructor(t) {
    super(), Or(
      this,
      t,
      pd,
      hd,
      Tr,
      {
        width: 13,
        height: 14,
        maxScale: 15,
        events: 16,
        skipInactive: 0,
        autoPlay: 1,
        speedOption: 2,
        speed: 17,
        showController: 3,
        tags: 4,
        inactiveColor: 5,
        getMirror: 18,
        triggerResize: 19,
        inactivePeriods: 20,
        toggleFullscreen: 6,
        addEventListener: 21,
        addEvent: 22,
        getMetaData: 23,
        getReplayer: 24,
        toggle: 25,
        setSpeed: 26,
        toggleSkipInactive: 27,
        play: 28,
        pause: 29,
        goto: 30,
        playRange: 31
      },
      null,
      [-1, -1]
    );
  }
  get getMirror() {
    return this.$$.ctx[18];
  }
  get triggerResize() {
    return this.$$.ctx[19];
  }
  get inactivePeriods() {
    return this.$$.ctx[20];
  }
  get toggleFullscreen() {
    return this.$$.ctx[6];
  }
  get addEventListener() {
    return this.$$.ctx[21];
  }
  get addEvent() {
    return this.$$.ctx[22];
  }
  get getMetaData() {
    return this.$$.ctx[23];
  }
  get getReplayer() {
    return this.$$.ctx[24];
  }
  get toggle() {
    return this.$$.ctx[25];
  }
  get setSpeed() {
    return this.$$.ctx[26];
  }
  get toggleSkipInactive() {
    return this.$$.ctx[27];
  }
  get play() {
    return this.$$.ctx[28];
  }
  get pause() {
    return this.$$.ctx[29];
  }
  get goto() {
    return this.$$.ctx[30];
  }
  get playRange() {
    return this.$$.ctx[31];
  }
};
class wd extends dd {
  constructor(t) {
    super({
      target: t.target,
      props: t.data || t.props
    });
  }
}
export {
  wd as Player,
  wd as default
};
//# sourceMappingURL=rrweb-player.js.map
